/* 
	 IMPORTANT NOTE:
	 
	 This file is the unminified JS that is used by the theme. This file is therefore not included into the "theme.liquid" Liquid. It is bundled only
	 for developers who would like to add their own JavaScript or edit the existing JavaScript. Re-minifying the file and make sure you include it into the "theme.liquid" is up to the developers responsibility.
	 
	 Because we are using WebPack internally to bundle our JavaScript code, even the unminified file can be quite hard to read or edit due to all the
	 code added by WebPack.
	 
	 Please note that we do not provide any assistance for changes made here that may break the theme: it's at your own risk :).
*/

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}
function setGetParam(key,value) {
	if (history.pushState) {
		var params = new URLSearchParams(window.location.search);
		params.set(key, value);
		var newUrl = window.location.origin 
					+ window.location.pathname 
					+ '?' + params.toString();
		window.history.pushState({path:newUrl},'',newUrl);
	}
}
function deleteParam(key) {
	if (history.pushState) {
		var params = new URLSearchParams(window.location.search);
		params.delete(key);
		var newUrl = window.location.origin 
					+ window.location.pathname 
					+ '?' + params.toString();
		window.history.pushState({path:newUrl},'',newUrl);
	}
}

/******/(function (modules) {
	// webpackBootstrap
	/******/ // The module cache
	/******/var installedModules = {};
	/******/
	/******/ // The require function
	/******/function __webpack_require__(moduleId) {
		/******/
		/******/ // Check if module is in cache
		/******/if (installedModules[moduleId]) {
			/******/return installedModules[moduleId].exports;
			/******/
		}
		/******/ // Create a new module (and put it into the cache)
		/******/var module = installedModules[moduleId] = {
			/******/i: moduleId,
			/******/l: false,
			/******/exports: {}
			/******/ };
		/******/
		/******/ // Execute the module function
		/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
		/******/
		/******/ // Flag the module as loaded
		/******/module.l = true;
		/******/
		/******/ // Return the exports of the module
		/******/return module.exports;
		/******/
	}
	/******/
	/******/
	/******/ // expose the modules object (__webpack_modules__)
	/******/__webpack_require__.m = modules;
	/******/
	/******/ // expose the module cache
	/******/__webpack_require__.c = installedModules;
	/******/
	/******/ // define getter function for harmony exports
	/******/__webpack_require__.d = function (exports, name, getter) {
		/******/if (!__webpack_require__.o(exports, name)) {
			/******/Object.defineProperty(exports, name, {
				/******/configurable: false,
				/******/enumerable: true,
				/******/get: getter
				/******/ });
			/******/
		}
		/******/
	};
	/******/
	/******/ // getDefaultExport function for compatibility with non-harmony modules
	/******/__webpack_require__.n = function (module) {
		/******/var getter = module && module.__esModule ?
		/******/function getDefault() {
			return module['default'];
		} :
		/******/function getModuleExports() {
			return module;
		};
		/******/__webpack_require__.d(getter, 'a', getter);
		/******/return getter;
		/******/
	};
	/******/
	/******/ // Object.prototype.hasOwnProperty.call
	/******/__webpack_require__.o = function (object, property) {
		return Object.prototype.hasOwnProperty.call(object, property);
	};
	/******/
	/******/ // __webpack_public_path__
	/******/__webpack_require__.p = "";
	/******/
	/******/ // Load entry module and return exports
	/******/return __webpack_require__(__webpack_require__.s = 77);
	/******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/**
	 * Various DOM helper
	 */

	var Dom = function () {
		function Dom() {
			_classCallCheck(this, Dom);
		}

		_createClass(Dom, null, [{
			key: 'getSiblings',

			/**
			 * Get all the previous and next siblings, optionally filtered by a selector
			 */
			value: function getSiblings(element, filter) {
				var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

				var siblings = [];
				var currentElement = element;
				// Do the previous first

				while (currentElement = currentElement.previousElementSibling) {
					if (!filter || currentElement.matches(filter)) {
						siblings.push(currentElement);
					}
				}

				if (includeSelf) {
					siblings.push(element);
				}

				// Then the next side
				currentElement = element;

				while (currentElement = currentElement.nextElementSibling) {
					if (!filter || currentElement.matches(filter)) {
						siblings.push(currentElement);
					}
				}

				return siblings;
			}

			/**
			 * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
			 * we need to normalize it
			 */

		}, {
			key: 'nodeListToArray',
			value: function nodeListToArray(nodeList, filter) {
				var items = [];

				for (var i = 0; i !== nodeList.length; ++i) {
					if (!filter || nodeList[i].matches(filter)) {
						items.push(nodeList[i]);
					}
				}

				return items;
			}

			/**
			 * Calculate an element width with its margin
			 */

		}, {
			key: 'outerWidthWithMargin',
			value: function outerWidthWithMargin(element) {
				var width = element.offsetWidth,
						style = getComputedStyle(element);

				width += parseInt(style.marginLeft) + parseInt(style.marginRight);

				return width;
			}

			/**
			 * Calculate an element height with its margin
			 */

		}, {
			key: 'outerHeightWithMargin',
			value: function outerHeightWithMargin(element) {
				var height = element.offsetHeight,
						style = getComputedStyle(element);

				height += parseInt(style.marginTop) + parseInt(style.marginBottom);

				return height;
			}
		}]);

		return Dom;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Dom;

	/***/
},
/* 1 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var Responsive = function () {
		function Responsive() {
			var _this = this;

			_classCallCheck(this, Responsive);

			this.currentBreakpoint = Responsive.getCurrentBreakpoint();

			window.addEventListener('resize', function () {
				var newBreakpoint = Responsive.getCurrentBreakpoint();

				if (_this.currentBreakpoint === newBreakpoint) {
					return;
				}

				document.dispatchEvent(new CustomEvent('breakpoint:changed', { detail: {
						previousBreakpoint: _this.currentBreakpoint,
						currentBreakpoint: newBreakpoint
					} }));

				_this.currentBreakpoint = newBreakpoint;
			});
		}

		_createClass(Responsive, null, [{
			key: 'matchesBreakpoint',
			value: function matchesBreakpoint(breakpoint) {
				switch (breakpoint) {
					case 'phone':
						return window.matchMedia('screen and (max-width: 640px)').matches;

					case 'tablet':
						return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

					case 'tablet-and-up':
						return window.matchMedia('screen and (min-width: 641px)').matches;
						
					case 'pocket':
						return window.matchMedia('screen and (max-width: 1007px)').matches;

					case 'lap':
						return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

					case 'lap-and-up':
						return window.matchMedia('screen and (min-width: 1008px)').matches;

					case 'desk':
						return window.matchMedia('screen and (min-width: 1280px)').matches;

					case 'widescreen':
						return window.matchMedia('screen and (min-width: 1600px)').matches;

					case 'supports-hover':
						return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
				}
			}
		}, {
			key: 'getCurrentBreakpoint',
			value: function getCurrentBreakpoint() {
				if (window.matchMedia('screen and (max-width: 640px)').matches) {
					return 'phone';
				}

				if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
					return 'tablet';
				}

				if (window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches) {
					return 'lap';
				}

				if (window.matchMedia('screen and (min-width: 1280px)').matches) {
					return 'desk';
				}
			}
		}]);

		return Responsive;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Responsive;

	/***/
},
/* 2 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Responsive__ = __webpack_require__(1);

	var Carousel = function () {
		function Carousel(element) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

			_classCallCheck(this, Carousel);

			this.element = element;
			this.initialConfig = Object.assign(JSON.parse(element.getAttribute('data-flickity-config')), overrideSettings);
			this.options = options;
			this._attachListeners();
			this._build();
		}

		_createClass(Carousel, [{
			key: 'destroy',
			value: function destroy() {
				this.flickityInstance.destroy();

				if (this.initialConfig['breakpoints'] !== undefined) {
					document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
				}
			}
		}, {
			key: 'getFlickityInstance',
			value: function getFlickityInstance() {
				return this.flickityInstance;
			}
		}, {
			key: 'selectCell',
			value: function selectCell(index) {
				var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
				var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

				if (shouldPause) {
					this.flickityInstance.pausePlayer();
				}

				this.flickityInstance.select(index, false, !shouldAnimate);
			}
		}, {
			key: 'next',
			value: function next() {
				this.flickityInstance.next();
			}
		}, {
			key: 'previous',
			value: function previous() {
				this.flickityInstance.previous();
			}
		}, {
			key: 'pausePlayer',
			value: function pausePlayer() {
				this.flickityInstance.pausePlayer();
			}
		}, {
			key: 'unpausePlayer',
			value: function unpausePlayer() {
				this.flickityInstance.unpausePlayer();
			}
		}, {
			key: 'resize',
			value: function resize() {
				this.flickityInstance.resize();
			}
		}, {
			key: 'getSelectedIndex',
			value: function getSelectedIndex() {
				return this.flickityInstance.selectedIndex;
			}
		}, {
			key: 'getSelectedCell',
			value: function getSelectedCell() {
				return this.flickityInstance.selectedCell.element;
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				if (this.initialConfig['breakpoints'] !== undefined) {
					this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
					document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
				}
			}

			/**
			 * Create the carousel instance
			 */

		}, {
			key: '_build',
			value: function _build() {
				var _this2 = this;

				var config = this._processConfig();

				this.flickityInstance = new Flickity(this.element, config);
				this._validateDraggable();

				this.selectedIndex = this.flickityInstance.selectedIndex;

				this.flickityInstance.on('resize', this._validateDraggable.bind(this));

				if (this.options['onSelect']) {
					this.flickityInstance.on('select', function () {
						// Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check
						// first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)

						if (_this2.selectedIndex !== _this2.flickityInstance.selectedIndex) {
							_this2.options['onSelect'](_this2.flickityInstance.selectedIndex, _this2.flickityInstance.selectedCell.element);
							_this2.selectedIndex = _this2.flickityInstance.selectedIndex;
						}
					});
				}

				if (this.options['onSettle']) {
					this.flickityInstance.on('settle', function (index) {
						_this2.options['onSettle'](index, _this2.flickityInstance.selectedCell.element);
					});
				}

				if (this.options['onClick']) {
					this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
						_this2.options['onClick'](cell, index);
					});
				}

			}

			/**
			 * By default, Flickity does not disable draggable automatically if there is nothing to slide. We therefore manually do the check here by checking
			 * if the displayed elements equals to the amount of elements
			 */

		}, {
			key: '_validateDraggable',
			value: function _validateDraggable() {
				var isActive = this.flickityInstance.isActive || false;

				if (!isActive || !this.flickityInstance.options['draggable']) {
					return; // Not draggable, so nothing to do
				}

				if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
					this.flickityInstance.unbindDrag();
				} else {
					this.flickityInstance.bindDrag();
				}
			}

			/**
			 * Flickity is a CSS driven library and hence it is hard to setup some stuff in pure JS
			 */

		}, {
			key: '_processConfig',
			value: function _processConfig() {
				var config = Object.assign({}, this.initialConfig);

				delete config['breakpoints'];

				if (this.initialConfig['breakpoints'] === undefined) {
					return config; // No change, we simply return the config as it is
				}

				var breakpoints = this.initialConfig['breakpoints'];

				breakpoints.forEach(function (breakpoint) {
					if (__WEBPACK_IMPORTED_MODULE_0__helper_Responsive__["default"].matchesBreakpoint(breakpoint['matches'])) {
						config = Object.assign(config, breakpoint['settings']);
					}
				});

				return config;
			}

			/**
			 * Verify if the breakpoint has changed, and optionally update the carousel
			 */

		}, {
			key: '_onBreakpointChanged',
			value: function _onBreakpointChanged() {
				// The breakpoint may have changed, so we delete the carousel and rebuild it
				this.flickityInstance.destroy();
				this._build();
			}
		}]);

		return Carousel;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Carousel;

	/***/
},
/* 3 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Responsive__ = __webpack_require__(1);

	var Popover = function () {
		function Popover(element, options) {
			_classCallCheck(this, Popover);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);

			this.activator = options['activator'] || document.querySelector('[aria-controls="' + element.getAttribute('id') + '"]');

			this.preferredPosition = options['preferredPosition'] || 'bottom';
			this.preferredAlignment = options['preferredAlignment'] || undefined;
			this.threshold = options['threshold'] || 20;
			this.isOpen = false;

			this.onValueChanged = options['onValueChanged'] || function () {};
			this.onOpen = options['onOpen'] || function () {};
			this.onClose = options['onClose'] || function () {};

			this.showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay'];
			this.pageOverlayElement = document.querySelector('.PageOverlay');

			this._attachListeners();
		}

		_createClass(Popover, [{
			key: 'destroy',
			value: function destroy() {
				this.element.removeEventListener('keyup', this._handleKeyboardListener);
				this.delegateElement.off('click');
				this.activator.removeEventListener('click', this._toggleListener);
			}
		}, {
			key: 'toggle',
			value: function toggle() {
				this.isOpen ? this.close() : this.open();
			}
		}, {
			key: 'open',
			value: function open() {
				var _this3 = this;

				// Note: the additional check on the aria-controls is used here so that a given activator can be used on different
				//       popovers and be modified dynamically in JavaScript
				if (this.isOpen || this.activator.getAttribute('aria-controls') !== this.element.id) {
					return;
				}

				this.element.setAttribute('aria-hidden', 'false');
				this.activator.setAttribute('aria-expanded', 'true');

				disableBodyScroll(true, '[data-scrollable]');

				document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open

				if (__WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('lap-and-up')) {
					document.body.addEventListener('click', this._clickOutsideListener);
					this._position();

					this.element.setAttribute('tabindex', '-1');

					this.element.addEventListener('transitionend', function () {
						_this3.element.focus();
					}, { once: true });
				} else {
					this.element.removeAttribute('style');

					if (this.showOverlay) {
						this.pageOverlayElement.classList.add('is-visible');
						this.pageOverlayElement.addEventListener('click', this._closeListener);
					}
				}

				this.onOpen(this); // Call the callback to allow other code to hook their logic
				this.isOpen = true;
			}
		}, {
			key: 'close',
			value: function close() {
				if (!this.isOpen) {
					return;
				}

				this.element.setAttribute('aria-hidden', 'true');
				this.activator.setAttribute('aria-expanded', 'false');

				disableBodyScroll(false, '[data-scrollable]');

				document.documentElement.classList.remove('no-scroll');

				if (__WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('lap-and-up')) {
					document.body.removeEventListener('click', this._clickOutsideListener);
				} else if (this.showOverlay) {
					this.pageOverlayElement.classList.remove('is-visible');
					this.pageOverlayElement.removeEventListener('click', this._closeListener);
				}

				this.element.removeAttribute('tabindex');
				this.activator.focus();

				this.onClose(this); // Call the callback to allow other code to hook their logic
				this.isOpen = false;
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._handleKeyboardListener = this._handleKeyboard.bind(this);
				this._clickOutsideListener = this._clickOutside.bind(this);
				this._closeListener = this.close.bind(this);
				this._toggleListener = this.toggle.bind(this);

				this.element.addEventListener('keyup', this._handleKeyboardListener);
				this.activator.addEventListener('click', this._toggleListener);

				this.delegateElement.on('click', '[data-action="close-popover"]', this.close.bind(this));
				this.delegateElement.on('click', '[data-action="select-value"]', this._valueChanged.bind(this));

				if (this.element.hasAttribute('id')) {
					this.delegateElement.on('focusout', '#' + this.element.getAttribute('id'), this._onFocusOut.bind(this));
				}
			}

			/**
			 * Whenever a value is selected, it can notify a callback so that the calling code can do its own logic in response
			 * of the value change
			 */

		}, {
			key: '_valueChanged',
			value: function _valueChanged(event) {
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].getSiblings(event.target, '.is-selected').forEach(function (item) {
					return item.classList.remove('is-selected');
				});
				event.target.classList.add('is-selected');

				// If there is a callback in option we call it with the value
				this.onValueChanged(event.target.getAttribute('data-value'), event.target, this.activator);
				this.close();
			}
		}, {
			key: '_onFocusOut',
			value: function _onFocusOut(event) {
				if (!this.element.contains(event.relatedTarget)) {
					this.close();
				}
			}

			/**
			 * Callback that is called to decide if we should close the popover when a click is captured outside
			 */

		}, {
			key: '_clickOutside',
			value: function _clickOutside(event) {
				if (!event.target.closest('.Popover') && !event.target.closest('.Modal') && event.target !== this.activator && !this.activator.contains(event.target)) {
					this.close();
				}
			}

			/**
			 * On desktop, we reposition the popover in JavaScript by doing some smart logic to detect the most appropriate area
			 */

		}, {
			key: '_position',
			value: function _position() {
				var _this4 = this;

				var topPosition = 0,
						rightPosition = 0,
						position = '',
						alignment = '',
						threshold = this.threshold;

				fastdom.measure(function () {
					var windowHeight = window.innerHeight,
							activatorBoundingRect = _this4.activator.getBoundingClientRect(),
							halfHeight = windowHeight / 2;

					if (_this4.preferredPosition === 'bottom') {
						alignment = 'right';

						if (_this4.element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
							position = 'bottom';
						} else {
							position = 'top';
						}
					} else if (_this4.preferredPosition === 'top') {
						alignment = 'right';

						if (_this4.element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
							position = 'top';
						} else {
							position = 'bottom';
						}
					} else {
						position = 'left';

						// Is there enough space to use the center alignment (which is preferred)?
						var halfElementHeight = _this4.element.clientHeight / 2;

						if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
							alignment = 'center';
						} else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
							alignment = 'bottom';
						} else {
							alignment = 'top';
						}
					}

					if (_this4.preferredAlignment) {
						alignment = _this4.preferredAlignment;
					}

					if (position === 'top') {
						topPosition = activatorBoundingRect.top - _this4.element.clientHeight - threshold;

						if (alignment === 'center') {
							rightPosition = window.innerWidth - activatorBoundingRect.right - _this4.element.clientWidth / 2 + 3;
						} else {
							rightPosition = window.innerWidth - activatorBoundingRect.right;
						}
					} else if (position === 'bottom') {
						topPosition = activatorBoundingRect.bottom + threshold;

						if (alignment === 'center') {
							rightPosition = window.innerWidth - activatorBoundingRect.right - _this4.element.clientWidth / 2 + 3;
						} else {
							rightPosition = window.innerWidth - activatorBoundingRect.right;
						}
					} else {
						rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;

						if (alignment === 'center') {
							topPosition = activatorBoundingRect.top - _this4.element.clientHeight / 2 + _this4.activator.clientHeight / 2;
						} else if (alignment === 'top') {
							topPosition = activatorBoundingRect.bottom - _this4.element.clientHeight;
						} else {
							topPosition = activatorBoundingRect.top;
						}
					}
				});

				fastdom.mutate(function () {
					['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].map(function (item) {
						return _this4.element.classList.remove(item);
					});
					_this4.element.classList.add('Popover--position' + (position.charAt(0).toUpperCase() + position.slice(1)));
					_this4.element.classList.add('Popover--align' + (alignment.charAt(0).toUpperCase() + alignment.slice(1)));

					_this4.element.setAttribute('style', 'top: ' + parseInt(topPosition) + 'px; right: ' + parseInt(rightPosition) + 'px;');
				});
			}

			/**
			 * Handle a11y events
			 */

		}, {
			key: '_handleKeyboard',
			value: function _handleKeyboard(event) {
				if (this.isOpen && event.keyCode === 27) {
					this.close();
				}
			}
		}]);

		return Popover;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Popover;

	/***/
},
/* 4 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/**
	 * Note: this was a feature that was added at the very end and couldn't do something much cleaner without rewriting large parts of the theme...
	 */

	var ProductItemColorSwatch = function () {
		function ProductItemColorSwatch(element) {
			_classCallCheck(this, ProductItemColorSwatch);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);

			this.delegateElement.on('change', '.ColorSwatch__Radio', this._colorChanged.bind(this));
		}

		_createClass(ProductItemColorSwatch, [{
			key: '_colorChanged',
			value: function _colorChanged(event, target) {
				// We need to change the URL of the various links
				var productItem = target.closest('.ProductItem'),
						variantUrl = target.getAttribute('data-variant-url');

				productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', variantUrl);
				productItem.querySelector('.ProductItem__Title > a').setAttribute('href', variantUrl);

				// If we have a custom image for the variant, we change it
				var originalImageElement = productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');

				if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
					var newImageElement = document.createElement('img');
					newImageElement.className = 'ProductItem__Image Image--fadeIn Image--lazyLoad';
					newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
					newImageElement.setAttribute('data-src', target.getAttribute('data-image-url'));
					newImageElement.setAttribute('data-widths', target.getAttribute('data-image-widths'));
					newImageElement.setAttribute('data-sizes', 'auto');

					// Replace the original node
					if (window.theme.productImageSize === 'natural') {
						originalImageElement.parentNode.style.paddingBottom = 100.0 / target.getAttribute('data-image-aspect-ratio') + '%';
					}

					originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
					originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
				}
			}
		}]);

		return ProductItemColorSwatch;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductItemColorSwatch;

	/***/
},
/* 5 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var Accessibility = function () {
		function Accessibility() {
			_classCallCheck(this, Accessibility);
		}

		_createClass(Accessibility, null, [{
			key: 'trapFocus',

			/**
			 * Traps the focus in a particular container
			 */
			value: function trapFocus(container, namespace) {
				this.listeners = this.listeners || {};
				// We check if there is an element with the attribute "autofocus"
				var elementToFocus = container.querySelector('[autofocus]') || container;
				
				container.setAttribute('tabindex', '-1');
				elementToFocus.focus();

				this.listeners[namespace] = function (event) {
					if (container !== event.target && !container.contains(event.target)) {
						container.focus();
					}
				};
				
				document.addEventListener('focusin', this.listeners[namespace]);
			}

			/**
			 * Removes the trap of focus in a particular container
			 */

		}, {
			key: 'removeTrapFocus',
			value: function removeTrapFocus(container, namespace) {
				if (container) {
					container.removeAttribute('tabindex');
				}

				if (this.listeners && this.listeners[namespace]) {
					document.removeEventListener('focusin', this.listeners[namespace]);
				}
			}

			/**
			 * Reset any previous trap focus
			 */

		}, {
			key: 'clearTrapFocus',
			value: function clearTrapFocus() {
				for (var key in this.listeners) {
					if (this.listeners.hasOwnProperty(key)) {
						document.removeEventListener('focusin', this.listeners[key]);
					}
				}

				this.listeners = {};
			}
		}]);

		return Accessibility;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Accessibility;

	/***/
},
/* 6 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__ = __webpack_require__(5);

	var Drawer = function () {
		function Drawer(element) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			_classCallCheck(this, Drawer);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.delegateBody = new domDelegate.Delegate(document.body);

			this.onOpen = options['onOpen'] || function () {};
			this.onClose = options['onClose'] || function () {};

			this.isOpen = false;
			this.direction = this.element.classList.contains('Drawer--fromLeft') ? 'fromLeft' : 'fromRight';

			this.pageOverlayElement = document.querySelector('.PageOverlay');

			// custom code
			this.announcementBar = document.querySelector('.AnnouncementBar');
			this.headerElement = document.querySelector('.Header');
			this.searchElement = document.getElementById('Search');
			this.body = document.querySelector('body');
			
			this.headerWasTransparent = this.headerElement?.classList.contains("Header--transparent") ? true : false;
			this.mobileHeaderWasTransparent = this.headerElement?.classList.contains("MobileHeader--transparent") ? true : false;

			this.headerParent = document.getElementById('shopify-section-header');			
			if (document.getElementById('shopify-section-announcement')) {
				this.announcementParent = document.getElementById('shopify-section-announcement-updated');
			} else if (document.getElementById('shopify-section-announcement-updated')) {
				this.announcementParent = document.getElementById('shopify-section-announcement-updated');
			} else {
				this.announcementParent = null;
			}

			this.showDrawerButton = document.querySelector('[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]');
			this.closeDrawerButton = document.querySelector('[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]');

			this.mainSearchButton = document.querySelector('[data-action="toggle-search"]');
			
			this.buttonWasActive;

			this._attachListeners();
		}

		_createClass(Drawer, [{
			key: 'destroy',
			value: function destroy() {
				this.delegateBody.off('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]');
				this.delegateBody.off('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]');
				window.removeEventListener('resize', this._calculateMaxHeightListener);

			}
		}, {
			key: 'toggle',
			value: function toggle() {
				this.isOpen ? this.close() : this.open();
			}
		}, {
			key: 'open',
			value: function open(event) {
				if (this.isOpen) {
					return;
				}

				if (this.body.classList.contains('template-index') || this.body.classList.contains('template-collection')) {
					this.searchElement.setAttribute('aria-hidden', 'false');
					this.searchElement.classList.remove('forced_show');
				}

				//setGetParam("sidecart", "open")

				this.headerWasTransparent = this.headerElement.classList.contains("Header--transparent") ? true : false;
				this.mobileHeaderWasTransparent = this.headerElement?.classList.contains("MobileHeader--transparent") ? true : false;

				// Make sure that the search is closed whenever a drawer is opened
				this.element.dispatchEvent(new CustomEvent('search:close', { bubbles: true }));

				if (event) {
					event.preventDefault();
				}

				
				this.element.setAttribute('aria-hidden', 'false');
				this._calculateMaxHeight();

				this.mainSearchButton.setAttribute("data-action", "toggle-sidebar-search");

				document.documentElement.classList.add('no-scroll');
				
				// This prevent the body to scroll on iOS. This is honestly a bit hacky, but until the platform supports "touch-action: none" like
				// other browsers, this is the only way to achieve that
				//disableBodyScroll(true, '[data-scrollable]');
				// __WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].trapFocus(this.element, 'drawer');

				document.querySelector('#shopify-section-header').style.zIndex = ''; // Ugly hack

				// We attach an event to the page overlay to close it
				this.pageOverlayElement.classList.add('is-visible');
				this.pageOverlayElement.addEventListener('click', this._closeListener);
				let _this = this;
				// custom code 
				if (this.element.id != "sidebar-cart") {
					if (this.announcementParent != null) {
						this.announcementParent.style.position = "sticky";
						this.announcementParent.style.zIndex = 5;
						$(this.announcementParent).animate({
							top: 0
						}, 300);
					}
					$(this.headerParent).animate({
						top: this.announcementBar != null ? this.announcementBar.offsetHeight : 0
					}, 300);

					this.headerElement.classList.add("FastTransition");
					let _this = this;
					let onTransitionEnd = function onTransitionEnd(event) {
						if (event.propertyName === 'transform') {
							_this.headerElement?.classList.remove("FastTransition");
							_this.element.removeEventListener('transitionend', onTransitionEnd);
						}
					};
					this.element.addEventListener('transitionend', onTransitionEnd);
					this.headerElement.classList.remove("Header--transparent", "MobileHeader--transparent");
				
					this.pageOverlayElement.style.top = this.headerParent.offsetHeight + this.announcementParent.offsetHeight + 'px';
					this.showDrawerButton.style.display = 'none';
					this.closeDrawerButton.style.display = 'block';
				} else {
					let pageContainer = this.element.parentNode.querySelector(".PageContainer");
					pageContainer.style.transform = "translateX(-"+this.element.offsetWidth+"px)";
					this.pageOverlayElement.style.opacity = "0";
					let $this = this;
					let floatingProductPageButton = document.querySelector(".ProductForm--floating_button--wrapper");
					if (floatingProductPageButton) {		
						floatingProductPageButton.style.position = "absolute";
						let relativeContainer = document.querySelector(".Product__InfoWrapper");
						let params = relativeContainer.getBoundingClientRect();
						let topValue = params.height - params.bottom + window.innerHeight - floatingProductPageButton.clientHeight;
						floatingProductPageButton.style.top = topValue + "px";
						let onTransitionEnd = function onTransitionEnd(event) {
							if (event.propertyName === 'transform') {
								floatingProductPageButton.style.removeProperty("position");
								floatingProductPageButton.style.removeProperty("top");
								pageContainer.removeEventListener('transitionend', onTransitionEnd);
								floatingProductPageButton.setAttribute("aria-hidden", true);
							}
						};

						pageContainer.addEventListener('transitionend', onTransitionEnd);

					}
				}

				this.isOpen = true;
				document.dispatchEvent(new CustomEvent('drawer:open', {
					detail: {
						id: this.element.id
					}
				}));

				this.onOpen(); // Call the callback to allow other code to hook their logic

				return false;
			}
		}, {
			key: 'close',
			value: function close(event) {
				if (!this.isOpen) {
					return;
				}

				if (event) {
					event.preventDefault();
				}

				// deleteParam("sidecart", "open")

				this.element.setAttribute('aria-hidden', 'true');

				this.mainSearchButton.setAttribute("data-action", "toggle-search");

				if ((this.body.classList.contains('template-index') || this.body.classList.contains('template-collection')) && window.innerWidth < 639 ) {
					this.searchElement.setAttribute('aria-hidden', 'false');
					this.searchElement.classList.add('forced_show');
				}

				document.documentElement.classList.remove('no-scroll');

				disableBodyScroll(false, '[data-scrollable]');

				__WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].removeTrapFocus(this.element, 'drawer');

				this.pageOverlayElement.classList.remove('is-visible');
				this.pageOverlayElement.removeEventListener('click', this._closeListener);
				
				let _this = this;

				// custom code
				if (this.element.id != "sidebar-cart") {
					if (this.announcementParent != null) {
						$(this.announcementParent).animate({
							top: 'unset'
						}, 300, function(){
							_this.announcementParent.style.position = "relative";
							_this.announcementParent.style.zIndex = 1;
							_this.pageOverlayElement.style.top = '0px';
						});
					}          
					$(this.headerParent).animate({
						top: 0
					}, 300);
					this.showDrawerButton.style.display = 'block';
					this.closeDrawerButton.style.display = 'none';
					this.mainSearchButton.style.pointerEvents = "initial";
				} else {
					let pageContainer = this.element.parentNode.querySelector(".PageContainer");
					pageContainer.style.transform = "translateX(0px)";
					let floatingProductPageButton = document.querySelector(".ProductForm--floating_button--wrapper");
					let onTransitionEnd1 = function onTransitionEnd1(event) {
						if (event.propertyName === 'transform') {
							pageContainer.style.removeProperty("transform");
							pageContainer.removeEventListener('transitionend', onTransitionEnd1);
						}
					};
					pageContainer.addEventListener('transitionend', onTransitionEnd1);

					this.pageOverlayElement.style.removeProperty('opacity');
				}


				let onTransitionEnd2 = function onTransitionEnd2(event) {
					if (event.propertyName === 'transform') {
						document.dispatchEvent(new CustomEvent('drawer:close:transitionend'));
						_this.element.removeEventListener('transitionend', onTransitionEnd2);
					}
				};

				this.element.addEventListener('transitionend', onTransitionEnd2);

				this.isOpen = false;
				document.dispatchEvent(new CustomEvent('drawer:close'));
				this.onClose(); // Call the callback to allow other code to hook their logic
				
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._openListener = this.open.bind(this);
				this._closeListener = this.close.bind(this);
				this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this);

				this.delegateBody.on('click', '[data-action="open-drawer"][data-drawer-id="' + this.element.id + '"]', this._openListener);
				this.delegateBody.on('click', '[data-action="close-drawer"][data-drawer-id="' + this.element.id + '"]', this._closeListener);
				this.element.addEventListener('keyup', this._handleKeyboard.bind(this));
				window.addEventListener('resize', this._calculateMaxHeightListener);
			}

			/**
			 * Make sure that we force a max-height so that the drawer always stays on screen
			 */

		}, {
			key: '_calculateMaxHeight',
			value: function _calculateMaxHeight() {
				var announcementBar_offset = this.announcementBar != null ? this.announcementBar.offsetHeight : 0;
				var topOffset = announcementBar_offset + this.headerElement?.offsetHeight || 0;
				if (this.element.id != "sidebar-cart" ){
					this.element.style.maxHeight = (window.innerHeight - topOffset) + 2 + 'px';
				} else {
					this.element.style.maxHeight = window.innerHeight + 'px';
				}
			}
		}, {
			key: '_handleKeyboard',

			/**
			 * Handle a11y events
			 */
			value: function _handleKeyboard(event) {
				if (this.isOpen && event.keyCode === 27) {
					this.close();
				}
			}
		}]);

		return Drawer;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Drawer;

	/***/
},
/* 7 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var Animation = function () {
		function Animation() {
			_classCallCheck(this, Animation);
		}

		_createClass(Animation, null, [{
			key: 'slideUp',

			/**
			 * Slide up aims to close an element. To do that, we take the height of the element, and set it to 0 to
			 * force an animation
			 */
			value: function slideUp(element) {
				element.style.height = element.scrollHeight + 'px'; // Force previous height to allow CSS transition
				element.offsetHeight; // Force redraw
				element.style.height = 0;
			}

			/**
			 * Slide down aims to open an element. To do that, you must make sure that the element you are trying to open
			 * is set with height: 0; overflow: hidden in the CSS, and does not contain any padding nor margin.
			 */

		}, {
			key: 'slideDown',
			value: function slideDown(element) {
				if (element.style.height === 'auto') {
					return;
				}

				// To do the animation we temporarily hide it, check the height, and transition to it
				element.style.height = element.firstElementChild.scrollHeight + 'px';

				var transitionEnded = function transitionEnded(event) {
					if (event.propertyName === 'height') {
						element.style.height = 'auto'; // Allows the content to grow normally
						element.removeEventListener('transitionend', transitionEnded);
					}
				};

				element.addEventListener('transitionend', transitionEnded);
			}
		}]);

		return Animation;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Animation;

	/***/
},
/* 8 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var Currency = function () {
		function Currency() {
			_classCallCheck(this, Currency);
		}

		_createClass(Currency, null, [{
			key: 'formatMoney',

			/**
			 * Format money values based on your shop currency settings
			 *
			 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
			 * @param  {String} format - shop money_format setting
			 * @return {String} value - formatted value
			 */
			value: function formatMoney(cents, format) {
				if (typeof cents === 'string') {
					cents = cents.replace('.', '');
				}

				var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
						formatString = format || '${{amount}}';

				function defaultTo(value, defaultValue) {
					return value == null || value !== value ? defaultValue : value;
				}

				function formatWithDelimiters(number, precision, thousands, decimal) {
					precision = defaultTo(precision, 2);
					thousands = defaultTo(thousands, ',');
					decimal = defaultTo(decimal, '.');

					if (isNaN(number) || number == null) {
						return 0;
					}

					number = (number / 100.0).toFixed(precision);

					var parts = number.split('.'),
							dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
							centsAmount = parts[1] ? decimal + parts[1] : '';

					return dollarsAmount + centsAmount;
				}

				var value = '';

				switch (formatString.match(placeholderRegex)[1]) {
					case 'amount':
						value = formatWithDelimiters(cents, 2);
						break;
					case 'amount_no_decimals':
						value = formatWithDelimiters(cents, 0);
						break;
					case 'amount_with_space_separator':
						value = formatWithDelimiters(cents, 2, ' ', '.');
						break;
					case 'amount_no_decimals_with_comma_separator':
						value = formatWithDelimiters(cents, 0, ',', '.');
						break;
					case 'amount_no_decimals_with_space_separator':
						value = formatWithDelimiters(cents, 0, ' ');
						break;
					case 'amount_with_comma_separator':
						value = formatWithDelimiters(cents, 2, '.', ',');
						break;
					case 'custom_comma_separator':
						value = formatWithDelimiters(cents, 2);
						break;
					case 'FB_AddToCart_Price_Format':
						value = formatWithDelimiters(cents, 2, '');
						break;
				}

				if (formatString.indexOf('with_comma_separator') !== -1) {
					return formatString.replace(placeholderRegex, value).replace(',00', '');
				} else if(formatString.indexOf('custom_comma_separator') !== -1) {
					return formatString.replace(placeholderRegex, value).replace(',00', '.00');
				} else if(formatString.indexOf('FB_AddToCart_Price_Format') !== -1) {
					return formatString.replace(placeholderRegex, value).replace(',00', '.00');
				} else {
					return formatString.replace(placeholderRegex, value).replace('.00', '');
				}
			}
		}]);

		return Currency;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Currency;

	/***/
},
/* 9 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var Image = function () {
		function Image() {
			_classCallCheck(this, Image);
		}

		_createClass(Image, null, [{
			key: 'getSizedImageUrl',

			/**
			 * Create a CDN URL (similar to the img_url filter in Liquid)
			 */
			value: function getSizedImageUrl(src, size) {
				if (size === null) {
					return src;
				}

				if (size === 'master') {
					return src.replace(/http(s)?:/, '');
				}

				var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

				if (match) {
					var prefix = src.split(match[0]);
					var suffix = match[0];

					return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '');
				} else {
					return null;
				}
			}

			/**
			 * From a given set of desired sizes and a given image, filter out any unwanted sizes
			 */

		}, {
			key: 'getSupportedSizes',
			value: function getSupportedSizes(image, desiredSizes) {
				var supportedSizes = [],
						imageWidth = image['width'];

				desiredSizes.forEach(function (width) {
					if (imageWidth >= width) {
						supportedSizes.push(width);
					}
				});

				return supportedSizes;
			}
		}]);

		return Image;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Image;

	/***/
},
/* 10 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__Accessibility__ = __webpack_require__(5);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "AccessibilityHelper", function () {
		return __WEBPACK_IMPORTED_MODULE_0__Accessibility__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__Animation__ = __webpack_require__(7);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "AnimationHelper", function () {
		return __WEBPACK_IMPORTED_MODULE_1__Animation__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__Currency__ = __webpack_require__(8);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "CurrencyHelper", function () {
		return __WEBPACK_IMPORTED_MODULE_2__Currency__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__Dom__ = __webpack_require__(0);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "DomHelper", function () {
		return __WEBPACK_IMPORTED_MODULE_3__Dom__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__Image__ = __webpack_require__(9);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ImageHelper", function () {
		return __WEBPACK_IMPORTED_MODULE_4__Image__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__Responsive__ = __webpack_require__(1);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ResponsiveHelper", function () {
		return __WEBPACK_IMPORTED_MODULE_5__Responsive__["default"];
	});

	/***/
},
/* 11 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Popover__ = __webpack_require__(3);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Form__ = __webpack_require__(22);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__components_VariantSelector__ = __webpack_require__(17);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__helper_Currency__ = __webpack_require__(8);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__components_StoreAvailability__ = __webpack_require__(27);
	/**
	 * This component handles all the logic of switching variant, updating product meta...
	 */

	var ProductVariants = function () {
		function ProductVariants(container, options) {
			var _this5 = this;

			_classCallCheck(this, ProductVariants);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.options = options;

			this.preorderData = JSON.parse(this.options.preorderMeData);
			this.usePreorderText = false;
			var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
			this.productData = jsonData['product'];
			this.caninacalURL = jsonData['canonical_url'];
			this.productHasOnlyDefaultVariant = jsonData['productHasOnlyDefaultVariant'];

			this.variantsInventories = jsonData['inventories'] || {};
			this.masterSelector = this.element.querySelector('#product-select-' + this.productData['id']);

			this.productOptions = [...this.productData.options];

			// We init value with the first selected variant
			this.productData['variants'].forEach(function (variant) {
				if (variant['id'] === jsonData['selected_variant_id']) {
					_this5.currentVariant = variant;
					_this5.option1 = variant['option1'];
					_this5.option2 = variant['option2'];
					_this5.option3 = variant['option3'];
				}
			});
			
			if (this.productHasOnlyDefaultVariant) {
				this._updateAddToCartButton(this.currentVariant);
				this._updateDeliveryInfo(this.currentVariant);
			}

			this.storeAvailability = new __WEBPACK_IMPORTED_MODULE_5__components_StoreAvailability__["default"](this.element.querySelector('.ProductMeta__StoreAvailabilityContainer'), this.productData['title']);
			this.storeAvailability.updateWithVariant(this.currentVariant);

			this.backInStockFormWrapper = this.element.querySelector(".back_in_stock-form-wrapper");
			if (this.backInStockFormWrapper != null) {
				this.backInStockForm = this.backInStockFormWrapper.querySelector("#back_in_stock_form");
				this._handleBackInStockForm(this.currentVariant);
			}

			this.secondaryMeta = this.element.querySelector(".ProductMeta-secondary");
			this.lowStockQuote =  this.element.querySelector(".left_in_stock-info");
			if (this.lowStockQuote != null) {
				this._showPreselectedStock(this.productData);
			}
			
			let paumentButtonContainer = document.querySelector(".PaymentButton--overlay");
			if (paumentButtonContainer) {
				document.addEventListener("DOMContentLoaded", function() {
					let paymentButton = document.querySelector("[data-shopify='payment-button']");
					let findButton = setInterval(function() {
						if (paymentButton) {
							let targetButton = paymentButton.querySelector("div[role='button']");
							if (!targetButton) return;
							let clone = targetButton.cloneNode(true);
							let targetContainer = document.querySelector(".PaymentButton--placeholder");
							targetContainer.append(clone);
							targetContainer.style.opacity = "1";
							clearInterval(findButton)
						};
					})
				})
			}

			this.content_ids = JSON.parse(this.element.querySelector('[data-content-ids]').innerHTML).content_ids;

			this.floatingButtonActive = false;
			this._checkAddToCartButtonPosition();
			if (window.updateOrderTimer) { window.updateOrderTimer(); }
			this._attachListeners();
			this._createSelectors();
			this._triggerFBPixelEvent();
		}

		_createClass(ProductVariants, [{
			key: 'destroy',
			value: function destroy() {
				this.delegateElement.off('click');
				this.formPopovers.forEach(function (popover) {
					return popover.destroy();
				});
				this.formVariantSelectors.forEach(function (selector) {
					return selector.destroy();
				});
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
				this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
				this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
				this.delegateElement.on('change', '[name="quantity"]', this._validateQuantity.bind(this));
				this.delegateElement.on('submit', '#back_in_stock_form', this._backInStockSubmit.bind(this));
				this.delegateElement.on('change', '.ProductForm__Option select[data-option-position]', this._onOptionChanged.bind(this));
				// Hook when a radio button change
				this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
				window.addEventListener("scroll", this._checkAddToCartButtonPosition.bind(this));
				this.delegateElement.on('click', '[data-action="scroll-to-form"]', this._scrollToForm.bind(this));
			}

			/**
			 * Selectors can either be popovers or dedicated variant selectors. We therefore pre-create them all here
			 */

		}, {
			key: '_createSelectors',
			value: function _createSelectors() {
				var _this6 = this;

				// Create the instances for each selector
				this.formPopovers = [];
				this.formVariantSelectors = [];

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function (item) {
					var popover = new __WEBPACK_IMPORTED_MODULE_0__components_Popover__["default"](item, { preferredPosition: 'left', onValueChanged: _this6._onOptionChanged.bind(_this6) });
					_this6.formPopovers.push(popover);
				});

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.VariantSelector')).forEach(function (item) {
					var variantSelector = new __WEBPACK_IMPORTED_MODULE_3__components_VariantSelector__["default"](item, _this6, { onValueChanged: _this6._onOptionChanged.bind(_this6) });
					_this6.formVariantSelectors.push(variantSelector);
				});
			}

			/**
			 * ---------------------------------------------------------------------------------------------------
			 * CODE THAT HANDLE VARIANT CHANGES IN THE FRONT
			 *
			 * Please note that this code is highly dependant on the markup and classes, so make sure to NOT
			 * edit this code
			 * ---------------------------------------------------------------------------------------------------
			 */

			/**
			 * This callback is called whenever the variant changes and allows to update data about the active variant
			 */

		}, {
			key: '_onVariantChanged',
			value: function _onVariantChanged(previousVariant, newVariant) {

				console.log('previousVariant - ');
			    console.log(previousVariant);

				console.log('newVariant - ');
			    console.log(newVariant);

				// 1st: the prices
				this._updateProductPrices(newVariant, previousVariant);

				// 2nd: update inventory
				this._updateInventory(newVariant, previousVariant);

				// 3rd: update SKU
				this._updateSku(newVariant, previousVariant);

				// 4th: update the price measurement
				this._updateUnitPrice(newVariant, previousVariant);

				// 5th: the add to cart button
				this._updateAddToCartButton(newVariant, previousVariant);

				// 6th: store availability
				this.storeAvailability.updateWithVariant(newVariant);
				
				// 7th: update "Low Stock" number
				this._updateLowStock(newVariant);

				// 8th: handle "Back in Stock" Form
				this._handleBackInStockForm(newVariant);

				// 8th: update "Delivery info" below add to cart button
				this._updateDeliveryInfo(newVariant);
				
				// 9th; update global variant ID 
				//this._updateGlobalVariantID(newVariant);

				// Finally, we send an event so that other system could hook and do their own logic
				this.element.dispatchEvent(new CustomEvent('variant:changed', {
					bubbles: true,
					detail: { variant: newVariant, previousVariant: previousVariant }
				}));
			}

			/**
			 * Update the prices (optionally showing compare at price)
			 */

		}, {
			key: '_updateProductPrices',
			value: function _updateProductPrices(newVariant, previousVariant) {

				var productMetaPrices = this.element.querySelector('.ProductMeta__PriceList');
				
				if (productMetaPrices == null) return;

				if (!newVariant) {
					productMetaPrices.style.display = 'none';
				} else {
					if (previousVariant && previousVariant['price'] === newVariant['price'] && previousVariant['compare_at_price'] === newVariant['compare_at_price']) {
						return; // The price do not have changed so let's return to avoid changing the DOM for nothing
					}

					productMetaPrices.innerHTML = '';


					if (newVariant['compare_at_price'] > newVariant['price']) {
						productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + __WEBPACK_IMPORTED_MODULE_4__helper_Currency__["default"].formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>';
						productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>' + __WEBPACK_IMPORTED_MODULE_4__helper_Currency__["default"].formatMoney(newVariant['compare_at_price'], window.theme.moneyFormat) + '</span>';
					} else {
						productMetaPrices.innerHTML += '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>' + __WEBPACK_IMPORTED_MODULE_4__helper_Currency__["default"].formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>';
					}

					productMetaPrices.style.display = '';
				}
				
			}

			/**
			 * Update the inventory (if needed)
			 */

		}, {
			key: '_updateInventory',
			value: function _updateInventory(newVariant) {
				if (!this.options['showInventoryQuantity']) {
					return;
				}

				var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
						variantInventory = newVariant ? this.variantsInventories[newVariant['id']] : null;

				if (!newVariant || null === variantInventory['inventory_management'] || variantInventory['inventory_quantity'] <= 0 || this.options['inventoryQuantityThreshold'] > 0 && variantInventory['inventory_quantity'] > this.options['inventoryQuantityThreshold']) {
					productFormInventory.style.display = 'none';
				} else {
					productFormInventory.innerHTML = variantInventory['inventory_message'];
					productFormInventory.style.display = '';
				}
			}

			/**
			 * Update the SKU
			 */

		}, {
			key: '_updateSku',
			value: function _updateSku(newVariant) {
				if (!this.options['showSku'] || !newVariant) {
					return;
				}

				var productSkuNumber = this.element.querySelector('.ProductMeta__SkuNumber');

				if (productSkuNumber && newVariant['sku']) {
					productSkuNumber.innerText = newVariant['sku'];
				}
			}

			/**
			 * Update the unit price
			 */

		}, {
			key: '_updateUnitPrice',
			value: function _updateUnitPrice(newVariant) {
				if (!newVariant) {
					return;
				}

				var unitPriceMeasurement = this.element.querySelector('.ProductMeta__UnitPriceMeasurement');
				
				if (unitPriceMeasurement == null) return;

				if (!newVariant.hasOwnProperty('unit_price')) {
					unitPriceMeasurement.style.display = 'none';
					return;
				}

				unitPriceMeasurement.style.display = 'block';

				unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML = __WEBPACK_IMPORTED_MODULE_4__helper_Currency__["default"].formatMoney(newVariant['unit_price'], window.theme.moneyFormat);
				unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant['unit_price_measurement']['reference_unit'];

				var unitPriceReferenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
				unitPriceReferenceValue.textContent = newVariant['unit_price_measurement']['reference_value'];
				unitPriceReferenceValue.style.display = newVariant['unit_price_measurement']['reference_value'] === 1 ? 'none' : 'inline';
			}

			/**
			 * Update the add to cart
			 */

		}, {
			key: '_updateAddToCartButton',
			value: function _updateAddToCartButton(newVariant) {
				if (this.preorderData != null && this.preorderData[newVariant.id] != undefined ) {
					if (this.preorderData[newVariant.id]["prompt"].length > 0 && 
						this.preorderData[newVariant.id]["enabled"] === true && 
						this.preorderData[newVariant.id]["inventory"] < 1 ) {
						this.usePreorderText = true;
					} else {
						this.usePreorderText = false;
					}
				}
				
				var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
						shopifyPaymentButton = this.element.querySelector('.shopify-payment-button');

				addToCartButton.classList.remove('Button--secondary');
				addToCartButton.classList.remove('Button--primary');

				let paymentButton = document.querySelector(".PaymentButton--overlay");
				if (paymentButton) {
					paymentButton.setAttribute("data-action", "default")
				}

				console.log(newVariant);

				if (!newVariant) {
					addToCartButton.setAttribute('disabled', 'disabled');
					addToCartButton.removeAttribute('data-action');
					addToCartButton.classList.add('Button--secondary');
					addToCartButton.innerHTML = window.languages.productFormUnavailable;
					console.log('variant unavailable');
				} else {
					if (newVariant['available']) {
						console.log('variant available');
						addToCartButton.removeAttribute('disabled');
						addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
						addToCartButton.setAttribute('data-action', 'add-to-cart');

						if (this.usePreorderText) {
							addToCartButton.innerHTML = "<span>"+window.languages.productFormPreorder+"</span>";
						} else {  
							if (undefined === this.options['showPriceInButton'] || this.options['showPriceInButton']) {
								addToCartButton.innerHTML = '\n            <span>' + window.languages.productFormAddToCart + '</span>\n            <span class="Button__SeparatorDot"></span>\n            <span data-money-convertible>' + __WEBPACK_IMPORTED_MODULE_4__helper_Currency__["default"].formatMoney(newVariant['price'], window.theme.moneyFormat) + '</span>\n          ';
							} else {
								addToCartButton.innerHTML = '<span>' + window.languages.productFormAddToCart + '</span>';
							}
						}

					} else {  
						console.log('variant unavailable');
						addToCartButton.setAttribute('disabled', 'disabled');
						addToCartButton.classList.add('Button--secondary');
						addToCartButton.removeAttribute('data-action');
						addToCartButton.innerHTML = window.languages.productFormSoldOut;
					}
				}

				if (this.options['showPaymentButton'] && shopifyPaymentButton) {
					if (!newVariant || !newVariant['available']) {
						shopifyPaymentButton.style.display = 'none';
					} else {
						shopifyPaymentButton.style.display = 'block';
					}
				}
			}

			/**
			 * ---------------------------------------------------------------------------------------------------
			 * INTERNAL CODE THAT HANDLE VARIANT CHANGES
			 * ---------------------------------------------------------------------------------------------------
			 */

			/**
			 * Whenever an option is changed, this code fetch the corresponding active variant
			 */

		}, {
			key: '_onOptionChanged',
			value: function _onOptionChanged(newValue, target, activator) {

				// console.error('_onOptionChanged' + _onOptionChanged)

				// We change the value associated with the activator, and check if we have a color swatch
				if (activator) {
					this['option' + target.getAttribute('data-option-position')] = newValue;
					activator.querySelector('.ProductForm__SelectedValue').innerHTML = newValue;
				} else {
					this['option' + target.getAttribute('data-option-position')] = target.value;
					var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');
					if (selectedValue) {
						selectedValue.innerHTML = target.value;
					}
				}

				// Finally, we get the new variant
				var previousVariant = this.currentVariant;
				this.currentVariant = this._getCurrentVariantFromOptions();

				console.log(previousVariant.name);
				console.log(this.currentVariant.name);

				this._onVariantChanged(previousVariant, this.currentVariant);

				if (this.currentVariant) {
					if (this.options['enableHistoryState']) {
						this._updateHistoryState(this.currentVariant);
					}

					// We need to modify the hidden select that contain the id attribute as well
					this.masterSelector.querySelector('[selected]').removeAttribute('selected');
					this.masterSelector.querySelector('[value="' + this.currentVariant['id'] + '"]').setAttribute('selected', 'selected');
					this.masterSelector.dispatchEvent(new Event('change', { bubbles: true }));
				}
			}

			/**
			 * Get the active variant based on the options
			 */

		}, {
			key: '_getCurrentVariantFromOptions',
			value: function _getCurrentVariantFromOptions() {
				var _this7 = this;

				var found = false;

				this.productData['variants'].forEach(function (variant) {
					if (variant['option1'] === _this7.option1 && variant['option2'] === _this7.option2 && variant['option3'] === _this7.option3) {
						found = variant;
					}
				});

				return found || null;
			}

			/**
			 * Update the history state for browsers that support it
			 */

		}, {
			key: '_updateHistoryState',
			value: function _updateHistoryState(variant) {
				if (!history.replaceState) {
					return;
				}

				var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;

				window.history.replaceState({ path: newUrl }, '', newUrl);
			}

			/**
			 * ---------------------------------------------------------------------------------------------------
			 * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
			 * ---------------------------------------------------------------------------------------------------
			 */

		}, // Inside your _addToCart function
		{
			key: '_addToCart',
			value: function _addToCart(event) {
				var _this8 = this;
		
				if (!this.options['useAjaxCart']) {
					return; // When using a cart type of page, we just simply redirect to the cart page
				}
		
				event.preventDefault(); // Prevent form to be submitted
		
				var addToCartButton = this.element.querySelector('.ProductForm__AddToCart');
		
				// First, we switch the status of the button
				addToCartButton.setAttribute('disabled', 'disabled');
				document.dispatchEvent(new CustomEvent('theme:loading:start'));
		
				// Then we add the product in Ajax
				var formElement = this.element.querySelector('form[action*="/cart/add"]');
		
				fetch(window.routes.cartAddUrl + '.js', {
					body: JSON.stringify(__WEBPACK_IMPORTED_MODULE_2__helper_Form__["default"].serialize(formElement)),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
					}
				}).then(function (response) {
					document.dispatchEvent(new CustomEvent('theme:loading:end'));
		
					if (response.ok) {
						addToCartButton.removeAttribute('disabled');

						// Check if the current select is inside the modal 
						if (_this8.masterSelector) {
							// Find the modal among parents of the select element
							let modalToClose = _this8.masterSelector.closest('.Modal'); // Assuming the modal has a class 'Modal'
							if (modalToClose) {
								console.log('Closing modal after product added from modal.');
								modalToClose.querySelector('.Modal__Close').click();
							} 
						}
		
						console.log('Add to Cart successful.');
		
						// We simply trigger an event so the mini-cart can re-render
						_this8.element.dispatchEvent(new CustomEvent('product:added', {
							bubbles: true,
							detail: {
								variant: _this8.currentVariant,
								quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
							}
						}));

		
						response.json().then(function(data) {
							// Optional: Add any tracking events or additional logic
						});
		
					} else {
						response.json().then(function (content) {
							var errorMessageElement = document.createElement('span');
							errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
							errorMessageElement.innerHTML = content['description'];
							addToCartButton.removeAttribute('disabled');
							addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
							setTimeout(function () {
								errorMessageElement.remove();
							}, 2500);
						});
					}
				});
		
				event.preventDefault();
			}
		}, {
			key: '_decreaseQuantity',
			value: function _decreaseQuantity(event, target) {
				target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1);
			}

			/**
			 * When using the quantity selector, this can be used to increase the quantity
			 */

		}, {
			key: '_increaseQuantity',
			value: function _increaseQuantity(event, target) {
				target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1;
			}

			/**
			 * Make sure the quantity does not go below when manually changed
			 */

		}, {
			key: '_validateQuantity',
			value: function _validateQuantity(event, target) {
				target.value = Math.max(parseInt(target.value) || 1, 1);
			}
		}, {
			key: '_updateLowStock',
			value: function _updateLowStock(variant) {
				try {
					if (!this.lowStockQuote) {
						return;
					}
					if (!variant || !variant.id) {
						return;
					}
					var variantID = variant.id;
					var stock_number = document.getElementById("low_stock-value");
					if (!stock_number) {
						return;
					}
					if (!variant.available) {
						if (this.secondaryMeta) { this.secondaryMeta.classList.add("hidden"); }
						return;
					}
					if (this.secondaryMeta) { this.secondaryMeta.classList.remove("hidden"); }
					var id = 'product_variant_' + variantID;
					var lowStockVal = Math.floor(Math.random() * 10) + 4; // 4-13
					var timeStamp = new Date().getTime();
					var LSAObject = null;
					try {
						var cached = localStorage ? localStorage.getItem("__LSA") : null;
						LSAObject = cached ? JSON.parse(cached) : null;
					} catch (e) { LSAObject = null; }
					var needWrite = true;
					var valueToShow = lowStockVal;
					try {
						if (LSAObject && typeof LSAObject === 'object') {
							if (Object.prototype.hasOwnProperty.call(LSAObject, id)) {
								var rec = LSAObject[id];
								if (rec && typeof rec === 'object' && typeof rec.timeStamp === 'number' && (timeStamp - rec.timeStamp) <= 4 * 24 * 60 * 60 * 1000) {
									valueToShow = rec.val;
									needWrite = false;
								}
							}
						}
					} catch (e) {}
					stock_number.innerHTML = valueToShow;
					if (needWrite) {
						try {
							var data = LSAObject && typeof LSAObject === 'object' ? LSAObject : {};
							data[id] = { val: valueToShow, timeStamp: timeStamp };
							if (localStorage) localStorage.setItem("__LSA", JSON.stringify(data));
						} catch (e) {}
					}
				} catch (err) {
					try {
						var el = document.getElementById("low_stock-value");
						if (el) { el.textContent = (Math.floor(Math.random() * 10) + 4); }
						if (this.secondaryMeta) { this.secondaryMeta.classList.remove("hidden"); }
					} catch (e) {}
					console.error('_updateLowStock failed', err);
				}
			}
		}, {
			key: '_showPreselectedStock',
			value: function _showPreselectedStock(product) {
				
				let productID = product.id; 
				let id = 'product_' + productID;
				let lowStockVal = Math.floor(Math.random() * 10) + 4; // 4-13
				let timeStamp = new Date().getTime();
				let LSAObject = null;
				try {
					const cached = localStorage ? localStorage.getItem("__LSA") : null;
					LSAObject = cached ? JSON.parse(cached) : null;
				} catch(e) { LSAObject = null; }
				const hasProduct = LSAObject && Object.prototype.hasOwnProperty.call(LSAObject, id);
				const isExpired = hasProduct ? (timeStamp - (LSAObject[id] && LSAObject[id]['timeStamp'] || 0)) > 6 * 24 * 60 * 60 * 1000 : true;
				if (!hasProduct || isExpired) {
					try {
						let data = LSAObject && typeof LSAObject === 'object' ? LSAObject : {};
						data[id] = { val: lowStockVal, timeStamp: timeStamp };
						if (localStorage) localStorage.setItem("__LSA", JSON.stringify(data));
					} catch(e) {}
				} else {
					lowStockVal = LSAObject[id]['val'];
				}

				if (product.variants.length == 1) {
					let variant_id = 'product_variant_'+product.variants[0].id;
					let lowStockVal_var = Math.floor(Math.random() * 10) + 4; // 4-13
					let timeStamp_var = new Date().getTime();
					const hasVar = LSAObject && Object.prototype.hasOwnProperty.call(LSAObject, variant_id);
					const isVarExpired = hasVar ? (timeStamp_var - (LSAObject[variant_id] && LSAObject[variant_id]['timeStamp'] || 0)) > 4 * 24 * 60 * 60 * 1000 : true;
					if (!hasVar || isVarExpired) {
						try {
							let data = LSAObject && typeof LSAObject === 'object' ? LSAObject : {};
							data[variant_id] = { val: lowStockVal_var, timeStamp: timeStamp_var };
							if (localStorage) localStorage.setItem("__LSA", JSON.stringify(data));
						} catch(e) {}
					} 
				}

				if (!this.lowStockQuote) {
					return;
				}
				if (!product.available) {
					this.secondaryMeta.classList.add("hidden");
					return;
				}

				let stock_number = document.getElementById("low_stock-value");
				stock_number.innerHTML = lowStockVal;
				this.secondaryMeta.classList.remove("hidden");			

			}
		}, {
			key: "_handleBackInStockForm",
			value: function _handleBackInStockForm(variant) {
				this.backInStockForm.style.display = 'flex';
				this.backInStockForm.nextElementSibling.style.display = 'none';
				if (variant && !variant.available) {
					let addToCartButton = this.element.querySelector(".ProductForm__AddToCart");
					addToCartButton.setAttribute('disabled', 'disabled');
					addToCartButton.removeAttribute('data-action');
					addToCartButton.classList.add('Button--secondary');
					addToCartButton.innerHTML = window.languages.productFormSoldOut;

					this.backInStockFormWrapper.classList.add("show");
					this.backInStockForm.setAttribute("data-variant-id", variant.id);
				} else {
					this.backInStockFormWrapper.classList.remove("show");
					this.backInStockForm.removeAttribute("data-variant-id");
				}
			}
		}, {
			key: "_backInStockSubmit",
			value: function _backInStockSubmit(event, container) {
				event.preventDefault();
				var _this = this;
				const variantID = container.getAttribute("data-variant-id");
				const email = container.querySelector('.Form__Input').value;

				if (!variantID || !email) {
					return; // Exit if variant ID or email is not provided
				}

				const formattedVariantID = `$shopify:::$default:::${variantID}`;

				const BISpayload = {
					data: {
						type: "back-in-stock-subscription",
						attributes: {
							profile: {
								data: {
									type: "profile",
									attributes: {
										email: email
									}
								}
							},
							channels: ["EMAIL"]
						},
						relationships: {
							variant: {
								data: {
									type: "catalog-variant",
									id: formattedVariantID
								}
							}
						}
					}
				};

				const BISrequestOptions = {
					method: 'POST',
					headers: {
						accept: "application/json",
						revision: "2024-07-15",
						"Content-Type": "application/json"
					},
					body: JSON.stringify(BISpayload)
				};

				const requestTargetUrl = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyoAPIKey}`;

				// Perform the fetch request
				fetch(requestTargetUrl, BISrequestOptions)
					.then(response => {
						// First, check if the response is empty
						if (!response.ok) {
							return response.text().then(text => {
								throw new Error(`HTTP error! Status: ${response.status}, Response: ${text}`);
							});
						}

						// Try to parse as JSON if possible
						const contentType = response.headers.get("content-type");
						if (contentType && contentType.includes("application/json")) {
							return response.json();
						} else {
							return response.text(); // Return as plain text for non-JSON responses
						}
					})
					.then(data => {
						const submitButton = container.querySelector('button');
						const successMessage = _this.backInStockFormWrapper.querySelector(".success_message");
						const defaultDescription = _this.backInStockFormWrapper.querySelector(".form_description");
						submitButton.style.display = 'none';
						successMessage.style.display = 'block';
						defaultDescription.style.display = 'none';
					})
					.catch(error => {
						console.error("Fetch error:", error);
					});
			}
		}, {
			// not used anymore - clear later
			key: "_listenForAllSelectors",
			value: function _listenForAllSelectors(event) {
			  const target = event.target;

			  // Ensure target exists before proceeding
			  if (!target || !target.classList) {
				console.error("Target is undefined or does not have classList");
				return;
			  }
		  
			  // Get the closest form to determine if the action is from the modal or main page
			  const formElement = target.closest('.ProductForm');
			  const isModal = formElement.closest('.Modal') !== null;  // Check if the form belongs to modal
		  
			  // Log to see which form is being handled
			  console.log('Handling form for:', isModal ? 'Modal' : 'Main Page');
		  
			  // Ensure that only the correct form's selects trigger this event
			  if (isModal && target.closest('.Modal')) {
			  } else if (!isModal && target.closest('.ProductForm')) {
			  } else {
				return;  // Stop if not handling the correct context
			  }
		  
			  if (this.productOptions.length === 0) {
				return;
			  }
		  
			  let optionName = target.getAttribute("data-option-name");
			  let index = this.productOptions.indexOf(optionName);
		  
			  if (index > -1) {
				this.productOptions.splice(index, 1);
			  }
		  
			  // Apply event listener to the correct form only
			  if (this.productOptions.length === 0) {
				const formSelector = isModal ? '.Modal .ProductForm__Option select[data-option-position]' : '.ProductForm__Option select[data-option-position]';
				this.delegateElement.on('change', formSelector, this._onOptionChanged.bind(this));

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(formElement.querySelectorAll("[data-option-position][data-option-name]")).forEach(function (item) {
				  item.dispatchEvent(new Event('change', { bubbles: true }));
				});
			  }
			}
		  }, {
			key: "_addToCartButtonWhileSelectingOptions",
			value: function _addToCartButtonWhileSelectingOptions(event) {
				event.preventDefault();

				// Get the target element that triggered the event
				const target = event.target;

				// Ensure target exists and has a child element before proceeding
				if (target && target.firstElementChild) {
					let buttonContent = target.firstElementChild;
					buttonContent.textContent = window.languages.selectAnOption;
				} else {
					console.error("Target or its firstElementChild is undefined");
				}
			}
		}, {
			key: "_updateDeliveryInfo",
			value: function _updateDeliveryInfo(variant) {
				if (this.preorderData == null) return; 
				var deliveryInfoElement = document.querySelector(".delivery-info");
				console.log(deliveryInfoElement);
				if (!deliveryInfoElement) return;
				let preorderCopy = deliveryInfoElement.querySelector(".PreorderCopy");
				let mainCopy = deliveryInfoElement.querySelector(".MainCopy");
				let preorderData = JSON.parse(this.options.preorderMeData);
				let orderTimer = this.element.querySelector('.ProductMeta_secondary-order-timer')
				let estimatedDispatch = this.element.querySelector('.estimated-dispatch')
				let id = variant.id;
				if (this.usePreorderText) {
					mainCopy.style.display = 'none';
					preorderCopy.innerHTML = "<span>"+ preorderData[id]['prompt'] +"</span>";
					preorderCopy.style.display = 'block';
					if (estimatedDispatch) { estimatedDispatch.style.display = 'none'; }
					if (orderTimer) {
						orderTimer.remove();
					}
				} else {
					mainCopy.style.display = 'block';
					preorderCopy.style.display = 'none';
					if (estimatedDispatch) { estimatedDispatch.style.display = 'block'; }
				}
			}
		}, {
			key: "_triggerFBPixelEvent",
			value: function _triggerFBPixelEvent() {
				return;
				let content_ids = [];
				this.productData.variants.forEach(variant=>{
					content_ids.push(variant.id.toString());
				});
				let content_name = this.productData.title;
				let content_type = this.productData.type;
				let currency = window.theme.currentCurrency;
				let value = this.productData.price / 100;
				let data = {
					content_ids: content_ids,
					content_type: 'product',
					content_name: content_name,
					content_category: content_type,
					currency: currency,
					value: value
				}
				let interval = setInterval(function(){
					if (Shopify.analytics) {
						Shopify.analytics.publish("product_viewed_custom", data);
						clearInterval(interval)
					}
				}, 50);
			}
		}, {
			key: "_checkAddToCartButtonPosition",
			value: function _checkAddToCartButtonPosition(event) {
				let $this = this;
				let targetElement = this.element.querySelector(".ProductForm--buttons_wrapper");
				if (!targetElement) return;

				let floatingButtonContainer = this.element.querySelector(".ProductForm--floating_button--wrapper");
				if (!floatingButtonContainer) return;

				let targetContainerRect = targetElement.getBoundingClientRect();
				let announcementBar = document.querySelector("#shopify-section-announcement-updated");
				let header = document.querySelector("#shopify-section-header");
				let	headerCorrection = 0;
				let windowWidth = 0;
				fastdom.measure(function(){
					headerCorrection = announcementBar.clientHeight + header.clientHeight;
					windowWidth = window.innerWidth;
				});
				fastdom.mutate(function() {
					if (windowWidth > 768) {
						$this.floatingButtonActive = false;
						floatingButtonContainer.setAttribute("aria-hidden", true);
						return;
					}
					if (targetContainerRect.bottom < headerCorrection) {
						floatingButtonContainer.setAttribute("aria-hidden", false);
						$this.floatingButtonActive = true;
					} else if (targetContainerRect.bottom >= headerCorrection) {
						floatingButtonContainer.setAttribute("aria-hidden", true);
						$this.floatingButtonActive = false;
					}
				});
			}
		}, {
			key: "_scrollToForm",
			value: function _scrollToFrom(event) {
				event.preventDefault();
				// let targetForm = this.element.querySelector()
				$("html, body").animate({
					scrollTop: 0
				}, 1000)
			}
		}, {
			key: "_updateGlobalVariantID",
			value: function _updateGlobalVariantID(newVariant) {
				let targetInput = document.querySelector("#globalVariantID");
				targetInput.value = this.content_ids[newVariant.id];
			}
		},
		{
			key: '_reinitializeProductVariants',
			value: function _reinitializeProductVariants() {
				// Ensure the currentVariant is set up again
				let jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
				this.productData = jsonData['product'];
		
				// Set the current variant based on initial load
				this.productData['variants'].forEach((variant) => {
					if (variant['id'] === jsonData['selected_variant_id']) {
						this.currentVariant = variant;
						this.option1 = variant['option1'];
						this.option2 = variant['option2'];
						this.option3 = variant['option3'];
					}
				});
		
				this._updateAddToCartButton(this.currentVariant);
				this._updateDeliveryInfo(this.currentVariant);
		
				// Reattach the listeners for option changes
				this._attachListeners();
				this._createSelectors();
		
				console.log('ProductVariants reinitialized after modal content load.');
			}
		}
	]);

		return ProductVariants;
	}();
	/* harmony export (immutable) */

	// Expose ProductVariants globally by attaching it to the window object
	window.ProductVariants = ProductVariants;
	__webpack_exports__["default"] = ProductVariants;

	/***/
},
/* 12 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var CountrySelector = function () {
		function CountrySelector(countrySelect, provinceSelect) {
			_classCallCheck(this, CountrySelector);

			this.countrySelect = countrySelect;
			this.provinceSelect = provinceSelect;

			if (this.countrySelect && this.provinceSelect) {
				this._attachListeners();
				this._initSelectors();
			}
		}

		_createClass(CountrySelector, [{
			key: 'destroy',
			value: function destroy() {
				if (this.countrySelect) {
					this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
				}
			}
		}, {
			key: '_initSelectors',
			value: function _initSelectors() {
				// Check first the default value of country
				var defaultCountry = this.countrySelect.getAttribute('data-default');

				if (defaultCountry) {
					for (var i = 0; i !== this.countrySelect.options.length; ++i) {
						if (this.countrySelect.options[i].text === defaultCountry) {
							this.countrySelect.selectedIndex = i;
							break;
						}
					}
				} else {
					this.countrySelect.selectedIndex = 0;
				}

				var event = new Event('change', { bubbles: true });
				this.countrySelect.dispatchEvent(event);

				// Then the province
				var defaultProvince = this.provinceSelect.getAttribute('data-default');
				if (defaultProvince) {
					for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
						if (this.provinceSelect.options[_i].text === defaultProvince) {
							this.provinceSelect.selectedIndex = _i;
							break;
						}
					}
				}
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._onCountryChangedListener = this._onCountryChanged.bind(this);
				this.countrySelect.addEventListener('change', this._onCountryChangedListener);
			}
		}, {
			key: '_onCountryChanged',
			value: function _onCountryChanged() {
				var _this9 = this;

				var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
						provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');

				// First remove all options
				this.provinceSelect.innerHTML = '';

				if (provinces.length === 0) {
					this.provinceSelect.parentNode.style.display = 'none';
					return;
				}

				// We need to build the provinces array
				provinces.forEach(function (data) {
					_this9.provinceSelect.options.add(new Option(data[1], data[0]));
				});

				this.provinceSelect.parentNode.style.display = 'block';
			}
		}]);

		return CountrySelector;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = CountrySelector;

	/***/
},
/* 13 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/**
	 * This class allows to automatically scrolls within a div when this div does not fit into the visible space
	 */

	var OverflowScroller = function () {
		function OverflowScroller(element) {
			_classCallCheck(this, OverflowScroller);

			if (!element) {
				return;
			}

			this.element = element;
			this.lastKnownY = window.scrollY;
			this.currentTop = 0;
			this.initialTopOffset = parseInt(window.getComputedStyle(this.element).top);

			this._attachListeners();
		}

		_createClass(OverflowScroller, [{
			key: 'destroy',
			value: function destroy() {
				window.removeEventListener('scroll', this._checkPositionListener);
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._checkPositionListener = this._checkPosition.bind(this);
				window.addEventListener('scroll', this._checkPositionListener);
			}
		}, {
			key: '_checkPosition',
			value: function _checkPosition() {
				var _this10 = this;

				fastdom.measure(function () {
					var bounds = _this10.element.getBoundingClientRect(),
							maxTop = bounds.top + window.scrollY - _this10.element.offsetTop + _this10.initialTopOffset,
							minTop = _this10.element.clientHeight - window.innerHeight;

					if (window.scrollY < _this10.lastKnownY) {
						_this10.currentTop -= window.scrollY - _this10.lastKnownY;
					} else {
						_this10.currentTop += _this10.lastKnownY - window.scrollY;
					}

					_this10.currentTop = Math.min(Math.max(_this10.currentTop, -minTop), maxTop, _this10.initialTopOffset);
					_this10.lastKnownY = window.scrollY;
				});

				fastdom.mutate(function () {
					_this10.element.style.top = _this10.currentTop + 'px';
				});
			}
		}]);

		return OverflowScroller;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = OverflowScroller;

	/***/
},
/* 14 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Image__ = __webpack_require__(9);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__ = __webpack_require__(1);

	var ProductImageZoom = function () {
		function ProductImageZoom(element, slideshow) {
			_classCallCheck(this, ProductImageZoom);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.delegateRoot = new domDelegate.Delegate(document.body);

			this.slideshow = slideshow;

			this._attachListeners();
		}

		_createClass(ProductImageZoom, [{
			key: 'destroy',
			value: function destroy() {
				this.delegateElement.off('click');
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this));
				this.delegateElement.on('click', '.Product__SlideItem--image', this._initPhotoSwipeFromImageClick.bind(this));
			}

			/**
			 * To save performance, we only initialize PhotoSwipe when it's requested. All high resolution images
			 * are also loaded only on demand. Also, please note that PhotoSwipe is always completely destroyed
			 * whenever it is closed, so it stays super snappy
			 */

		}, {
			key: '_initPhotoSwipe',
			value: function _initPhotoSwipe() {
				var images = [];

				this.slideshow.flickityInstance.cells.forEach(function (item) {
					if (item.element.classList.contains('Product__SlideItem--image')) {
						images.push(item.element.querySelector('img'));
					}
				});

				this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(this.slideshow.flickityInstance.selectedElement.getAttribute('data-image-media-position')));
			}

			/**
			 * On desktop we do not have the dedicated small icon, instead the zoom is triggered when clicking directly on the image
			 */

		}, {
			key: '_initPhotoSwipeFromImageClick',
			value: function _initPhotoSwipeFromImageClick(event, target) {
				// Opening this way is only available on desktop

				if (__WEBPACK_IMPORTED_MODULE_2__helper_Responsive__["default"].matchesBreakpoint('pocket')) {
					return;
				}

				var images = __WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.Product__SlideItem--image img'));

				this._createPhotoSwipeInstance(this._createPhotoSwipeItemsFromImages(images), parseInt(target.getAttribute('data-image-media-position')));
			}

			/**
			 * Take a list of images and create a PhotoSwipe array. This is called whenever the gallery is initialized.
			 */

		}, {
			key: '_createPhotoSwipeItemsFromImages',
			value: function _createPhotoSwipeItemsFromImages(images) {
				return images.map(function (image) {
					var maxWidth = parseInt(image.getAttribute('data-max-width')),
							maxHeight = parseInt(image.getAttribute('data-max-height')),
							maxDimension = __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__["default"].matchesBreakpoint('phone') ? 1200 : 1800,
							// 1200 is max size for mobile and 1800 for larger devices
					reduceFactor = 1.0;

					if (maxWidth >= maxHeight) {
						reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
					} else {
						reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
					}

					var requestedWidth = Math.floor(maxWidth / reduceFactor);
					var requestedHeight = Math.floor(maxHeight / reduceFactor);

					return {
						msrc: image.currentSrc || image.src, // For browser that supports srcset, currentSrc is the currently used image
						w: requestedWidth,
						h: requestedHeight,
						initialZoomLevel: 0.1,
						// src: __WEBPACK_IMPORTED_MODULE_1__helper_Image__["default"].getSizedImageUrl(image.getAttribute('data-original-src'), requestedWidth + 'x' + requestedHeight)
						src: `${image.getAttribute('data-original-src')}&width=${requestedWidth}&height=${requestedHeight}`
					};
				});
			}

			/**
			 * Take a list of nodes containing all images and create a PhotoSwipe array. This is called
			 * whenever the gallery is initialized.
			 */

		}, {
			key: '_createPhotoSwipeInstance',
			value: function _createPhotoSwipeInstance(items, selectedImageIndex) {
				var _this11 = this;

				var photoswipeContainer = document.querySelector('.pswp');

				this.photoSwipeInstance = new PhotoSwipe(photoswipeContainer, false, items, {
					index: selectedImageIndex,
					showHideOpacity: true,
					showAnimationDuration: 500,
					loop: false,
					history: false,
					closeOnVerticalDrag: false,
					allowPanToNext: false,
					pinchToClose: false,
					errorMsg: '<p class="pswp__error-msg">' + window.languages.productImageLoadingError + '</p>',
					scaleMode: 'zoom',
					getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
						if (isMouseClick) {
							return 1.6;
						} else {
							return item.initialZoomLevel < 0.7 ? 1 : 1.33;
						}
					},
					getThumbBoundsFn: function getThumbBoundsFn(index) {
						var thumbnail = _this11.element.querySelector('.Product__Slideshow .Carousel__Cell[data-image-media-position="' + parseInt(index) + '"] img'),
								pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
								rect = thumbnail.getBoundingClientRect();

						return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
					}
				});

				this.photoSwipeInstance.listen('beforeChange', this._onSlideChanged.bind(this));
				this.photoSwipeInstance.listen('destroy', this._destroyPhotoSwipe.bind(this));
				this.photoSwipeInstance.listen('doubleTap', this._onDoubleTap.bind(this));
				this.photoSwipeInstance.listen('initialZoomIn', this._onInitialZoomIn.bind(this));
				this.photoSwipeInstance.listen('initialZoomOut', this._onInitialZoomOut.bind(this));

				this.delegateRoot.on('pswpTap', '.pswp__scroll-wrap', this._onSingleTap.bind(this));
				this.delegateRoot.on('pswpTap', '.pswp__button--close', this.photoSwipeInstance.close);
				this.delegateRoot.on('pswpTap', '.pswp__button--prev', this.photoSwipeInstance.prev);
				this.delegateRoot.on('pswpTap', '.pswp__button--next', this.photoSwipeInstance.next);

				this.photoSwipeInstance.init();
			}

			/**
			 * Update the nav
			 */

		}, {
			key: '_onSlideChanged',
			value: function _onSlideChanged() {
				if (this.photoSwipeInstance.getCurrentIndex() === 0) {
					this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').setAttribute('disabled', 'disabled');
				} else {
					this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--prev').removeAttribute('disabled');
				}

				if (this.photoSwipeInstance.getCurrentIndex() + 1 === this.photoSwipeInstance.options.getNumItemsFn()) {
					this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').setAttribute('disabled', 'disabled');
				} else {
					this.photoSwipeInstance.scrollWrap.querySelector('.pswp__button--next').removeAttribute('disabled');
				}
			}

			/**
			 * This event is a bit different and is triggered when the user click somewhere. We use it do allow to zoom in and
			 * zoom out in the image on desktop and use for the UI
			 */

		}, {
			key: '_onSingleTap',
			value: function _onSingleTap(event) {
				if (!event.detail || event.detail.pointerType === 'mouse') {
					if (event.target.classList.contains('pswp__img')) {
						this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
					}
				} else {
					if (event.target.classList.contains('pswp__button')) {
						return;
					}

					event.target.closest('.pswp').querySelector('.pswp__ui').classList.toggle('pswp__ui--hidden');
				}
			}
		}, {
			key: '_onDoubleTap',
			value: function _onDoubleTap(point) {
				var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

				if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
					this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
				} else {
					this.photoSwipeInstance.zoomTo(initialZoomLevel < 0.7 ? 1 : 1.33, point, 333);
				}
			}
		}, {
			key: '_onInitialZoomIn',
			value: function _onInitialZoomIn() {
				document.querySelector('.pswp__ui').classList.remove('pswp__ui--hidden');
				document.querySelector('.Header').style.opacity = '0'; // Add this line
			}
		}, {
			key: '_onInitialZoomOut',
			value: function _onInitialZoomOut() {
				document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden');
				document.querySelector('.Header').style.opacity = '1'; // Add this line
			}

			/**
			 * PhotoSwipe instance is automatically destroyed for us when it's closed. What we need to do is simply re-set
			 * our in-memory instance to null and our own events
			 */

		}, {
			key: '_destroyPhotoSwipe',
			value: function _destroyPhotoSwipe() {
				this.delegateRoot.off('pswpTap');
				this.photoSwipeInstance = null;
			}
		}]);

		return ProductImageZoom;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductImageZoom;

	/***/
},
/* 15 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Responsive__ = __webpack_require__(1);

	var ProductModel = function () {
		function ProductModel(element, stackProductImages) {
			_classCallCheck(this, ProductModel);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.delegateRoot = new domDelegate.Delegate(document.documentElement);
			this.stackProductImages = stackProductImages;

			this._attachListeners();

			var stylesheet = document.createElement('link');
			stylesheet.rel = 'stylesheet';
			stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
			document.head.appendChild(stylesheet);

			window.Shopify.loadFeatures([{
				name: 'model-viewer-ui',
				version: '1.0',
				onLoad: this._setupModelViewerUI.bind(this)
			}, {
				name: 'shopify-xr',
				version: '1.0'
			}]);
		}

		_createClass(ProductModel, [{
			key: '_attachListeners',
			value: function _attachListeners() {
				var _this12 = this;

				this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_play', function () {
					_this12.element.dispatchEvent(new CustomEvent('model:played', { bubbles: true }));
				});
				this.element.querySelector('model-viewer').addEventListener('shopify_model_viewer_ui_toggle_pause', function () {
					_this12.element.dispatchEvent(new CustomEvent('model:paused', { bubbles: true }));
				});
			}
		}, {
			key: 'hasBeenSelected',
			value: function hasBeenSelected() {
				// As per guidelines, we only need to autoplay when it's not a touch device
				if (__WEBPACK_IMPORTED_MODULE_0__helper_Responsive__["default"].matchesBreakpoint('supports-hover')) {
					this.modelUi.play();
				}
			}
		}, {
			key: 'hasBeenDeselected',
			value: function hasBeenDeselected() {
				// In all cases, we just turn it off
				this.modelUi.pause();
			}
		}, {
			key: '_setupModelViewerUI',
			value: function _setupModelViewerUI() {
				this.modelElement = this.element.querySelector('model-viewer');
				this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement);
			}
		}]);

		return ProductModel;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductModel;

	/***/
},
/* 16 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);

	var ProductReviews = function () {
		function ProductReviews(container) {
			_classCallCheck(this, ProductReviews);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);

			var __this = this;
			this._relocateReviewsContent(window.innerWidth);
			window.addEventListener("resize", function(event){
				__this._relocateReviewsContent(event.target.innerWidth);
			});

		}

		_createClass(ProductReviews, [{
			key: 'destroy',
			value: function destroy() {
				this.delegateElement.off();
			}
		}, {
			key: '_relocateReviewsContent',
			value: function _relocateReviewsContent(windowWidth) {
				var reviewsContent = document.getElementById("shopify-product-reviews");
				var rowTabSelector = document.getElementById("reviews-first_instance");
				var collapsibleTabSelector = document.getElementById("reviews-second_instance");
				if (windowWidth < 769 && collapsibleTabSelector) {
					collapsibleTabSelector.append(reviewsContent);
				} else {
					// enable to enable reviews part on desktop
					// rowTabSelector.append(reviewsContent);
				}
			}
		}]);

		return ProductReviews;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductReviews;

	/***/
},
/* 17 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__ = __webpack_require__(5);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__helper_Currency__ = __webpack_require__(8);
	/**
	 * Variant selector is a bit similar to the popover, but due to some differences, I've created a distinct class
	 */

	var VariantSelector = function () {
		function VariantSelector(element, parentProductVariants) {

			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

			_classCallCheck(this, VariantSelector);

			this.element = element;
			this.parentProductVariants = parentProductVariants;
			this.delegateElement = new domDelegate.Delegate(this.element);

			this.activator = options['activator'] || document.querySelector('[aria-controls="' + element.getAttribute('id') + '"]');
			this.onValueChangedCallback = options['onValueChanged'] || function () {};
			this.isOpen = false;

			this.pageOverlayElement = document.querySelector('.PageOverlay');

			this.variantChoiceList = __WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.VariantSelector__Choice'));
			this.variantCarousel = new __WEBPACK_IMPORTED_MODULE_1__Carousel__["default"](this.element.querySelector('.VariantSelector__Carousel'), {
				onSelect: this._variantChanged.bind(this),
				onClick: this._variantSelected.bind(this)
			});

			this._attachListeners();
		}

		_createClass(VariantSelector, [{
			key: 'destroy',
			value: function destroy() {
				this.element.removeEventListener('keyup', this._handleKeyboardListener);
				this.delegateElement.off('click');
				this.activator.removeEventListener('click', this._toggleListener);
				this.variantCarousel.destroy();
			}
		}, {
			key: 'toggle',
			value: function toggle() {
				this.isOpen ? this.close() : this.open();
			}
		}, {
			key: 'open',
			value: function open() {
				if (this.isOpen) {
					return;
				}
				this.element.setAttribute('aria-hidden', 'false');
				this.activator.setAttribute('aria-expanded', 'true');

				__WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].trapFocus(this.element, 'variant-selector');

				document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open

				this.element.setAttribute('style', '');
				this.pageOverlayElement.classList.add('is-visible');
				this.pageOverlayElement.addEventListener('click', this._closeListener);

				this.isOpen = true;
			}
		}, {
			key: 'close',
			value: function close() {
				if (!this.isOpen) {
					return;
				}

				this.element.setAttribute('aria-hidden', 'true');
				this.activator.setAttribute('aria-expanded', 'false');

				__WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].removeTrapFocus(this.element, 'variant-selector');

				document.documentElement.classList.remove('no-scroll');

				this.pageOverlayElement.classList.remove('is-visible');
				this.pageOverlayElement.removeEventListener('click', this._closeListener);

				this.isOpen = false;
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._handleKeyboardListener = this._handleKeyboard.bind(this);
				this._closeListener = this.close.bind(this);
				this._toggleListener = this.toggle.bind(this);

				this.element.addEventListener('keyup', this._handleKeyboardListener);
				this.activator.addEventListener('click', this._toggleListener);
				this.delegateElement.on('click', '[data-action="select-variant"]', this._onVariantSelect.bind(this));

				this.parentProductVariants.delegateElement.on('variant:changed', this._onVariantChanged.bind(this));

			}

			/**
			 * Called when the variant is changed (but not yet selected)
			 */

		}, {
			key: '_variantChanged',
			value: function _variantChanged(selectedIndex) {
				var activeChoice = this.variantChoiceList[selectedIndex];

				activeChoice.classList.add('is-selected');
				__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].getSiblings(activeChoice, '.is-selected').forEach(function (item) {
					return item.classList.remove('is-selected');
				});
			}

			/**
			 * Called when a variant is clicked or selected
			 */

		}, {
			key: '_variantSelected',
			value: function _variantSelected(cellElement, cellIndex) {

				if (this.variantCarousel.getSelectedIndex() === cellIndex) {
					this.onValueChangedCallback(cellElement.getAttribute('data-option-value'), cellElement, this.activator);
					this.close();
				} else {
					this.variantCarousel.selectCell(cellIndex);
				}
			}
		}, {
			key: '_onVariantChanged',
			value: function _onVariantChanged(event) {
				var _this13 = this;

				var selectedVariant = event.detail.variant,
						imageWrapperElements = this.element.querySelectorAll('.VariantSelector__ImageWrapper'),
						found = false;

				__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(imageWrapperElements).forEach(function (image) {
					var colorPosition = parseInt(image.parentElement.getAttribute('data-option-position')) - 1,
							combinationExcludedColor = '';

					selectedVariant.options.forEach(function (optionValue, index) {
						if (index !== colorPosition) {
							combinationExcludedColor += optionValue;
						}
					});

					if (image.getAttribute('data-variant-title') === combinationExcludedColor) {
						image.setAttribute('aria-hidden', 'false');
						found = true;
					} else {
						image.setAttribute('aria-hidden', 'true');
					}
				});

				if (!found) {
					imageWrapperElements.children[0].setAttribute('aria-hidden', 'false');
				}

				var foundColorIndex = 0;

				__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.VariantSelector__ChoicePrice')).forEach(function (priceElement, index) {
					var colorPosition = parseInt(priceElement.getAttribute('data-color-position')) - 1;

					_this13.parentProductVariants.productData['variants'].forEach(function (variant) {
						var matchOptionsExcludedColor = true;

						variant['options'].forEach(function (option, index) {
							if (index !== colorPosition) {
								if (variant['options'][index] !== selectedVariant['options'][index]) {
									matchOptionsExcludedColor = false;
								}
							}
						});

						if (matchOptionsExcludedColor && variant['options'][colorPosition] === selectedVariant['options'][colorPosition]) {
							if (foundColorIndex++ === index) {
								priceElement.innerHTML = '<span class="Heading Text--subdued">' + __WEBPACK_IMPORTED_MODULE_3__helper_Currency__["default"].formatMoney(variant['price'], window.theme.moneyFormat) + '</span>';
							}
						}
					});
				});
			}

			/**
			 * Called when the button "choose this variant" is explicitly clicked
			 */

		}, {
			key: '_onVariantSelect',
			value: function _onVariantSelect() {
				var selectedCell = this.variantCarousel.flickityInstance.selectedCell.element;

				this.onValueChangedCallback(selectedCell.getAttribute('data-option-value'), selectedCell, this.activator);
				this.close();
			}

			/**
			 * Handle a11y events
			 */

		}, {
			key: '_handleKeyboard',
			value: function _handleKeyboard(event) {
				if (this.isOpen && event.keyCode === 27) {
					this.close();
				}
			}
		}]);

		return VariantSelector;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = VariantSelector;

	/***/
},
/* 18 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Responsive__ = __webpack_require__(1);

	var ProductVideo = function () {
		function ProductVideo(element, stackProductImages, enableVideoLooping) {
			_classCallCheck(this, ProductVideo);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.stackProductImages = stackProductImages;
			this.enableVideoLooping = enableVideoLooping;
			this.player = null;

			switch (this.element.getAttribute('data-media-type')) {
				case 'video':
					var stylesheet = document.createElement('link');
					stylesheet.rel = 'stylesheet';
					stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
					document.head.appendChild(stylesheet);

					window.Shopify.loadFeatures([{
						name: 'video-ui',
						version: '1.0',
						onLoad: this._setupHtml5Video.bind(this)
					}]);
					break;

				case 'external_video':
					this._setupExternalVideo();
					break;
			}
		}

		_createClass(ProductVideo, [{
			key: 'destroy',
			value: function destroy() {
				if (this.player) {
					this.player.destroy(); // Both Plyr and YouTube API use the same name
				}
			}
		}, {
			key: 'hasBeenSelected',
			value: function hasBeenSelected() {
				// As per guidelines, we only need to autoplay when it's not a touch device
				if (__WEBPACK_IMPORTED_MODULE_0__helper_Responsive__["default"].matchesBreakpoint('supports-hover')) {
					this.play();
				}
			}
		}, {
			key: 'hasBeenDeselected',
			value: function hasBeenDeselected() {
				this.pause();
			}
		}, {
			key: 'play',
			value: function play() {
				switch (this.element.getAttribute('data-media-type')) {
					case 'video':
						this.player.play();
						break;

					case 'external_video':
						this.player.playVideo();
						break;
				}
			}
		}, {
			key: 'pause',
			value: function pause() {
				switch (this.element.getAttribute('data-media-type')) {
					case 'video':
						this.player.pause();
						break;

					case 'external_video':
						this.player.pauseVideo();
						break;
				}
			}
		}, {
			key: '_setupHtml5Video',
			value: function _setupHtml5Video() {
				var _this14 = this;

				this.player = new Shopify.Plyr(this.element.querySelector('video'), {
					controls: ['play', 'progress', 'mute', 'volume', 'play-large', 'fullscreen'],
					loop: { active: this.enableVideoLooping },
					hideControlsOnPause: true,
					clickToPlay: true,
					iconUrl: '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
					tooltips: {
						controls: false,
						seek: true
					}
				});

				this.player.on('play', function () {
					_this14.element.dispatchEvent(new CustomEvent('video:played', { bubbles: true }));
				});
				this.player.on('pause', function () {
					_this14.element.dispatchEvent(new CustomEvent('video:paused', { bubbles: true }));
				});
			}
		}, {
			key: '_setupExternalVideo',
			value: function _setupExternalVideo() {
				if (this.element.getAttribute('data-video-host') === 'youtube') {
					this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this));
				}
			}
		}, {
			key: '_setupYouTubePlayer',
			value: function _setupYouTubePlayer() {
				var _this15 = this;

				var playerLoadingInterval = setInterval(function () {
					if (window.YT !== undefined && window.YT.Player !== undefined) {
						_this15.player = new YT.Player(_this15.element.querySelector('iframe'), {
							videoId: _this15.element.getAttribute('data-video-id'),
							events: {
								onStateChange: function onStateChange(event) {
									if (event.data === window.YT.PlayerState.PLAYING) {
										_this15.element.dispatchEvent(new CustomEvent('video:played', { bubbles: true }));
									} else if (event.data === YT.PlayerState.PAUSED) {
										_this15.element.dispatchEvent(new CustomEvent('video:paused', { bubbles: true }));
									}

									if (event.data === window.YT.PlayerState.ENDED && _this15.enableVideoLooping) {
										event.target.seekTo(0);
									}
								}
							}
						});

						clearInterval(playerLoadingInterval);
					}
				}, 50);
			}
		}, {
			key: '_loadYouTubeScript',
			value: function _loadYouTubeScript() {
				return new Promise(function (resolve, reject) {
					var script = document.createElement('script');
					document.body.appendChild(script);
					script.onload = resolve;
					script.onerror = reject;
					script.async = true;
					script.src = '//www.youtube.com/iframe_api';
				});
			}
		}]);

		return ProductVideo;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductVideo;

	/***/
},
/* 19 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/**
	 * This code has been heavily inspired by this: https://kitaitimakoto.gitlab.io/scrollspy-example/index.en.html#whatsthis
	 */

	var ScrollSpy = function () {
		function ScrollSpy(container, elementsToSpy, observerOptions) {
			var _this16 = this;

			_classCallCheck(this, ScrollSpy);

			this.container = container;
			this.targets = [];
			this.targetIndices = {};
			this.indicesInViewPort = [];

			this.observer = new IntersectionObserver(this._onIntersectionChange.bind(this), observerOptions);

			elementsToSpy.forEach(function (elementToSpy, index) {
				_this16.targets.push(elementToSpy);
				_this16.targetIndices[elementToSpy.id] = index;
				_this16.observer.observe(elementToSpy);
			});
		}

		_createClass(ScrollSpy, [{
			key: 'destroy',
			value: function destroy() {
				this.observer.disconnect();
			}

			/**
			 * Called whenever there is a change of visibility
			 */

		}, {
			key: '_onIntersectionChange',
			value: function _onIntersectionChange(changes) {
				var oldTargetIndex = this.indicesInViewPort[0] || 0;

				for (var i = changes.length - 1; i >= 0; i--) {
					this._updateIndicesInViewPort(changes[i], oldTargetIndex);
				}

				// Firefox generates duplicates so make sure to remove
				this.indicesInViewPort = this.indicesInViewPort.filter(function (value, index, self) {
					return self.indexOf(value) === index;
				});

				if (this.indicesInViewPort.length === 0 || oldTargetIndex === this.indicesInViewPort[0]) {
					return;
				}

				var event = new CustomEvent('scrollspy:target:changed', {
					detail: {
						newTarget: this.targets[this.indicesInViewPort[0]],
						oldTarget: this.targets[oldTargetIndex]
					}
				});

				this.container.dispatchEvent(event);
			}

			/**
			 * Update indices visible in the view port
			 */

		}, {
			key: '_updateIndicesInViewPort',
			value: function _updateIndicesInViewPort(change, oldTargetIndex) {
				var index = this.targetIndices[change.target.id];

				if (change.intersectionRatio === 0) {
					var indexInViewPort = this.indicesInViewPort.indexOf(index);

					if (indexInViewPort !== -1) {
						this.indicesInViewPort.splice(indexInViewPort, 1);
					}
				} else {
					if (index < oldTargetIndex) {
						this.indicesInViewPort.unshift(index);
					} else if (index > this.indicesInViewPort[this.indicesInViewPort.length - 1]) {
						this.indicesInViewPort.push(index);
					} else {
						this.indicesInViewPort.push(index);
						this.indicesInViewPort.sort();
					}
				}
			}
		}]);

		return ScrollSpy;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ScrollSpy;

	/***/
},
/* 20 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Animation__ = __webpack_require__(7);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Currency__ = __webpack_require__(8);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__CountrySelector__ = __webpack_require__(12);

	var ShippingEstimator = function () {
		function ShippingEstimator(element) {
			_classCallCheck(this, ShippingEstimator);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.countrySelector = new __WEBPACK_IMPORTED_MODULE_2__CountrySelector__["default"](this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));

			this._attachListeners();
		}

		_createClass(ShippingEstimator, [{
			key: 'onUnload',
			value: function onUnload() {
				this.delegateElement.off('click');
				this.countrySelector.destroy();
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '.ShippingEstimator__Submit', this._fetchRates.bind(this));
			}
		}, {
			key: '_fetchRates',
			value: function _fetchRates() {
				var _this17 = this;

				var country = this.element.querySelector('[name="country"]').value,
						province = this.element.querySelector('[name="province"]').value,
						zip = this.element.querySelector('[name="zip"]').value;

				document.dispatchEvent(new CustomEvent('theme:loading:start'));

				fetch(window.routes.cartUrl + '/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province, {
					credentials: 'same-origin',
					method: 'GET'
				}).then(function (response) {
					response.json().then(function (result) {
						document.dispatchEvent(new CustomEvent('theme:loading:end'));

						var resultsContainer = _this17.element.querySelector('.ShippingEstimator__Results'),
								errorContainer = _this17.element.querySelector('.ShippingEstimator__Error');

						if (response.ok) {
							var shippingRates = result['shipping_rates'];

							if (shippingRates.length === 0) {
								resultsContainer.innerHTML = '<p>' + window.languages.shippingEstimatorNoResults + '</p>';
							} else {
								var html = '';

								if (shippingRates.length === 1) {
									html += '<p>' + window.languages.shippingEstimatorOneResult + '</p><ul>';
								} else {
									html += '<p>' + window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length) + '</p><ul>';
								}

								shippingRates.forEach(function (item) {
									html += '<li>' + item['name'] + ': ' + __WEBPACK_IMPORTED_MODULE_1__helper_Currency__["default"].formatMoney(item['price'], window.theme.moneyFormat) + '</li>';
								});

								html += '</ul>';

								resultsContainer.firstElementChild.innerHTML = html;
							}

							TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, { autoAlpha: 0, y: -15 }, { autoAlpha: 1, y: 0, delay: 0.35 });

							errorContainer.style.display = 'none';
							resultsContainer.style.display = 'block';

							__WEBPACK_IMPORTED_MODULE_0__helper_Animation__["default"].slideDown(resultsContainer);
						} else {
							var errorHtml = '';

							Object.keys(result).forEach(function (key) {
								errorHtml += '<li class="Alert__ErrorItem">' + key + ' ' + result[key] + '</li>';
							});

							errorContainer.innerHTML = '<ul class="Alert__ErrorList">' + errorHtml + '</ul>';

							resultsContainer.style.display = 'none';
							errorContainer.style.display = 'block';
						}
					});
				});
			}
		}]);

		return ShippingEstimator;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ShippingEstimator;

	/***/
},
/* 21 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__Carousel__ = __webpack_require__(2);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Carousel", function () {
		return __WEBPACK_IMPORTED_MODULE_0__Carousel__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__Collapsible__ = __webpack_require__(23);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Collapsible", function () {
		return __WEBPACK_IMPORTED_MODULE_1__Collapsible__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__Drawer__ = __webpack_require__(6);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Drawer", function () {
		return __WEBPACK_IMPORTED_MODULE_2__Drawer__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__LoadingBar__ = __webpack_require__(24);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "LoadingBar", function () {
		return __WEBPACK_IMPORTED_MODULE_3__LoadingBar__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(25);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Modal", function () {
		return __WEBPACK_IMPORTED_MODULE_4__Modal__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__Popover__ = __webpack_require__(3);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "Popover", function () {
		return __WEBPACK_IMPORTED_MODULE_5__Popover__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__PageTransition__ = __webpack_require__(26);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "PageTransition", function () {
		return __WEBPACK_IMPORTED_MODULE_6__PageTransition__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__ProductItemColorSwatch__ = __webpack_require__(4);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductItemColorSwatch", function () {
		return __WEBPACK_IMPORTED_MODULE_7__ProductItemColorSwatch__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_8__ProductImageZoom__ = __webpack_require__(14);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductImageZoom", function () {
		return __WEBPACK_IMPORTED_MODULE_8__ProductImageZoom__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_9__ProductModel__ = __webpack_require__(15);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductModel", function () {
		return __WEBPACK_IMPORTED_MODULE_9__ProductModel__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_10__ProductReviews__ = __webpack_require__(16);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductReviews", function () {
		return __WEBPACK_IMPORTED_MODULE_10__ProductReviews__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_11__ProductVariants__ = __webpack_require__(11);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductVariants", function () {
		return __WEBPACK_IMPORTED_MODULE_11__ProductVariants__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_12__ProductVideo__ = __webpack_require__(18);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductVideo", function () {
		return __WEBPACK_IMPORTED_MODULE_12__ProductVideo__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_13__ScrollSpy__ = __webpack_require__(19);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ScrollSpy", function () {
		return __WEBPACK_IMPORTED_MODULE_13__ScrollSpy__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_14__SearchBar__ = __webpack_require__(28);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "SearchBar", function () {
		return __WEBPACK_IMPORTED_MODULE_14__SearchBar__["default"];
	});

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_57__SearchBarCustom__ = __webpack_require__(57);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "SearchBarCustom", function () {
		return __WEBPACK_IMPORTED_MODULE_57__SearchBarCustom__["default"];
	});

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_15__ShippingEstimator__ = __webpack_require__(20);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ShippingEstimator", function () {
		return __WEBPACK_IMPORTED_MODULE_15__ShippingEstimator__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_16__VariantSelector__ = __webpack_require__(17);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "VariantSelector", function () {
		return __WEBPACK_IMPORTED_MODULE_16__VariantSelector__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_17__RowTabs__ = __webpack_require__(59);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "RowTabs", function () {
		return __WEBPACK_IMPORTED_MODULE_17__RowTabs__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_18__WishList__ = __webpack_require__(67);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "WishList", function () {
		return __WEBPACK_IMPORTED_MODULE_18__WishList__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_19__IPDetection__ = __webpack_require__(69);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "IPDetection", function () {
		return __WEBPACK_IMPORTED_MODULE_19__IPDetection__["default"];
	});
	/***/
},
/* 22 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/**
	 * This implementation allows to serialize a form
	 */

	var Form = function () {
		function Form() {
			_classCallCheck(this, Form);
		}

		_createClass(Form, null, [{
			key: 'serialize',
			value: function serialize(form) {
				function stringKey(key, value) {
					var beginBracket = key.lastIndexOf('[');

					if (beginBracket === -1) {
						var _hash = {};
						_hash[key] = value;
						return _hash;
					}

					var newKey = key.substr(0, beginBracket);
					var newValue = {};

					newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

					return stringKey(newKey, newValue);
				}

				var hash = {};

				for (var i = 0, len = form.elements.length; i < len; i++) {
					var formElement = form.elements[i];

					if (formElement.name === '' || formElement.disabled) {
						continue;
					}

					if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
						var stringKeys = stringKey(formElement.name, formElement.value);
						hash = Form.extend(hash, stringKeys);
					}
				}

				return hash;
			}
		}, {
			key: 'extend',
			value: function extend() {
				var extended = {};
				var i = 0;

				// Merge the object into the extended object
				var merge = function merge(obj) {
					for (var prop in obj) {
						if (obj.hasOwnProperty(prop)) {
							// If property is an object, merge properties
							if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
								extended[prop] = Form.extend(extended[prop], obj[prop]);
							} else {
								extended[prop] = obj[prop];
							}
						}
					}
				};

				// Loop through each object and conduct a merge
				for (; i < arguments.length; i++) {
					merge(arguments[i]);
				}

				return extended;
			}
		}]);

		return Form;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Form;

	/***/
},
/* 23 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Animation__ = __webpack_require__(7);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__ = __webpack_require__(1);
	/**
	 * Handle the collapsibles. This plugin is global, so it listens to any click on [data-action="toggle-collapsible"] element
	 */

	var Collapsible = function () {
		function Collapsible() {
			_classCallCheck(this, Collapsible);

			this.domDelegate = new domDelegate.Delegate(document.body);
			this._attachListeners();
		}

		_createClass(Collapsible, [

		{
			key: '_attachListeners',
			value: function _attachListeners() {
				this.domDelegate.on('click', '[data-action="toggle-collapsible"]', this._toggleCollapsible.bind(this));
				this.domDelegate.on("collapsible:force-close", this._forceClose.bind(this));
			}

			/**
			 * Toggle a given collapsible
			 */

		}, {
			key: '_toggleCollapsible',
			value: function _toggleCollapsible(event, target) {
				var _this18 = this;
				// If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
				var parentCollapsible = target.closest('.Collapsible');

				if (parentCollapsible.classList.contains('Collapsible--autoExpand') && __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__["default"].matchesBreakpoint('tablet-and-up')) {
					return;
				}

				if (
					target.getAttribute('data-target-tab-mobile') === 'reviews_tab' &&
					!parentCollapsible.dataset.reviewsLoaded
				) {
					// Get productId from a data attribute or JS variable
					const productId = target.getAttribute('data-product-id'); // adjust as needed
				
					loadAndRenderReviews(
					productId,
					parentCollapsible // or the element containing your .custom-reviews-list/.custom-reviews-pagination
					// No need to pass a height handler for mobile
					);
					parentCollapsible.dataset.reviewsLoaded = "true";
				}

				var isOpen = target.getAttribute('aria-expanded') === 'true';
				let hideSiblings = target.closest("[data-collapsible-sibling]") ? true : false;

				if (isOpen) {
					this._close(parentCollapsible, target);
					if(hideSiblings) {
						this._showSiblings(target);
					}
				} else {
					this._open(parentCollapsible, target);
					if (hideSiblings) {
						this._hideSiblings(target);
					}
				}

				// We make sure to close any siblings collapsible as well
				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].getSiblings(parentCollapsible).forEach(function (collapsibleToClose) {
					return _this18._close(collapsibleToClose);
				});
				event.preventDefault();
			}

			/**
			 * Open a given collapsible
			 */

		}, {
			key: '_open',
			value: function _open(collapsible) {
				var toggleButton = collapsible.querySelector('.Collapsible__Button'),
						collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

				if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'true') {
					return; // It's already open
				}

				toggleButton.setAttribute('aria-expanded', 'true');
				collapsibleInner.style.overflow = 'visible';
				__WEBPACK_IMPORTED_MODULE_0__helper_Animation__["default"].slideDown(collapsibleInner);
			}

			/**
			 * Close a given collapsible
			 */

		}, {
			key: '_close',
			value: function _close(collapsible) {
				var toggleButton = collapsible.querySelector('.Collapsible__Button'),
						collapsibleInner = collapsible.querySelector('.Collapsible__Inner');

				if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
					return; // It's already closed
				}

				toggleButton.setAttribute('aria-expanded', 'false');
				collapsibleInner.style.overflow = 'hidden';
				__WEBPACK_IMPORTED_MODULE_0__helper_Animation__["default"].slideUp(collapsibleInner);
			}
		}, {
			key: "_forceClose",
			value: function _forceClose(event, target) {
				let _this = this;

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(event.detail.container.querySelectorAll('.Collapsible')).forEach(function (collapsible) {
					_this._close(collapsible);
				});

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(event.detail.container.querySelectorAll('[data-collapsible-sibling]')).forEach(element=>{
					if (element != target.parentNode) {
						$(element).slideDown(350);
					}
				});

			}
		}, {
			key: "_hideSiblings",
			value: function _hideSiblings(target) {
				let elements = target.parentNode.parentNode.querySelectorAll("[data-collapsible-sibling]");
				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(elements).forEach(element=>{
					if (element != target.parentNode) {
						$(element).slideUp(350);
					}
				});
			}
		}, {
			key: "_showSiblings",
			value: function _hideSiblings(target) {
				let elements = target.parentNode.parentNode.querySelectorAll("[data-collapsible-sibling]");
				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(elements).forEach(element=>{
					if (element != target.parentNode) {
						$(element).slideDown(350);
					}
				});
			}
		}]);

		return Collapsible;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Collapsible;

	/***/
},
/* 24 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/**
	 * Simple plugin that handles the loading bar actions
	 *
	 * This plugin uses delegate events so it's independent of the sections.
	 */

	var LoadingBar = function () {
		function LoadingBar() {
			_classCallCheck(this, LoadingBar);

			this.element = document.querySelector('.LoadingBar');

			document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
			document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));

			this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
		}

		_createClass(LoadingBar, [{
			key: '_onLoadingStart',
			value: function _onLoadingStart() {
				this.element.classList.add('is-visible');
				this.element.style.width = '40%';
			}
		}, {
			key: '_onLoadingEnd',
			value: function _onLoadingEnd() {
				this.element.style.width = '100%';
				this.element.classList.add('is-finished');
			}
		}, {
			key: '_onTransitionEnd',
			value: function _onTransitionEnd(event) {
				if (event.propertyName === 'width' && this.element.classList.contains('is-finished')) {
					this.element.classList.remove('is-visible');
					this.element.classList.remove('is-finished');
					this.element.style.width = '0';
				}
			}
		}]);

		return LoadingBar;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = LoadingBar;

	/***/
},
/* 25 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__ = __webpack_require__(5);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__components_RowTabs__ = __webpack_require__(59);

	/**
	 * Handle the modals. This plugin is global, so it basically listens to any click on [data-action="open-modal"] and
	 * [data-action="close-modal"] events
	 */

	var Modal = function () {
		function Modal() {
			_classCallCheck(this, Modal);

			this.domDelegate = new domDelegate.Delegate(document.body);
			this.activeModal = null; // Keep track of the active modal
			this.wasLocked = false;
			
			this.pageOverlayElement = document.querySelector('.PageOverlay');

			this._attachListeners();
			this._checkOpenByHash();
		}

		_createClass(Modal, [{
			key: '_attachListeners',
			value: function _attachListeners() {
				this._closeListener = this._closeModal.bind(this);
				this._handleKeyboardListener = this._handleKeyboard.bind(this);
				
				this.domDelegate.on('click', '[data-action="open-modal"]', this._openModalEvent.bind(this));
				this.domDelegate.on('click', '[data-action="close-modal"]', this._closeModal.bind(this));
				this.domDelegate.on('click', '[data-mesurment]', this._toggleUnits.bind(this));
				this.domDelegate.on('click', '[data-toggle-size-conversion]', this._toggleTables.bind(this));
			}
		}, {
			key: '_openModalEvent',
			value: function _openModalEvent(event, target) {
				this._openModal(document.getElementById(target.getAttribute('aria-controls')));

				let targetButtonProductHandle = target.dataset.handle;
				document.getElementById(target.getAttribute('aria-controls')).dataset.handle = targetButtonProductHandle;

				event.preventDefault();
				event.stopPropagation();
			}
		}, {
			key: '_openModal',
			value: function _openModal(modal) {
				var _this19 = this;
		
				if (!modal) {
					return; // If no modal is provided, exit
				}
		
				// Initialize openModals array if it doesn't exist
				if (!this.openModals) {
					this.openModals = [];
				}
		
				// Add the modal to the stack of open modals
				this.openModals.push(modal);
				this.activeModal = modal;  // Set the activeModal to the most recently opened modal
		
				this.domDelegate.on('keyup', this._handleKeyboardListener);

				this._toggleRelevantSizeTable();
		
				fastdom.mutate(function () {
					_this19.activeModal.setAttribute('aria-hidden', 'false');
					document.documentElement.classList.add('no-scroll');
		
					// Look for the button that triggered the modal (from the last clicked element)
					const lastTriggeringButton = _this19.activeModal.dataset.handle;

		
					if (lastTriggeringButton && _this19.activeModal.id == "quick-buy-modal") {
						const productHandle = lastTriggeringButton;
						if (productHandle) {
							console.log('Product handle found:', productHandle);
							_this19._loadProductData(productHandle); // Fetch and inject product info
						} else {
							console.log('No product handle found for modal.');
						}
					} else {
						console.log('No triggering button found.');
					}
				});
			}
		}, {
			key: '_closeModal',
			value: function _closeModal() {
				var _this20 = this;
		
				if (!this.activeModal || !this.openModals || this.openModals.length === 0) {
					return; // If no modal is open, exit
				}
		
				// Get the last opened modal (top of the stack)
				const modalToClose = this.openModals.pop();  // Remove the last opened modal from the stack
		
				// Ensure the modal to close is a valid DOM element
				if (!modalToClose) {
					console.error('Modal to close is not valid.');
					return;
				}
		
				modalToClose.removeEventListener('keyup', this._handleKeyboardListener);
				this.domDelegate.off('keyup');
		
				fastdom.mutate(function () {
					// Handle video content if applicable
					if (modalToClose.classList.contains('Modal--videoContent')) {
						_this20._resetVideoListener = _this20._resetVideo.bind(_this20);
						modalToClose.addEventListener('transitionend', _this20._resetVideoListener);
					}
		
					__WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].removeTrapFocus(modalToClose, 'modal');
		
					if (!modalToClose.classList.contains('Modal--fullScreen')) {
						_this20.pageOverlayElement.classList.remove('is-visible');
						_this20.pageOverlayElement.removeEventListener('click', _this20._closeListener);
					}
		
					modalToClose.setAttribute('aria-hidden', 'true');
		
					// Check if this modal is the quick-buy modal and clear its contents
					if (modalToClose.id === 'quick-buy-modal') {
						console.log('Clearing contents of quick-buy modal.');
						modalToClose.querySelector('#quick-buy-content').innerHTML = ''; // Clear the contents
					}
		
					// If there are no more modals, clear activeModal
					if (_this20.openModals.length === 0) {
						_this20.activeModal = null;
					} else {
						// Set activeModal to the last opened modal (top of the stack)
						_this20.activeModal = _this20.openModals[_this20.openModals.length - 1];
					}
		
					if (!_this20.wasLocked) {
						document.documentElement.classList.remove('no-scroll');
					}
				});
			}
		}, 
		{
			key: '_loadProductData',
			value: function _loadProductData(handle) {
				const _this = this;
				console.log('Fetching product data for handle:', handle);
				// Fetch product data via the product's handle
				fetch(`/products/${handle}`)
					.then(response => response.text())
					.then(html => {
						console.log('Product data fetched successfully');
						const tempDiv = document.createElement('div');
						tempDiv.innerHTML = html;
						const productSection = tempDiv.querySelector('.Product.Product--medium'); // Select the section container
						if (productSection) {
							console.log('Product section found. Injecting into modal.');
							// Inject the product data into the modal
							_this.activeModal.querySelector('#quick-buy-content').innerHTML = productSection.outerHTML;
							// Initialize the carousel (slideshow) inside the modal after the product content is injected
							const modalSlideshowElement = _this.activeModal.querySelector('.Product__Slideshow'); // Use the correct selector

							modalSlideshowElement.classList.remove('Product__Slideshow--zoomable');

							if (modalSlideshowElement) {
								const flickityConfig = {
									cellAlign: 'left',
									contain: true,
									wrapAround: true,
									prevNextButtons: false,
									pageDots: true,
									draggable: true
								};
						
								// Initialize Flickity for the modal slideshow
								const flickityInstance = new Flickity(modalSlideshowElement, flickityConfig);
								flickityInstance.resize();
						
							} else {
								console.error('No slideshow element found inside modal.');
							}

							_this.tabs = new __WEBPACK_IMPORTED_MODULE_4__components_RowTabs__["default"](_this.activeModal.querySelector('.Product.Product--medium'));

							yotpoWidgetsContainer.initWidgets();

							// size guide
							let sizeGuideButton = _this.activeModal.querySelector('.size_guide-button');
							let sizeGuidePopup = _this.activeModal.querySelector('#modal-size-chart');
							if (sizeGuideButton && sizeGuidePopup) {
								sizeGuidePopup.setAttribute('id', 'quick-buy-modal-inside');
								sizeGuideButton.setAttribute('aria-controls', 'quick-buy-modal-inside');
							}

							// Extract the product JSON from the <script> tag
							const productJsonScript = _this.activeModal.querySelector('script[data-product-json]');
							const productJsonString = productJsonScript.innerHTML.trim();
							if (productJsonScript) {
								try {
									const productJson = JSON.parse(productJsonString);  // Parse the JSON inside the <script> tag
									console.log('Product JSON extracted:', productJson);
								
									// Set the ENTIRE product JSON as a data attribute on the product form for ProductVariants to use
									const modalProductForm = _this.activeModal.querySelector('.ProductForm');
									if (modalProductForm) {

										// Now initialize ProductVariants using the section container, not the form
										const modalSectionContainer = _this.activeModal.querySelector('.Product.Product--medium');

										let modalSectionContainerOptions = modalSectionContainer.getAttribute('data-section-settings');

										if (modalSectionContainerOptions) {
											try {
												modalSectionContainerOptions = JSON.parse(modalSectionContainerOptions); // Ensure it's parsed
												const productVariantsInstance = new window.ProductVariants(modalSectionContainer, modalSectionContainerOptions);
												const newVariant = productVariantsInstance.currentVariant;
												if (newVariant && newVariant.id) {
													console.log('Variant ID found, reinitializing ProductVariants.');
												} else {
													console.error('No valid variant ID found.');
												}
											} catch (error) {
												console.error('Error parsing section settings:', error);
												modalSectionContainerOptions = {}; // Fallback to an empty object if parsing fails
											}
										}
									}
								} catch (error) {
									console.error('Error parsing product JSON:', error);
								}
							} else {
								console.error('No product JSON script found in modal.');
							}
						} else {
							console.log('Product wrapper not found.');
						}
					})
					.catch(error => {
						console.error('Error fetching product data:', error);
					});
			}
		},
		{
			key: '_onTransitionEnded',
			value: function _onTransitionEnded(event) {
				if (event.propertyName !== 'visibility') {
					return;
				}

				__WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].trapFocus(this.activeModal, 'modal'); // Trap the focus first (as this trigger reflows)

				this.activeModal.removeEventListener('transitionend', this._onTransitionEndedListener);
			}
		}, {
			key: '_resetVideo',
			value: function _resetVideo(event) {
				if (event.propertyName !== 'visibility') {
					return; // We check the visibility property as it's the one LazySizes uses for triggering lazyloading
				}

				var iframe = event.target.querySelector('iframe');
				iframe.parentNode.innerHTML = '<iframe class="Image--lazyLoad" data-src=' + iframe.getAttribute('data-src') + ' frameborder="0" allowfullscreen>';

				event.target.removeEventListener('transitionend', this._resetVideoListener);
			}

			/**
			 * Some forms needs to be open inside a modal, and on page reload we must make sure to properly open the modal again
			 */

		}, {
			key: '_checkOpenByHash',
			value: function _checkOpenByHash() {
				var hash = window.location.hash,
						modal = document.getElementById(hash.replace('#', ''));

				if (modal && modal.classList.contains('Modal')) {
					this._openModal(modal);
				}
			}

			/**
			 * Handle a11y events
			 */

		}, {
			key: '_handleKeyboard',
			value: function _handleKeyboard(event) {
				if (null !== this.activeModal && event.keyCode === 27) {
					this._closeModal();
				}
			}
		}, {
			key: '_toggleUnits',
			value: function _toggleUnits(event, target) {
				let buttons = document.querySelectorAll("[data-mesurment]");
				for (let button of buttons) {
					if (target.dataset.mesurment === button.dataset.mesurment) {
						button.classList.remove("Button--secondary");
						button.classList.add("Button--primary");
					} else {
						button.classList.remove("Button--primary");
						button.classList.add("Button--secondary");
					}
				}
				let container = target.closest(".page_content");
				let unitSpans = container.querySelectorAll("span:is(.inches, .cms)");
				for (let span of unitSpans) {
					if(target.dataset.mesurment === span.classList.value) {
						span.style.display = "block";
					} else {
						span.style.display = "none";
					}
				}
				let mesurmentsSpans = container.querySelectorAll(".MeasurmentsUnits");
				let mesurmentsValue = "";
				if (target.getAttribute("data-mesurment") == "cms") {
					mesurmentsValue = "cm"
				} else {
					mesurmentsValue = "in"
				}
				for (let span of mesurmentsSpans) {
					span.textContent = mesurmentsValue;
				}
			}
		}, {
			key: '_toggleTables',
			value: function _toggleTables(event, target) {
				if (target.classList.contains("Active")) return;
				let show = target.dataset.toggleSizeConversion === "true";
				let targetTable = document.querySelector(".SizeConversion");
				Array.from(document.querySelectorAll("[data-toggle-size-conversion]")).forEach(button => {
					if (button === target) {
						button.classList.add("Active")
					} else {
						button.classList.remove("Active")
					}
				});
				if (show) {
					targetTable.setAttribute("aria-hidden", false);
				} else {
					targetTable.setAttribute("aria-hidden", true);
				}
			}
		}, {
			key: "_toggleRelevantSizeTable",
			value: function _toggleRelevantSizeTable() {
				var _this = this;
				// Look for the size chart modal inside the active modal
				let targetModal = _this.activeModal;
				// Check if the modal contains the 'SizeChart' class
				if (targetModal && targetModal.classList.contains('SizeChart')) {
					console.log('Size chart modal found.');
				} else {
					return;  // Exit if the size chart modal is not found
				}
				// Find the relevant product info inside the active modal
				let element = targetModal.querySelector(".Modal--product_info");
				if (!element) {
					console.error('Product info not found in modal.');
					return;
				}
				// Get the relevant table ID and other data
				let targetTableID = element.dataset.targetTable;
				let tables = targetModal.querySelectorAll(".table_container[data-table-name]");
				console.log(tables);
				console.log(targetTableID);
				if (targetTableID !== "none") {
					for (let table of tables) {
						// Toggle the visibility of tables based on the product info
						if (table.dataset.tableName !== targetTableID) {
							table.style.display = "none";
						} else {
							// Update the table title if necessary
							if (element.dataset.targetTableTitle !== '') {
								let tableTitle = table.querySelector(".table_header");
								if (window.theme.shopLocation == "US" && element.dataset.targetTableTitle.includes("Trouser")) {
									element.dataset.targetTableTitle = element.dataset.targetTableTitle.replace("Trouser", "Pant");
									tableTitle.textContent = element.dataset.targetTableTitle;
								} else {
									tableTitle.textContent = element.dataset.targetTableTitle;
								}
							}
						}
					}
				}
			}
		}]);

		return Modal;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = Modal;

	/***/
},
/* 26 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/**
	 * This class will coordinate all the transitions from the website
	 */

	var PageTransition = function () {
		_createClass(PageTransition, null, [{
			key: 'getInstance',
			value: function getInstance() {
				if (!this.instance) {
					this.instance = new PageTransition();
				}

				return this.instance;
			}
		}]);

		function PageTransition() {
			_classCallCheck(this, PageTransition);

			this.domDelegate = new domDelegate.Delegate(document.body);
			this.pageTransition = document.querySelector('.PageTransition');

			this._attachListeners();
		}

		_createClass(PageTransition, [{
			key: '_attachListeners',
			value: function _attachListeners() {
				this.domDelegate.on('click', 'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])', this._onPageUnload.bind(this));
			}

			/**
			 * This callback captures click and transition from one page to another by doing a transition
			 */

		}, {
			key: '_onPageUnload',
			value: function _onPageUnload(event, target) {
				var _this21 = this;

				if (event.defaultPrevented || event.ctrlKey || event.metaKey || !window.theme.showPageTransition || !this.pageTransition) {
					return;
				}

				event.preventDefault(); // Prevent the click to happen

				if (window.theme.showPageTransition && this.pageTransition) {
					var doTransition = function doTransition(event) {
						// Animation is finished, we can transition
						if (event.propertyName === 'opacity') {
							_this21.pageTransition.removeEventListener('transitionend', doTransition);
							window.location.href = target.href;
						}
					};

					this.pageTransition.addEventListener('transitionend', doTransition);

					this.pageTransition.style.visibility = 'visible';
					this.pageTransition.style.opacity = '1';
				}
			}
		}]);

		return PageTransition;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = PageTransition;

	/***/
},
/* 27 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Drawer__ = __webpack_require__(6);

	/**
	 * Handle the store availability management. The parameter is the div that will hold the content. The function
	 * "updateWithVariant" must be called whenever the variant is changed.
	 */

	var StoreAvailability = function () {
		function StoreAvailability(element, productTitle) {
			_classCallCheck(this, StoreAvailability);

			this.element = element;
			this.productTitle = productTitle;
		}

		_createClass(StoreAvailability, [{
			key: 'updateWithVariant',
			value: function updateWithVariant(variant) {
				if (!this.element) {
					return; // If the element to inject the store availability does not exist, we return immediately
				}

				// If the variant is null (for instance unavailable variant), we clear the container
				if (!variant) {
					this.element.textContent = '';
					return;
				}

				// If we have a new variant we render the section
				this._renderAvailabilitySection(variant['id']);
			}
		}, {
			key: '_renderAvailabilitySection',
			value: function _renderAvailabilitySection(id) {
				var _this22 = this;

				// First we clear the previous content
				this.element.innerHTML = '';

				// If there is already an element with the given modal we remove it first
				var availabilityModal = document.getElementById('StoreAvailabilityModal-' + id);
				if (availabilityModal) {
					availabilityModal.remove();
				}

				return fetch(window.routes.rootUrlWithoutSlash + '/variants/' + id + '?section_id=store-availability').then(function (response) {
					return response.text().then(function (content) {
						_this22.element.innerHTML = content;
						_this22.element.innerHTML = _this22.element.firstElementChild.innerHTML;

						// The product title is not rendered so we have to render it manually
						var productTitle = _this22.element.querySelector('.store-availabilities-modal__product-title');

						if (productTitle) {
							productTitle.textContent = _this22.productTitle;
						}

						// In order for our modal system to work we have to append the modal to the body instead
						var availabilityModal = document.getElementById('StoreAvailabilityModal-' + id);
						document.body.appendChild(availabilityModal);

						// Create the drawer
						new __WEBPACK_IMPORTED_MODULE_0__components_Drawer__["default"](availabilityModal);
					});
				});
			}
		}]);

		return StoreAvailability;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = StoreAvailability;

	/***/
},
/* 28 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__ = __webpack_require__(5);

	var SearchBar = function () {
		function SearchBar() {
			_classCallCheck(this, SearchBar);
			let _thisS = this;
			this.documentDelegate = new domDelegate.Delegate(document.body);
			this.documentItselfDelegate = new domDelegate.Delegate(document);

			this.searchElement = document.getElementById('Search');
			this.searchInputElement = this.searchElement.querySelector('[name="q"]');
			this.searchResultsElement = this.searchElement.querySelector('.Search__Results');
			this.searchForm = this.searchElement.querySelector('.Search__Form');
			this.closeSearchElement = this.searchElement.querySelector('[data-action="close-search"]');
			this.queryMap = {};
			this.isOpen = false;

			this.pageOverlayElement = document.querySelector('.PageOverlay');

			// Stciky Scroll Bar Options
			this.scrollThreshold = 30;
			this.prevPosition = window.scrollY;
			this.where = 'start';
			this.scrollingSpotted = false;
			this.calcPoint = 0;
			this.templates = ['index', 'collection', 'search', '404'];

			fastdom.measure(function () {
				document.documentElement.style.setProperty('--search-height', _thisS.searchElement.clientHeight + 'px');
			});

			this.pageContent = document.getElementById("main");

			if (this.templates.indexOf(window.theme.pageType) > -1 || window.theme.showSearchBarOnPage == true) {
				if (window.innerWidth > 640) {
					this.searchElement.classList.remove('forced_show');
				} else {
					this.searchElement.classList.add('forced_show');
					this.searchElement.setAttribute('aria-hidden', false);
					this.pageContent.style.marginTop = this.searchElement.clientHeight + 'px';
				}
			}

			this._attachListeners();
		}

		_createClass(SearchBar, [{
			key: 'destroy',
			value: function destroy() {
				this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
				this.searchInputElement.removeEventListener('input', this._onInputListener);

				this.documentDelegate.off();
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._preventSubmissionListener = this._preventSubmission.bind(this);
				this._onInputListener = this._debounce(this._onInput.bind(this), 250);

				this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);
				this.searchInputElement.addEventListener('input', this._onInputListener);

				// append title: to query to limit search only to titles
				//'title:' + 
				// this.searchForm.addEventListener("submit", (event) => {
				// 	event.preventDefault();
				// 	window.location.href = 'search/?q=' + this.searchInputElement.value + '&type=product';
				// 	// window.location.href = 'search/?q=' + this.searchInputElement.value + '&type=product';
				// });

				this.documentDelegate.on('click', '[data-action="toggle-search"]', this._toggleSearch.bind(this));
				this.documentDelegate.on('click', '[data-action="open-search"]', this._openSearch.bind(this));
				this.documentDelegate.on('click', '[data-action="close-search"]', this._closeSearch.bind(this));
				

				// comment this out to make search thing hideable on scroll
				if (this.templates.indexOf(window.theme.pageType) > -1 || window.theme.showSearchBarOnPage == true) {
					document.addEventListener('scroll', this._enableStickySearch.bind(this));
					window.addEventListener('resize', this._enableStickySearch.bind(this));
				}



				this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
			}

			/**
			 * Toggle the search
			 */

		}, {
			key: '_toggleSearch',
			value: function _toggleSearch(event) {
				if (this.isOpen) {
					this._closeSearch(event);
				} else {
					this._openSearch(event);
				}
				event.preventDefault();
			}

			/**
			 * Open the search form and trap focus
			 */

		}, {
			key: '_openSearch',
			value: function _openSearch() {
				var _this23 = this;

				this.searchElement.setAttribute('aria-hidden', 'false');
				document.body.classList.add('no-scroll');
				// disableBodyScroll(true, '[data-scrollable]');

				__WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].trapFocus(this.searchElement, 'search', this.searchElement.querySelector('[name="q"]'));

				var onFocusListener = function onFocusListener() {
					_this23.searchInputElement.focus();
					_this23.searchElement.removeEventListener('transitionend', onFocusListener);
				};

				this.searchElement.addEventListener('transitionend', onFocusListener);
				this.isOpen = true;

				this.pageOverlayElement.classList.add('is-visible');
				document.querySelector('#shopify-section-header').style.zIndex = 10;
				this.pageOverlayElement.setAttribute("data-action", "close-search");
			}

			/**
			 * Close the search form and clear focus
			 */

		}, {
			key: '_closeSearch',
			value: function _closeSearch() {
				var _this24 = this;

				if (!$(this.searchElement).hasClass("forced_show")) {
					this.searchElement.setAttribute('aria-hidden', 'true'); 
				}
				this._resetSearch();
				this.searchInputElement.value = '';
				this._handleCloseSearchButton("hide");

				document.body.classList.remove('no-scroll');
				// disableBodyScroll(false, '[data-scrollable]');
				
				__WEBPACK_IMPORTED_MODULE_0__helper_Accessibility__["default"].removeTrapFocus(this.searchElement, 'search');

				this.isOpen = false;

				this.pageOverlayElement.classList.remove('is-visible');        
				this.pageOverlayElement.removeAttribute("data-action");

				let onTransitionEnd = function onTransitionEnd(event) {
					if (event.propertyName === 'transform') {
						document.dispatchEvent(new CustomEvent('search:close:transitionend'));
						_this24.searchElement.removeEventListener('transitionend', onTransitionEnd);
					}
				};
				this.searchElement.addEventListener('transitionend', onTransitionEnd);

			}

			/**
			 * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
			 * then we disable submission using enter key
			 */

		}, {
			key: '_preventSubmission',
			value: function _preventSubmission(event) {
				if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
					event.preventDefault();
				}
			}

			/**
			 * This is called when the user has stopped typing (after debounce delay)
			 */

		}, {
			key: '_onInput',
			value: function _onInput(event) {
				var _this25 = this;

				if (event.keyCode === 13) {
					return;
				}
				this._handleCloseSearchButton("show");
				// Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
				// keep track of sent requests, and only use the results of the last one
				this.lastInputValue = event.target.value;

				if (this.lastInputValue === '') {
					this._handleCloseSearchButton("hide");
					this._resetSearch();
					this._closeSearch();
					return;
				}        

				if (!this.isOpen) {
					this._openSearch();
				}

				var queryOptions = { method: 'GET', credentials: 'same-origin' };

				// var queries = [fetch(window.routes.searchUrl + '?view=ajax&q=title:' + encodeURIComponent(this.lastInputValue) + '*&type=product', queryOptions)];
				var queries = [fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=product', queryOptions)];

				if (window.theme.searchMode !== 'product') {
					queries.push(fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=' + window.theme.searchMode.replace('product,', ''), queryOptions));
				}

				this.queryMap[this.lastInputValue] = true;

				document.dispatchEvent(new CustomEvent('theme:loading:start'));

				Promise.all(queries).then(function (responses) {
					// If we receive the result for a query that is not the last one, we simply do not process the result
					if (_this25.lastInputValue !== event.target.value) {
						return;
					}

					delete _this25.queryMap[event.target.value];

					Promise.all(responses.map(function (response) {
						return response.text();
					})).then(function (contents) {
						// If we have only one content then we only have product, otherwise we have products and articles
						if (window.theme.searchMode === 'product') {
							_this25.searchResultsElement.innerHTML = contents[0];
						} else {
							_this25.searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">' + contents[0] + '</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">' + contents[1] + '</div>\n            </div>';
						}

						_this25.searchResultsElement.setAttribute('aria-hidden', 'false');
					});

					document.dispatchEvent(new CustomEvent('theme:loading:end'));
					dataLayer.push({ecommerce: null});
					dataLayer.push({event: "Search"});
				});
			}
		}, {
			key: '_resetSearch',
			value: function _resetSearch() {
				if (window.theme.searchMode === 'product') {
					this.searchResultsElement.innerHTML = '';
				} else {
					this.searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>';
				}

				this.searchResultsElement.setAttribute('aria-hidden', 'true');

				document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
			}

			/**
			 * Simple function that allows to debounce
			 */

		}, {
			key: '_debounce',
			value: function _debounce(fn, delay) {
				var _this26 = this;

				var timer = null;

				return function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					clearTimeout(timer);

					timer = setTimeout(function () {
						fn.apply(_this26, args);
					}, delay);
				};
			}
		}, {
			key: '_handleCloseSearchButton',
			value: function _handleCloseSearchButton(action) {
				if (window.innerWidth > 640) return;
				if (action == "hide") {
					this.closeSearchElement.style.display = "none";
				} else if (action == "show") {
					this.closeSearchElement.style.display = "block";
				} else {
					return;
				}
			}
		}, {
			key: '_enableStickySearch',
			value: function _enableStickySearch(event) {

				if (this.templates.indexOf(window.theme.pageType) < 0 && window.theme.showSearchBarOnPage == false)  {
					return;
				}

				var temp_var = this.where;
				if (event == undefined) {
					return;
				}
				if (window.innerWidth > 640) {
					if (this.searchElement.classList.contains('forced_show')) {
						this.searchElement.classList.remove('forced_show');
						this.searchElement.setAttribute("aria-hidden", true);
					}
					this.pageContent.style.marginTop = 0;
					return;
				}
				
				this.pageContent.style.marginTop = this.searchElement.clientHeight + 'px';

				if (event.type == 'scroll') {
					this.scrollingSpotted = true;
				} else if (event.type == 'resize') {
					this.scrollingSpotted = false;
					return;
				}
				if (window.scrollY - this.prevPosition > 0) {
					this.where = "down";
				} else {
					this.where = "up";
				}

				if (temp_var !== this.where) {
					this.calc_point = window.scrollY;
				}
				let announcementBarHeight = document.documentElement.style.getPropertyValue('--announcement-bar-height') ? parseInt(document.documentElement.style.getPropertyValue('--announcement-bar-height')) : 0;

				if (window.scrollY <= 0) {          
					this.searchElement.classList.add("forced_show");
					this.searchElement.setAttribute("aria-hidden", false);
				} else if (window.scrollY - this.calc_point >= this.scrollThreshold && this.where === "down" && window.scrollY > announcementBarHeight + this.scrollThreshold) {
					this.searchElement.classList.remove("forced_show");
					this.searchElement.setAttribute("aria-hidden", true);
				} else if (Math.abs(window.scrollY - this.calc_point) >= this.scrollThreshold && this.where === "up" ) {
					this.searchElement.classList.add("forced_show");
					this.searchElement.setAttribute("aria-hidden", false);
				}

				this.prevPosition = window.scrollY;
				
			}
		}]);

		return SearchBar;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = SearchBar;

	/***/
},
/* 29 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(10);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_CountrySelector__ = __webpack_require__(12);

	var AddressesSection = function AddressesSection() {
		var _this27 = this;

		_classCallCheck(this, AddressesSection);

		this.countrySelectors = [];

		__WEBPACK_IMPORTED_MODULE_0__helper__["DomHelper"].nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(function (modal) {
			_this27.countrySelectors.push(new __WEBPACK_IMPORTED_MODULE_1__components_CountrySelector__["default"](modal.querySelector('[name="address[country]"]'), modal.querySelector('[name="address[province]"]')));
		});
	};
	/* harmony export (immutable) */

	__webpack_exports__["default"] = AddressesSection;

	/***/
},
/* 30 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var ArticleList = function () {
		function ArticleList(container) {
			var _this28 = this;

			_classCallCheck(this, ArticleList);

			this.element = container;

			if (window.theme.showElementStaggering) {
				this.timeline = new TimelineLite({ delay: window.theme.showPageTransition ? 0.5 : 0 });

				this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));

				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
					_this28.intersectionObserver.observe(item);
				});
			}
		}

		_createClass(ArticleList, [{
			key: 'onUnload',
			value: function onUnload() {
				if (window.theme.showElementStaggering) {
					this.intersectionObserver.disconnect();
					this.timeline.kill();
				}
			}
		}, {
			key: '_reveal',
			value: function _reveal(results) {
				var _this29 = this;

				var toReveal = [];

				results.forEach(function (result) {
					if (result.isIntersecting || result.intersectionRatio > 0) {
						// isIntersecting does not exist on Samsung Android browser
						toReveal.push(result.target);
						_this29.intersectionObserver.unobserve(result.target);
					}
				});

				if (toReveal.length === 0) {
					return;
				}

				this.timeline.staggerFromTo(toReveal, 0.45, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0 }, 0.2);
			}
		}]);

		return ArticleList;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ArticleList;

	/***/
},
/* 31 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var ArticleSection = function () {
		function ArticleSection(container) {
			var _this30 = this;

			_classCallCheck(this, ArticleSection);

			this.element = container;
			this.toolbarElement = this.element.querySelector('.ArticleToolbar');
			this.articleNavElement = this.element.querySelector('.ArticleNav');

			var articleImageElement = this.element.querySelector('.Article__Image');

			if (articleImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
				this.parallaxInstance = new Rellax('.Article__Image', {
					speed: -7,
					center: false,
					round: true
				});
			}

			if (window.theme.showElementStaggering) {
				this.timeline = new TimelineLite({ delay: window.theme.showPageTransition ? 0.5 : 0 });
				this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));

				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.ArticleItem')).forEach(function (item) {
					_this30.intersectionObserver.observe(item);
				});
			}

			this._attachListeners();
		}

		_createClass(ArticleSection, [{
			key: 'onUnload',
			value: function onUnload() {
				if (this.parallaxInstance) {
					this.parallaxInstance.destroy();
				}

				if (window.theme.showElementStaggering) {
					this.intersectionObserver.disconnect();
					this.timeline.kill();
				}

				window.removeEventListener('scroll', this._onScrollListener);
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._onScrollListener = this._checkToolbarVisibility.bind(this);
				window.addEventListener('scroll', this._onScrollListener);
			}
		}, {
			key: '_checkToolbarVisibility',
			value: function _checkToolbarVisibility() {
				var _this31 = this;

				var lastYPosition = 0,
						headerHeight = 0,
						navBottom = 0,
						isFixedHeader = 0,
						header = document.querySelector('.Header');

				fastdom.measure(function () {
					lastYPosition = window.pageYOffset;
					headerHeight = header.offsetHeight;
					isFixedHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || 0);

					if (_this31.articleNavElement) {
						navBottom = _this31.articleNavElement.offsetTop + _this31.articleNavElement.clientHeight - headerHeight;
					}
				});

				fastdom.mutate(function () {
					_this31.toolbarElement.style.top = isFixedHeader ? headerHeight + 'px' : null;

					if (_this31.articleNavElement) {
						if (lastYPosition > 150 && _this31.articleNavElement && lastYPosition < navBottom) {
							_this31.toolbarElement.classList.add('is-visible');
						} else {
							_this31.toolbarElement.classList.remove('is-visible');
						}
					} else {
						if (lastYPosition > 150) {
							_this31.toolbarElement.classList.add('is-visible');
						} else {
							_this31.toolbarElement.classList.remove('is-visible');
						}
					}
				});
			}
		}, {
			key: '_reveal',
			value: function _reveal(results) {
				var _this32 = this;

				var toReveal = [];

				results.forEach(function (result) {
					if (result.isIntersecting || result.intersectionRatio > 0) {
						// isIntersecting does not exist on Samsung Android browser
						toReveal.push(result.target);
						_this32.intersectionObserver.unobserve(result.target);
					}
				});

				if (toReveal.length === 0) {
					return;
				}

				this.timeline.staggerFromTo(toReveal, 0.45, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0 }, 0.2);
			}
		}]);

		return ArticleSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ArticleSection;

	/***/
},
/* 32 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var BackgroundVideoSection = function () {
		function BackgroundVideoSection(container) {
			_classCallCheck(this, BackgroundVideoSection);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

			this._loadScript().then(this._setupPlayer.bind(this));
		}

		_createClass(BackgroundVideoSection, [{
			key: '_loadScript',
			value: function _loadScript() {
				var _this33 = this;

				return new Promise(function (resolve, reject) {
					var script = document.createElement('script');
					document.body.appendChild(script);
					script.onload = resolve;
					script.onerror = reject;
					script.async = true;
					script.src = _this33.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
				});
			}
		}, {
			key: 'onUnload',
			value: function onUnload() {
				if (this.player) {
					this.player.destroy(); // Both YouTube and Vimeo use the same function name
				}
			}
		}, {
			key: '_setupPlayer',
			value: function _setupPlayer() {
				var _this34 = this;

				var elementToInsert = this.element.querySelector('.ImageHero__VideoHolder');

				var playerLoadingInterval = setInterval(function () {
					if (_this34.options['videoType'] === 'youtube') {
						if (window.YT) {
							_this34.player = new YT.Player(elementToInsert, {
								videoId: _this34.options['videoId'],
								playerVars: {
									showinfo: 0,
									controls: 0,
									fs: 0,
									rel: 0,
									height: '100%',
									width: '100%',
									iv_load_policy: 3,
									html5: 1,
									loop: 1,
									playsinline: 1,
									modestbranding: 1,
									disablekb: 1,
									origin: _this34.options['requestHost']
								},
								events: {
									onReady: _this34._onYouTubeReady.bind(_this34),
									onStateChange: _this34._onYouTubeStateChange.bind(_this34)
								}
							});

							clearInterval(playerLoadingInterval);
						}
					} else {
						if (window.Vimeo) {
							_this34.player = new Vimeo.Player(elementToInsert.parentNode, {
								id: _this34.options['videoId'],
								autoplay: true,
								autopause: false,
								muted: true,
								background: true,
								/*height: '100%',
								width: '100%',*/
								loop: true
							});

							clearInterval(playerLoadingInterval);
						}
					}
				}, 50);
			}
		}, {
			key: '_onYouTubeReady',
			value: function _onYouTubeReady(event) {
				this.player.mute();
				this.player.playVideo();
			}
		}, {
			key: '_onYouTubeStateChange',
			value: function _onYouTubeStateChange(event) {
				if (event.data === YT.PlayerState.ENDED) {
					this.player.playVideo();
				}
			}
		}]);

		return BackgroundVideoSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = BackgroundVideoSection;

	/***/
},
/* 33 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Drawer__ = __webpack_require__(6);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__components_ShippingEstimator__ = __webpack_require__(20);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__helper_Responsive__ = __webpack_require__(1);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__helper_Animation__ = __webpack_require__(7);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__helper_Currency__ = __webpack_require__(8);

	var CartSection = function () {
		function CartSection(container) {
			_classCallCheck(this, CartSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
			this.itemCount = this.options['itemCount'];
			this.isCartNoteOpen = false;

			this.sidecartActivator = document.querySelector("[data-drawer-id='sidebar-cart']");

			if (this.options['drawer']) {
				this.sidebarDrawer = new __WEBPACK_IMPORTED_MODULE_0__components_Drawer__["default"](this.element, {
					onClose: this._onDrawerClosed.bind(this)
				});
			}

			if (this.options['hasShippingEstimator']) {
				this.shippingEstimator = new __WEBPACK_IMPORTED_MODULE_2__components_ShippingEstimator__["default"](this.element.querySelector('.ShippingEstimator'));
			}

			this._attachListeners();
		}

		_createClass(CartSection, [{
			key: 'onUnload',
			value: function onUnload() {
				if (this.options['hasShippingEstimator']) {
					this.shippingEstimator.destroy();
				}

				this.delegateElement.off();
				document.removeEventListener('product:added', this._onProductAddedListener);
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._onProductAddedListener = this._onProductAdded.bind(this);

				this.delegateElement.on('change', '#cart-note', this._updateCartNote.bind(this));

				if (this.options['type'] !== 'page') {
					this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
					this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._updateItemQuantity.bind(this));
				} else {
					this.delegateElement.on('change', '.QuantitySelector__CurrentQuantity', this._reloadPageWithQuantity.bind(this));
				}

				// We have some listeners that are specific to the fact it's a drawer or the dedicated cart page
				if (this.options['drawer']) {
					this.delegateElement.on('click', '[data-action="toggle-cart-note"]', this._toggleCartNote.bind(this));
				}

				document.addEventListener('product:added', this._onProductAddedListener);

				// We attach a listener at page level which allows to re-render the cart
				this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));

				this.delegateElement.on('click', '[data-extra-upsell-product]', this._addExtraUpsellProductToCart.bind(this));


				// this.delegateElement.on('click', '[data-checkout-button]', this._trackFBInitiateCheckoutEvent.bind(this));

			}
		}, {
			key: '_updateCartNote',
			value: function _updateCartNote(event, target) {
				fetch(window.routes.cartUrl + '/update.js', {
					body: JSON.stringify({ note: target.value }),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
					}
				});
			}
		}, {
			key: '_toggleCartNote',
			value: function _toggleCartNote() {
				var _this35 = this;

				var noteContainer = this.element.querySelector('.Cart__OffscreenNoteContainer'),
						cartNote = this.element.querySelector('#cart-note');

				this.element.classList.toggle('has-note-open');
				this.element.querySelector('.Cart__NoteButton').innerHTML = cartNote.value !== '' ? window.languages.cartEditNote : window.languages.cartAddNote;

				noteContainer.setAttribute('aria-hidden', noteContainer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');

				this.isCartNoteOpen = noteContainer.getAttribute('aria-hidden') === 'false';

				if (this.element.classList.contains('has-note-open')) {
					var transitionEndListener = function transitionEndListener() {
						_this35.element.querySelector('#cart-note').focus();
						noteContainer.removeEventListener('transitionend', transitionEndListener);
					};

					noteContainer.addEventListener('transitionend', transitionEndListener);
				}
			}
		}, {
			key: '_updateItemQuantity',
			value: function _updateItemQuantity(event, target) {
				var _this36 = this;

				document.dispatchEvent(new CustomEvent('theme:loading:start'));

				var quantity = null,
						elementToAnimate = null;

				if (target.tagName === 'INPUT') {
					quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
				} else {
					quantity = parseInt(target.getAttribute('data-quantity'));
				}

				// If the quantity is 0, then we will animate the product with a removal effect
				if (quantity === 0) {
					elementToAnimate = target.closest('.CartItemWrapper');
				}

				fetch(window.routes.cartChangeUrl + '.js', {
					body: JSON.stringify({ line: target.getAttribute('data-line'), quantity: quantity }),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
					}
				}).then(function (cart) {
					cart.json().then(function (content) {
						_this36.itemCount = content['item_count'];
						_this36._rerenderCart(elementToAnimate);

						document.dispatchEvent(new CustomEvent('theme:loading:end'));
					});
				});

				event.preventDefault();
			}
		}, {
			key: '_reloadPageWithQuantity',
			value: function _reloadPageWithQuantity(event, target) {
				window.location.href = window.routes.cartChangeUrl + '?quantity=' + parseInt(target.value) + '&line=' + target.getAttribute('data-line');
			}
		}, {
			key: '_onProductAdded',
			value: function _onProductAdded(event) {
				var _this37 = this;

				this.itemCount += event.detail.quantity;

				// Ugly hack to add delay to announcement bar animation
				this.opening = true;

				this._rerenderCart().then(function () {
					_this37.sidebarDrawer.open();
				});

			}
		}, {
			key: '_onDrawerClosed',
			value: function _onDrawerClosed() {
				if (this.isCartNoteOpen) {
					this._toggleCartNote();
				}
			}

			/**
			 * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
			 * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
			 * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
			 * all the time and hence having easier logic.
			 */

		}, {
			key: '_rerenderCart',
			value: function _rerenderCart(elementToAnimate) {
				var _this38 = this;
				
				// Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
				return fetch(window.routes.cartUrl + '?view=' + (this.options['drawer'] && window.theme.pageType !== 'cart' ? 'drawer' : 'ajax'), {
					credentials: 'same-origin',
					method: 'GET'
				}).then(function (content) {          
					// If there is an element to animate, we animate it using a transition
					if (_this38.options['drawer'] && elementToAnimate) {
						var timelineLite = new TimelineLite({ onComplete: function onComplete() {
								content.text().then(function (html) {
									_this38._replaceContent(html);
								});
							} });

						timelineLite.to(elementToAnimate, 0.5, { height: 0, opacity: 0, ease: Cubic.easeOut }, 0);

						if (_this38.itemCount === 0) {
							timelineLite.to(_this38.element.querySelector('.Drawer__Footer'), 0.5, { y: '100%', transition: 'none', ease: Cubic.easeInOut }, 0);
							timelineLite.to(_this38.element.querySelector('.Drawer__Announcement'), 0.5, { y: '-101%', transition: 'none', ease: Cubic.easeInOut }, 0);
							_this38.element.classList.add("Underlined");
						}
					} else {
						content.text().then(function (html) {
							_this38._replaceContent(html);
						});
						if (_this38.itemCount === 0) {
							_this38.element.classList.add("Underlined");
						} else {              
							_this38.element.classList.remove("Underlined");
						}
					}
				});
			}
		}, {
			key: '_replaceContent',
			value: function _replaceContent(html) {
				var _this39 = this;
				
				var tempElement = document.createElement('div');
				tempElement.innerHTML = html;

				var cartNodeParent = this.element.querySelector('.Cart').parentNode;

				var newDrawerAnnouncement = tempElement.querySelector(".Drawer__Announcement");
				var oldDrawerAnnouncement = this.element.querySelector(".Drawer__Announcement");

				if (newDrawerAnnouncement != null && oldDrawerAnnouncement != null) {
					var newAnnouncementText = newDrawerAnnouncement.querySelector(".Drawer__Announcement--message");
					var oldAnnouncementText = oldDrawerAnnouncement.querySelector(".Drawer__Announcement--message");
					if (newAnnouncementText.isEqualNode(oldAnnouncementText)) {
						newDrawerAnnouncement.classList.add("NoAnimate");
					};
				}

				if (this.options['drawer'] && window.theme.pageType !== 'cart') {
					var currentScrollPosition = this.element.querySelector('.Drawer__Main').scrollTop;
					cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
					this.element.querySelector('.Drawer__Main').scrollTop = currentScrollPosition;
				} else {
					// For dedicated page we replace the whole section if there is no more product
					if (this.itemCount === 0) {
						this.element.innerHTML = tempElement.querySelector('.shopify-section').firstElementChild.innerHTML;
					} else {
						cartNodeParent.replaceChild(tempElement.querySelector('.Cart'), this.element.querySelector('.Cart'));
						this.element.querySelector('.PageHeader').innerHTML = tempElement.querySelector('.PageHeader').innerHTML;
					}
				}

				// We can also update the dot and the quantity
				var cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));

				var cartDot = __WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(document.querySelectorAll('.Header__CartDot')), cartQuantity = __WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(document.querySelectorAll('.Header__CartCount'));

				if (newDrawerAnnouncement != null) {
					document.documentElement.dispatchEvent(new CustomEvent('ipdata:received', { 
							bubbles: true
					}));
					var drawerAnnouncementInner = newDrawerAnnouncement.querySelector(".Drawer__Announcement-inner");          
					if (_this39.opening) {
						setTimeout(function(){
							drawerAnnouncementInner.style.top = "0px";
						}, 600);
						_this39.opening = false;
					} else {
						drawerAnnouncementInner.style.top = "0px";
					}
				}

				cartDot.forEach(function (item) {
					if (_this39.itemCount === 0) {
						item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
					} else {
						item.classList.add('is-visible');
					}
				});

				cartQuantity.forEach(function (item) {
					item.textContent = _this39.itemCount;
				});

				let cartVariantsStock = __WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(cartNodeParent.querySelectorAll('.CartItem_LowStockReference'));

				cartVariantsStock.forEach(function(item) {
				  let LSAObject = JSON.parse(localStorage.getItem("__LSA"));
                  if (LSAObject) {
				  let stockNumber = LSAObject[item.closest(".CartItem").getAttribute("data-variant-id")]?.val;
					if (!stockNumber) {
						stockNumber = Math.round(Math.random() * 5 + 2)
					} else {
						if (stockNumber > 7) {
							stockNumber = 7
						}
					}
					item.textContent = item.textContent.replace('{{ items }}', stockNumber);
					item.style.opacity = 1;
                  }
				})
			}
		}, {
			key: "_addExtraUpsellProductToCart",
			value: function _addExtraUpsellProductToCart(event, target) {
				event.preventDefault();
				let upsellProductID = target.getAttribute("data-extra-upsell-product");
				let $this = this;
				document.dispatchEvent(new CustomEvent('theme:loading:start'));

				fetch(window.routes.cartAddUrl + '.js', {
					body: JSON.stringify({id: upsellProductID,quantity: 1}),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
					}
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					$this._rerenderCart();
					document.dispatchEvent(new CustomEvent('theme:loading:end'));
				});
			}
		}, {
			key: "_trackFBInitiateCheckoutEvent",
			value: function _trackFBInitiateCheckoutEvent(event, target) {
				event.preventDefault();
				fetch(window.routes.cartUrl+".js", {
					credentials: 'same-origin',
					method: 'GET'
				}).then(function (content) {
					return content.json();
				}).then(function (cartData) {
					let content_ids = [];
					let content_ids_default = [];
					let products = [];

					for (let i=0; i<cartData.items.length; i++) {
						content_ids.push(cartData.items[i].properties._globalVariantID);
						content_ids_default.push(cartData.items[i].variant_id.toString());
						products.push(
							{
								id: cartData.items[i].variant_id,
								name: cartData.items[i].title,
								price: cartData.items[i].price,
								quantity: cartData.items[i].quantity
							}
						)
					}
					
					dataLayer.push({ ecommerce: null });
					dataLayer.push({
						ecommerce: {
							checkout: {
								products: products,
								content_type: 'product',
								content_ids: content_ids,
								content_ids_default: content_ids_default,
								currency: cartData.currency,
								value: __WEBPACK_IMPORTED_MODULE_4__helper_Currency__["default"].formatMoney(cartData.total_price, '{{FB_AddToCart_Price_Format}}'),
								num_items: cartData.item_count
							}
						}
					});
					dataLayer.push({event: "InitiateCheckout"});
					
					window.location = target.href;
				})
			}
		}]);

		return CartSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = CartSection;

	/***/
},
/* 34 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var CollectionListSection = function () {
		function CollectionListSection(container) {
			_classCallCheck(this, CollectionListSection);

			this.element = container;

			var collectionListElement = this.element.querySelector('[data-flickity-config]');

			if (collectionListElement) {
				this.carousel = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](collectionListElement);
			}
		}

		_createClass(CollectionListSection, [{
			key: 'onUnload',
			value: function onUnload() {
				if (this.carousel) {
					this.carousel.destroy();
				}
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				if (this.carousel) {
					this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
				}
			}
		}, {
			key: 'onBlockDeselect',
			value: function onBlockDeselect() {
				if (this.carousel) {
					this.carousel.unpausePlayer();
				}
			}
		}]);

		return CollectionListSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = CollectionListSection;

	/***/
},
/* 35 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Drawer__ = __webpack_require__(6);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_Popover__ = __webpack_require__(3);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__components_ProductItemColorSwatch__ = __webpack_require__(4);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__helper_Responsive__ = __webpack_require__(1);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__components_OverflowScroller__ = __webpack_require__(13);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__components_PriceRange__ = __webpack_require__(70);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var CollectionSection = function () {
		function CollectionSection(element) {
			_classCallCheck(this, CollectionSection);

			this.element = element;
			this.elementID = this.element.getAttribute("data-section-id");

			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);

			// Add processedContainers as a class property
			this.processedContainers = new Set();

			this.toolbarElement = this.element.querySelector('.CollectionToolbar');
			this.collectionInnerElement = this.element.querySelector('.CollectionInner__Products');

			this.settings = JSON.parse(this.element.getAttribute('data-section-settings'));
			this.currentTags = this.settings['currentTags'];
			this.currentSortBy = this.settings['sortBy'];

			this.temporaryTags = this.currentTags.slice(); // This allows to do a deep copy of the current tags

			// Create the popover if available
			var sortPopoverElement = document.getElementById('collection-sort-popover');
			if (sortPopoverElement) {
				this.sortPopover = new __WEBPACK_IMPORTED_MODULE_1__components_Popover__["default"](sortPopoverElement, { onValueChanged: this._sortByChanged.bind(this) });
			}

			// Create the filter drawer if available
			var filterDrawerElement = document.getElementById('collection-filter-drawer');

			if (filterDrawerElement) {
				this.filterDrawer = new __WEBPACK_IMPORTED_MODULE_0__components_Drawer__["default"](filterDrawerElement, { onClose: this._removeUncommittedTags.bind(this) });
			}

			// Create scroller of sidebar
			if (this.settings['filterPosition'] === 'sidebar' && this.settings.infinityScroll != true) {
				this.filterInnerSidebarScroller = new __WEBPACK_IMPORTED_MODULE_5__components_OverflowScroller__["default"](this.element.querySelector('.CollectionInner__Sidebar'));
			}

			// Setup parallax on image (if any)
			var collectionImageElement = this.element.querySelector('.PageHeader__ImageWrapper');

			if (collectionImageElement && window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches) {
				this.parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
					speed: -7,
					center: false,
					round: true
				});
			}

			// Setup product item color swatch
			new __WEBPACK_IMPORTED_MODULE_2__components_ProductItemColorSwatch__["default"](this.element);

			// Setup animation
			if (this.settings.animateColletion != false ) {
				this.timeline = new TimelineLite({ delay: window.theme.showPageTransition ? 0.1 : 0 });      
				this._setupAnimation();
			} else {
				this.element.classList.add("animation_disabled");
			}

			this._initInfinityScroll();
			this._attachListeners();


			this.filterMenu = this.element.querySelector("#collection_filter-container");
			this.overlay = document.querySelector(".PageOverlay");
			if (this.filterMenu) {
				this.filterData = [];
				this.searchParamsInitial = window.location.search.slice(1);
				this.searchParamsPrev = window.location.search.slice(1);
				this._initCollectionFilter();
			}


			// Add this before carousel initialization
			this._initializeGhostMode();

			// Initialize carousels
			this._initializeProductCarousels(); 

			this.priceRangeSelector = this.element.querySelector("#PriceRange");
			if (this.priceRangeSelector) {
				this.priceRangeElement = new __WEBPACK_IMPORTED_MODULE_6__components_PriceRange__["default"](this.priceRangeSelector);
			};


		}

		_createClass(CollectionSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.delegateElement.off('click');

				if (this.sortPopover) {
					this.sortPopover.destroy();
				}

				if (this.filterDrawer) {
					this.filterDrawer.destroy();
				}

				if (this.filterInnerSidebarScroller) {
					this.filterInnerSidebarScroller.destroy();
				}

				if (this.parallaxInstance) {
					this.parallaxInstance.destroy();
				}

				if (window.theme.showElementStaggering) {
					this.intersectionObserver.disconnect();
					this.timeline.kill();
				}

				// Clean up any carousels
				var productSlideshows = this.element.querySelectorAll('.ProductItem__ImageWrapper .Carousel');
				productSlideshows.forEach(function(slideshow) {
					if (slideshow.flickityInstance) {
					slideshow.flickityInstance.destroy();
					}
				});
			}
		}, {
			// Add new method to initialize product carousels
			key: '_initializeProductCarousels',
			value: function _initializeProductCarousels() {
			  var _this = this;
			  
			  // Find all product slideshows in the collection
			  if (__WEBPACK_IMPORTED_MODULE_4__helper_Responsive__["default"].matchesBreakpoint('pocket')) {

				var productSlideshows = this.element.querySelectorAll('.ProductItem__ImageWrapper .Carousel');
				
				productSlideshows.forEach(function(productSlideshow) {
					if (productSlideshow.hasAttribute('data-flickity-config')) {
					new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](productSlideshow, {
						onSelect: _this._onImageChanged.bind(_this)
					}, {
						draggable: !__WEBPACK_IMPORTED_MODULE_4__helper_Responsive__["default"].matchesBreakpoint('supports-hover')
					});
					}
				});
				}
			}
		}, {
			// Add helper methods for carousel
			key: '_onImageChanged',
			value: function _onImageChanged(event, cell) {
			  // Handle image change if needed
			}
		}, {
			key: '_setupAnimation',
			value: function _setupAnimation() {
				var _this40 = this;

				this.animationInited = true;

				var forceLoadFromTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

				if (!window.theme.showElementStaggering) {
					return;
				}

				// If there is already an observer set up, we remove it first
				if (this.intersectionObserver) {
					this.intersectionObserver.disconnect();
				}

				if (forceLoadFromTop) {
					this.timeline.staggerFromTo(this.element.querySelectorAll('.ProductList .ProductItem:not(.revealed)'), 0.2, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 }, 0.1);
						__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem:not(.revealed)')).forEach(function (item) {
							item.classList.add('revealed');
						});
				} else { 
					this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), {
						threshold: 0
					});

					__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem:not(.revealed)')).forEach(function (item) {
						_this40.intersectionObserver.observe(item);
					});
				}
			}
		}, {
			key: '_reveal',
			value: function _reveal(results) {
				var _this41 = this;

				var toReveal = [];

				results.forEach(function (result) {
					if (result.isIntersecting || result.intersectionRatio > 0) {
						// isIntersecting does not exist on Samsung Android browser
						toReveal.push(result.target);            
						result.target.classList.add('revealed');
						_this41.intersectionObserver.unobserve(result.target);
					}
				});

				if (toReveal.length === 0) {
					return;
				}

				this.timeline.staggerFromTo(toReveal, 0.45, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 }, 0.2);
			}
		}, {
			key: '_changeLayoutMode',
			value: function _changeLayoutMode(event, target) {
				var _this42 = this;

				var layoutType = target.getAttribute('data-grid-type'),
					newCount = parseInt(target.getAttribute('data-count'));


				// default layout for reference 
				// Grid__Cell 1/2--phone 1/2--tablet-and-up 1/3--desk

				// Otherwise we detect the mode, and change all classes
				var productList = this.collectionInnerElement.querySelector('.ProductList');

				if (productList) {
					var previousCount = parseInt(productList.getAttribute('data-' + layoutType + '-count'));

					if (previousCount === newCount) {
						return; // Nothing has changed so we just return to avoid reflow
					}

					productList.setAttribute('data-' + layoutType + '-count', newCount);

					__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(productList.querySelectorAll('.Grid__Cell')).forEach(function (item) {
						if (layoutType === 'mobile') {
							item.classList.remove('1/' + previousCount + '--phone'); // IE11 and lower does not support classList.replace
							item.classList.add('1/' + newCount + '--phone');
						} else {
							var previousTabletCount = previousCount === 2 ? 2 : 3,
									newTabletCount = newCount === 2 ? 2 : 3;

							if (_this42.settings['filterPosition'] === 'drawer') {
								item.classList.remove('1/' + previousCount + '--lap-and-up');
								item.classList.add('1/' + newCount + '--lap-and-up');
							} else {
								item.classList.remove('1/' + previousCount + '--desk');
								item.classList.add('1/' + newCount + '--desk');
							}

							item.classList.remove('1/' + previousTabletCount + '--tablet-and-up');
							item.classList.add('1/' + newTabletCount + '--tablet-and-up');
						}

						if (window.theme.showElementStaggering) {
							item.firstElementChild.style.visibility = 'hidden'; // Make it as hidden so we can re-trigger the animation
						}
					});

					// Force lazy sizes to recalculate item sizes
					lazySizes.autoSizer.checkElems();

					let productSlideshows = document.querySelectorAll('.Product__Slideshow');
					productSlideshows.forEach(function(productSlideshow) {
						var flkty = Flickity.data(productSlideshow);
						if (flkty) {
							flkty.resize();
							flkty.reloadCells();
						}
					});
					
				}

				target.classList.add('is-active');
				__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].getSiblings(target).forEach(sibling => {
					sibling.classList.remove('is-active');
				});

				this._setupAnimation();

				// In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
				// is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript

				fetch(window.routes.cartUrl + '/update.js', {
					body: JSON.stringify({
						attributes: _defineProperty({}, 'collection_' + layoutType + '_items_per_row', newCount)
					}),
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
					}
				});
			}
		},
		{
			key: '_initializeGhostMode',
			value: function _initializeGhostMode() {
			// Get the first wrapper to check the saved mode
			const wrapper = this.element.querySelector('.ProductItem__Wrapper');
			if (!wrapper) return;

			const savedMode = wrapper.getAttribute('data-current-mode');
			
			// Update the active state of the ghost/first buttons
			const ghostButtons = this.element.querySelectorAll('[data-action="change-ghost-mode"]');
			ghostButtons.forEach(button => {
				if (button.getAttribute('data-firstImage') === savedMode) {
				button.classList.add('is-active');
				} else {
				button.classList.remove('is-active');
				}
			});
			}
		  },
		{
			key: '_changeGhostfirst',
			value: function _changeGhostfirst(event, target) {
			  // Return early if clicked button is already active
			  if (target.classList.contains('is-active')) {
				return;
			  }
			  
			  const isfirst = target.getAttribute('data-firstImage') === 'first';
			  target.classList.add('is-active');
			  __WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].getSiblings(target).forEach(sibling => {
				sibling.classList.remove('is-active');
			  });
			  
			  // Save preference to cart attributes
			  fetch(window.routes.cartUrl + '/update.js', {
				body: JSON.stringify({
				  attributes: {
					'collection_ghost_mode': isfirst ? 'first' : 'ghost'
				  }
				}),
				credentials: 'same-origin',
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'X-Requested-With': 'XMLHttpRequest'
				}
			  });
			  
			  this._updateProductCardImages(isfirst);
			}
		  },
		  {
			key: '_updateProductCardImages',
			value: function _updateProductCardImages(isfirst) {
			  // Switch images in all product cards
  const productCards = document.querySelectorAll('.Grid__Cell');
  productCards.forEach(card => {
    const wrapper = card.querySelector('.ProductItem__Wrapper');
    const slideshow = card.querySelector('.Product__Slideshow');
    
    if (slideshow) {
      const flickityInstance = Flickity.data(slideshow);
      if (flickityInstance) {
        const cells = flickityInstance.getCellElements();
        if (cells.length >= 2) {
          // Remove cells from Flickity
          flickityInstance.remove(cells);
          
          if (isfirst) {
            // For first mode, we want the first image at the start
            // The current first image is the ghost image, so we need to move it to the end
            const ghostImage = cells[0];  // The ghost image is currently first
            cells.shift();  // Remove it from the beginning
            cells.push(ghostImage);  // Add it to the end
          } else {
            // For ghost mode, we want the ghost image (last) at the start
            const ghostImage = cells[cells.length - 1];  // Get the last image
            cells.pop();  // Remove it from the end
            cells.unshift(ghostImage);  // Add it to the beginning
          }
                    
          // Add cells back in new order
          flickityInstance.append(cells);
          
          // Reset to first slide without animation
          flickityInstance.select(0, false, true);
        }
      }
    }
    
    // Update the data attribute to reflect new state
    wrapper.setAttribute('data-current-mode', isfirst ? 'first' : 'ghost');
  });
			}
		  }, {
			key: '_sortByChanged',
			value: function _sortByChanged(sortBy) {
				if (this.currentSortBy === sortBy) {
					return;
				}

				this.currentSortBy = sortBy;
				this._reloadProducts();
			}
		}, {
			key: '_toggleTag',
			value: function _toggleTag(event) {
				var element = event.target;

				if (element.classList.contains('is-active')) {
					this.temporaryTags.splice(this.temporaryTags.indexOf(element.getAttribute('data-tag')), 1); // Delete the tag if already active
				} else {
					var activeSibling = element.closest('.Collapsible').querySelector('.is-active');

					if (activeSibling) {
						this.temporaryTags.splice(this.temporaryTags.indexOf(activeSibling.getAttribute('data-tag')), 1);
					}

					this.temporaryTags.push(element.getAttribute('data-tag')); // Add if not previously active
				}

				this._updateActiveTags();

				// If we have the mode set as "sidebar" and that we are on desktop, we auto-commit
				if (__WEBPACK_IMPORTED_MODULE_4__helper_Responsive__["default"].matchesBreakpoint('lap-and-up') && this.settings['filterPosition'] === 'sidebar') {
					this._commit();
				}
			}
		}, {
			key: '_removeUncommittedTags',
			value: function _removeUncommittedTags() {
				this.temporaryTags = this.currentTags.slice(); // We simply reset the temporary tags to the active tags
				this._updateActiveTags();
			}
		}, {
			key: '_applyTags',
			value: function _applyTags() {
				this._updateActiveTags();
				this._commit();
			}
		}, {
			key: '_resetTags',
			value: function _resetTags() {
				this.temporaryTags = []; // We simply remove all tags
				this._applyTags();
			}
		}, {
			key: '_updateActiveTags',
			value: function _updateActiveTags() {
				var _this43 = this;

				__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.CollectionFilters [data-tag]')).forEach(function (item) {
					// IE11 and lower does not support classList.toggle...
					if (_this43.temporaryTags.includes(item.getAttribute('data-tag'))) {
						item.classList.add('is-active');
						item.parentNode.classList.add('is-selected'); // For the case of "ListItem"
					} else {
						item.classList.remove('is-active');
						item.parentNode.classList.remove('is-selected'); // For the case of "ListItem"
					}
				});
			}
		}, {
			key: '_commit',
			value: function _commit() {
				var _this44 = this;

				if (this.currentTags.sort().join(',') !== this.temporaryTags.sort().join(',')) {
					this.currentTags = this.temporaryTags.slice();
					this._reloadProducts();
				}

				if (this.filterDrawer.isOpen) {
					this.filterDrawer.close();
				}

				__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('[data-action="reset-tags"]')).forEach(function (resetButton) {
					resetButton.style.display = _this44.currentTags.length === 0 ? 'none' : 'block';
				});
			}
		}, {
			key: '_reloadProducts',
			value: function _reloadProducts() {
				var _this45 = this;

				document.dispatchEvent(new CustomEvent('theme:loading:start'));

				var filterElement = this.toolbarElement.querySelector('.CollectionToolbar__Item--filter');

				if (filterElement) {
					var filterElementCount = filterElement.querySelector('span');

					if (filterElementCount) {
						filterElement.removeChild(filterElementCount);
					}

					if (this.currentTags.length === 0) {
						filterElement.classList.add('Text--subdued');
					} else {
						filterElement.classList.remove('Text--subdued');
						filterElement.innerHTML += '<span class="Text--subdued">(' + this.currentTags.length + ')</span>';
					}
				}

				// We also rewrite the URL if browser supports it
				if (history.replaceState) {
					var tags = this.currentTags.length > 0 ? this.currentTags.join('+') : '';
					var newUrl = window.location.protocol + '//' + window.location.host + this.settings['collectionUrl'] + '/' + tags + '?sort_by=' + this.currentSortBy;

					window.history.pushState({ path: newUrl }, '', newUrl);
				}

				var formData = new FormData();
				formData.append('view', 'ajax');
				formData.append('sort_by', this.currentSortBy);

				fetch(location.pathname + '?view=ajax&sort_by=' + this.currentSortBy, {
					credentials: 'same-origin',
					method: 'GET'
				}).then(function (response) {
					response.text().then(function (content) {
						var tempElement = document.createElement('div');
						tempElement.innerHTML = content;

						_this45.collectionInnerElement.innerHTML = tempElement.querySelector('.shopify-section').innerHTML;
						document.dispatchEvent(new CustomEvent('theme:loading:end'));

						_this45._setupAnimation(true);

						// We scroll to the top
						var elementOffset = _this45.element.querySelector('.CollectionMain').getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue('--header-height'));

						if (__WEBPACK_IMPORTED_MODULE_4__helper_Responsive__["default"].matchesBreakpoint('lap-and-up') && _this45.toolbarElement && _this45.toolbarElement.clientHeight === 0) {
							elementOffset -= 50;
						}

						if (elementOffset < 0) {
							window.scrollBy({ top: elementOffset, behavior: 'smooth' });
						}
					});
				});
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._toggleTagListener = this._toggleTag.bind(this);
				this._applyTagsListener = this._applyTags.bind(this);
				this._resetTagsListener = this._resetTags.bind(this);
				this._changeLayoutModeListener = this._changeLayoutMode.bind(this);
				this._changeGhostfirstListener = this._changeGhostfirst.bind(this);

				this.delegateElement.on('click', '[data-action="toggle-tag"]', this._toggleTagListener);
				this.delegateElement.on('click', '[data-action="apply-tags"]', this._applyTagsListener);
				this.delegateElement.on('click', '[data-action="reset-tags"]', this._resetTagsListener);
				this.delegateElement.on('click', '[data-action="change-layout-mode"]', this._changeLayoutModeListener);
				this.delegateElement.on('click', '[data-action="change-ghost-mode"]', this._changeGhostfirstListener);

			}
		},{
			key: '_initInfinityScroll',
			value: function _initInfinityScroll(){
				let _this = this;
				//let offset = this.settings.infinityScrollOffset * 200;
				// let offset = window.innerHeight > 1300 ? window.innerHeight*2 : this.settings.infinityScrollOffset * 200;
				let offset = 1000;
				
				this.infinityScroll = new Ajaxinate({
					offset: offset,
					callback: function(e) {
						__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(e.querySelectorAll('.swym-product-view-snippet')).forEach(function (item) {
							eval(item.innerHTML)
						});
						if (_this.animationInited) {
							_this._setupAnimation();
						}
						
						// fix for layout customization
						let newCount = document.querySelector('[data-mobile-count]').getAttribute('data-mobile-count');
						__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(document.querySelectorAll('.Grid__Cell')).forEach(function (item) {
							item.classList.add('1/' + newCount + '--phone');
						});

						// Initialize carousels for newly loaded products
						_this._initializeProductCarousels();

					}
				});
			}
		}, { // Custom Filter
			key: '_initCollectionFilter',
			value: function _initCollectionFilter() {

				window.addEventListener('popstate', function (event) {
					const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
					if (searchParams === this.searchParamsPrev) return;          
					this._renderPage(searchParams, null, false);
				}.bind(this));

				this.delegateElement.on('click', '[data-filter="open"]', this._openFilterMenu.bind(this));
				this.delegateElement.on('click', '[data-filter="close"]', this._closeFilterMenu.bind(this));

				this.delegateElement.on("change", '#collection_filter, #collection_filter-mobile', function(){
					this._switchCloseButtonsState("off");
				}.bind(this));

				this.delegateElement.on("change", '#collection_filter, #collection_filter-mobile', debounce((event,target)=>{
					this._onSubmitForm(event,target);
				}, 800).bind(this));

				this.delegateElement.on('click', '[data-filter="clear"]', this._clearFilter.bind(this));
				
				this.documentDelegate.on('price-range:change', function(){
					this._switchCloseButtonsState("off");
				}.bind(this));

				this.documentDelegate.on('price-range:change', debounce((event,target)=>{
					let form = event.detail.form;
					this._onSubmitForm(event,form);
				}, 800).bind(this));

				this._getInitialPageData();
				this._sortFilterValues();
			}
		}, {
			key: "_getInitialPageData",
			value: function _getInitialPageData() {
				if (!!window.location.search) return;
				let html = this.element.parentNode.outerHTML;
				let url = `${window.location.pathname}?section_id=${this.elementID}&`;
				this.filterData.push({html, url})
			}
		}, { 
			key: '_openFilterMenu',
			value: function _openFilterMenu(event, target) {
				let buttonCoords = event.target.getBoundingClientRect();
				let topButtonCoords = buttonCoords.top;
				let bottomButtonCoords = window.innerHeight - buttonCoords.bottom;
				let filterForm = this.filterMenu.querySelector("#collection_filter");
				if (topButtonCoords > bottomButtonCoords) {
					filterForm.classList.add("test");
				}
				this.filterMenu.setAttribute("aria-hidden", false);
				document.body.classList.add('no-scroll');
				this.debounce = setTimeout(()=>{
					this.debounce = null;
				}, 600);
			} 
		}, {
			key: '_closeFilterMenu',
			value: function _closeFilterMenu(event, target) {
				event.preventDefault();
				if (this.debounce) return;
				this.filterMenu.setAttribute("aria-hidden", true);
				let filterForm = this.filterMenu.querySelector("#collection_filter");
				setTimeout(()=> {
					filterForm.classList.remove("test");
				}, 400);
				document.body.classList.remove('no-scroll');
				document.body.dispatchEvent(new CustomEvent('collapsible:force-close', {
						bubbles: true,
						detail: {
							container: this.filterMenu
						}
				}));
			} 
		}, {
			key: '_onSubmitForm',
			value: function _onSubmitForm(event,target) {
				let form = target.closest("form");
				let formData = new FormData(form);
				// if (formData.has("filter.v.option.size") || formData.has("filter.v.option.length")) {
				//   formData.append("filter.v.availability", 1);
				// }
				let filterActive = Boolean(Array.from(formData.entries()).length);
				if (filterActive) formData.append("filter.v.availability", 1);
				let searchParams = new URLSearchParams(formData).toString();
				this._renderPage(searchParams, event);
			}
		},{
			key: '_renderPage',
			value: function _renderPage(searchParams, event, updateURLHash = true) {
				document.dispatchEvent(new CustomEvent('theme:loading:start'));
				this.searchParamsPrev = searchParams;

				const url = `${window.location.pathname}?section_id=${this.elementID}&${searchParams}`;
				// How to render
				const filterDataUrl = element => element.url === url;

				if (updateURLHash) this._updateURLHash(searchParams);

				this.filterData.some(filterDataUrl) ?
				this._renderSectionFromCatch(filterDataUrl, event) :
				this._renderSectionFromFetch(url, event);
			}
		}, {
			key: '_renderSectionFromFetch',
			value: function _renderSectionFromFetch(url, event) {
				fetch(url)
					.then(response => response.text())
					.then((responseText) => {
						const html = responseText;
						this.filterData = [...this.filterData, { html, url }];
						this._renderSectionProducts(html);
						this.priceRangeElement._init();
						this._switchCloseButtonsState("on");
						document.dispatchEvent(new CustomEvent('theme:loading:end'));
					})
					.catch((error)=>{
						this._switchCloseButtonsState("on");
					});
			}
		}, {
			key: '_renderSectionFromCatch',
			value: function _renderSectionFromFetch(filterDataUrl, event) {
				const html = this.filterData.find(filterDataUrl).html;
				this._renderSectionProducts(html);
				this.priceRangeElement._init();
				this._switchCloseButtonsState("on");
				document.dispatchEvent(new CustomEvent('theme:loading:end'));
			}
		}, {
			key: "_updateURLHash",
			value: function _updateURLHash(searchParams) {
				history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
			}
		}, {
			key: "_renderSectionProducts",
			value: function _renderSectionProducts(html) {
				let tempElement = document.createElement("div");
				tempElement.innerHTML = html;
				let contentForReplacement = tempElement.querySelector(".CollectionInner__Products");
				let contentToReplace = this.element.querySelector(".CollectionInner__Products");
				contentToReplace.parentNode.replaceChild(contentForReplacement, contentToReplace);
				this._initInfinityScroll();
			}
		}, {
			key: '_clearFilter',
			value: function _clearFilter(event,target) {
				event.preventDefault();
				this._switchCloseButtonsState("off");
				__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(this.filterMenu.querySelectorAll('[type="checkbox"], [type="radio"]')).forEach(function (item) {
					item.checked = false;
				});
				this.priceRangeElement._clearPriceRange();
				let formToSubmit = this.filterMenu.querySelector("[data-filter-form]");
				this._onSubmitForm(event,formToSubmit);
			}
		}, {
			key: '_switchCloseButtonsState',
			value: function _switchCloseButtonsState(state) {
				let closeTriggers = this.filterMenu.querySelectorAll('[data-filter="close"]');
				__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(closeTriggers).forEach(selector=>{
					switch(selector.localName) {
						case "button":
							if (state === "on") {
								selector.disabled = false;
							} else {
								selector.disabled = true;
							}
							break;
						case "div":
							if (state === "on") {                
								selector.classList.remove("Disabled");
							} else {
								selector.classList.add("Disabled");
							}
							break;
					}
				});
			}
		}, 
		{
			key: '_sortFilterValues',
			value: function _sortFilterValues() {
				let option_containers = this.filterMenu.querySelectorAll("[data-sort-me]");
				
				// Looping through all options that need to be sorted
				__WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(option_containers).forEach(container=>{
					
					let options = container.querySelectorAll(".filter_option-wrapper");

					let regex = /^(\d*x)*(s|m|l)/i;

					let options_array = __WEBPACK_IMPORTED_MODULE_3__helper_Dom__["default"].nodeListToArray(options).filter(item=>{
						let attribute = item.getAttribute("data-filter-value").split(" ")[0];
						if (!regex.test(attribute)) return item;
					}).sort(compare).forEach((option, index)=>{
						option.style.order = index + 10;
					});

				});
				function compare(a,b) {
					let aValue = a.getAttribute("data-filter-value").slice().replace(/[^\d.,]/g, "");
					let bValue = b.getAttribute("data-filter-value").slice().replace(/[^\d.,]/g, "");
					return aValue - bValue;
				}
			} 
		}
	]);

		return CollectionSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = CollectionSection;

	/***/
},
/* 36 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Animation__ = __webpack_require__(7);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);

	var FaqSection = function () {
		function FaqSection(element) {
			_classCallCheck(this, FaqSection);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);

			this._attachListeners();
		}

		_createClass(FaqSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.delegateElement.off();
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				this._openItem(event.target);
			}
		}, {
			key: 'onBlockDeselect',
			value: function onBlockDeselect(event) {
				this._closeItem(event.target);
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '.Faq__Question', this._toggleItem.bind(this));
				this.delegateElement.on('click', '.FaqSummary__Item', this._switchToCategory.bind(this));
			}
		}, {
			key: '_switchToCategory',
			value: function _switchToCategory(event, target) {
				target.classList.add('is-active');

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].getSiblings(target, '.is-active').forEach(function (item) {
					item.classList.remove('is-active');
				});
			}
		}, {
			key: '_toggleItem',
			value: function _toggleItem(event, target) {
				var item = target.closest('.Faq__Item');

				if (item.getAttribute('aria-expanded') === 'true') {
					this._closeItem(item);
				} else {
					this._openItem(item);
				}
			}
		}, {
			key: '_openItem',
			value: function _openItem(item) {
				var answerWrapper = item.querySelector('.Faq__AnswerWrapper');

				item.setAttribute('aria-expanded', 'true');

				answerWrapper.setAttribute('aria-hidden', 'false');
				__WEBPACK_IMPORTED_MODULE_0__helper_Animation__["default"].slideDown(answerWrapper, true);

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].getSiblings(item, '[aria-expanded="true"]').forEach(function (siblingItem) {
					var siblingAnswerWrapper = siblingItem.querySelector('.Faq__AnswerWrapper');

					siblingItem.setAttribute('aria-expanded', 'false');

					siblingAnswerWrapper.setAttribute('aria-hidden', 'true');
					__WEBPACK_IMPORTED_MODULE_0__helper_Animation__["default"].slideUp(siblingAnswerWrapper);
				});
			}
		}, {
			key: '_closeItem',
			value: function _closeItem(item) {
				var answerWrapper = item.querySelector('.Faq__AnswerWrapper');

				item.setAttribute('aria-expanded', 'false');
				answerWrapper.setAttribute('aria-hidden', 'true');
				__WEBPACK_IMPORTED_MODULE_0__helper_Animation__["default"].slideUp(answerWrapper);
			}
		}]);

		return FaqSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = FaqSection;

	/***/
},
/* 37 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__ = __webpack_require__(4);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(10);

	var FeaturedCollectionsSection = function () {
		function FeaturedCollectionsSection(container) {
			var _this46 = this;

			_classCallCheck(this, FeaturedCollectionsSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.options = JSON.parse(this.element.getAttribute('data-settings'));

			this.carousels = [];

			__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
				_this46.carousels.push(new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](item));
			});

			// Setup product item color swatch
			new __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__["default"](this.element);

			this._setupAnimation();
			this._attachListeners();
		}

		_createClass(FeaturedCollectionsSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.carousels.forEach(function (item) {
					return item.destroy();
				});
				this.delegateElement.off('click');

				this.intersectionObserver.disconnect();
				this.timeline.kill();
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				// We simply trigger a click on the element that controls this tab
				this.element.querySelector('[aria-controls="' + event.target.id + '"]').click();
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '[data-action="toggle-tab"]', this._switchTab.bind(this));
			}
		}, {
			key: '_switchTab',
			value: function _switchTab(event, target) {
				var _this47 = this;

				// If the tab is already active, do nothing
				if (target.classList.contains('is-active')) {
					return;
				}

				// First, switch the current tab
				target.classList.add('is-active');
				__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].getSiblings(target, '.is-active').forEach(function (item) {
					item.classList.remove('is-active');
				});

				// Then, display the panel
				var tabPanelToShow = this.element.querySelector('#' + target.getAttribute('aria-controls'));

				this.timeline.eventCallback('onReverseComplete', function () {
					tabPanelToShow.setAttribute('aria-hidden', 'false');

					__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].getSiblings(tabPanelToShow, '.TabPanel[aria-hidden="false"]').forEach(function (item) {
						item.setAttribute('aria-hidden', 'true');
					});

					if (__WEBPACK_IMPORTED_MODULE_3__helper__["ResponsiveHelper"].matchesBreakpoint('lap-and-up')) {
						_this47.carousels.forEach(function (carousel) {
							// There is a bug in Safari where it cannot detect the pseudo-element "::after" if the tab panel is hidden. As a consequence,
							// we manually activate it
							carousel.flickityInstance.activate();
							carousel.flickityInstance.resize(); // Ugly hack
						});
					}

					_this47.timeline.clear();
					_this47._setupAnimation();
				});

				if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
					this.timeline.reverse().timeScale(3);
				} else {
					this.timeline.reverse();
				}
			}
		}, {
			key: '_setupAnimation',
			value: function _setupAnimation() {
				var _this48 = this;

				if (this.intersectionObserver) {
					this.intersectionObserver.disconnect();
				}

				this.timeline = new TimelineLite({ delay: 0.5 });

				if (this.options['layout'] === 'grid' && window.theme.showElementStaggering) {
					this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));

					__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.TabPanel[aria-hidden="false"] .ProductList .ProductItem')).forEach(function (item) {
						_this48.intersectionObserver.observe(item);
					});
				} else {
					var productList = this.element.querySelector('.TabPanel[aria-hidden="false"] .ProductList');

					if (productList) {
						this.timeline.fromTo(productList, 0.6, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 });
					}
				}
			}
		}, {
			key: '_reveal',
			value: function _reveal(results) {
				var _this49 = this;

				var toReveal = [];

				results.forEach(function (result) {
					if (result.isIntersecting || result.intersectionRatio > 0) {
						// isIntersecting does not exist on Samsung Android browser
						toReveal.push(result.target);
						_this49.intersectionObserver.unobserve(result.target);
					}
				});

				if (toReveal.length === 0) {
					return;
				}

				this.timeline.staggerFromTo(toReveal, 0.45, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 }, 0.2);
			}
		}]);

		return FeaturedCollectionsSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = FeaturedCollectionsSection;

	/***/
},
/* 38 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_ProductVariants__ = __webpack_require__(11);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Image__ = __webpack_require__(9);

	var FeaturedProductSection = function () {
		function FeaturedProductSection(container) {
			_classCallCheck(this, FeaturedProductSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

			if (!this.options['usePlaceholder'] && this.options['templateSuffix'] !== 'coming-soon') {
				this.productVariants = new __WEBPACK_IMPORTED_MODULE_0__components_ProductVariants__["default"](container, this.options);
			}

			// We have to re-order elements in the DOM
			var offscreenElement = this.element.querySelector('.Product__OffScreen');

			if (offscreenElement) {
				this.element.appendChild(offscreenElement);
			}

			this._attachListeners();
		}

		_createClass(FeaturedProductSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.delegateElement.off('click');

				if (this.productVariants) {
					this.productVariants.destroy();
				}
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('variant:changed', this._updateMainImage.bind(this));
			}

			/**
			 * Update the main featured image
			 */

		}, {
			key: '_updateMainImage',
			value: function _updateMainImage(event) {
				var variant = event.detail.variant,
						previousVariant = event.detail.previousVariant;

				if (!variant || !variant['featured_image'] || previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
					return;
				}

				// Otherwise we are on the home page. It's a bit more complex as we have to rewrite some code normally written in Liquid
				var newImage = variant['featured_image'];

				var mainImageContainer = this.element.querySelector('.FeaturedProduct__Gallery .AspectRatio');
				mainImageContainer.style.cssText = 'max-width: ' + newImage['width'] + 'px; --aspect-ratio: ' + newImage['width'] / newImage['height'];

				var newImageElement = document.createElement('img');
				newImageElement.classList.add('Image--lazyLoad');
				newImageElement.setAttribute('data-src', __WEBPACK_IMPORTED_MODULE_1__helper_Image__["default"].getSizedImageUrl(newImage['src'], '1x1').replace('_1x1.', '_{width}x.'));
				newImageElement.setAttribute('data-widths', '[' + __WEBPACK_IMPORTED_MODULE_1__helper_Image__["default"].getSupportedSizes(newImage, [200, 400, 600, 700, 800, 900, 1000]).join(',') + ']');
				newImageElement.setAttribute('data-sizes', 'auto');

				mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));
			}
		}]);

		return FeaturedProductSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = FeaturedProductSection;

	/***/
},
/* 39 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Popover__ = __webpack_require__(3);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Form__ = __webpack_require__(22);

	var FooterSection = function () {
		function FooterSection(container) {
			_classCallCheck(this, FooterSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.forms = document.querySelectorAll('.footer_newsletter_form');

			var localePopoverElement = document.getElementById('footer-locale-popover');
			if (localePopoverElement) {
				this.localePopover = new __WEBPACK_IMPORTED_MODULE_0__components_Popover__["default"](localePopoverElement, { preferredAlignment: 'center', preferredPosition: 'top', threshold: 12 });
			}

			var currencyPopoverElement = document.getElementById('footer-currency-popover');
			if (currencyPopoverElement) {
				this.currencyPopover = new __WEBPACK_IMPORTED_MODULE_0__components_Popover__["default"](currencyPopoverElement, { preferredAlignment: 'center', preferredPosition: 'top', threshold: 12 });
			}
			window.addEventListener('scroll', this.adjustFooterOpacity.bind(this));
			this.forms.forEach(form => {
				this._attachEventListeners(form);
			});
		}

		_createClass(FooterSection, [{
			key: 'onUnload',
			value: function onUnload() {
				if (this.localePopover) {
					this.localePopover.destroy();
				}

				if (this.currencyPopover) {
					this.currencyPopover.destroy();
				}
			}
		},{
			key: '_attachEventListeners',
			value: function _attachEventListeners(form){
				form.addEventListener('submit', (event) => {
					event.preventDefault(); // Prevent the default form submission
					this._footerFormSubmit(form); // Call a function to handle the form data
				});
			}
		},
		{
			key: 'adjustFooterOpacity',
			value: function adjustFooterOpacity(){
				const footerSection = document.querySelector('#shopify-section-footer-updated');
				const footer = document.querySelector('#section-footer-updated');
				const windowHeight = window.innerHeight;
				const documentHeight = document.documentElement.scrollHeight;
				if (window.innerWidth >= 768) {
				window.addEventListener('scroll', () => {
					const scrollPosition = window.scrollY;
					const triggerDistance = documentHeight - windowHeight - 800; // Adjust trigger point
					if (scrollPosition >= 300) {
						footerSection.style.opacity = '1';
					} else {
						footerSection.style.opacity = '0';
					}
					if (scrollPosition >= triggerDistance) {
						const opacity = Math.min(1, (scrollPosition - triggerDistance) / 800);
						footer.style.opacity = opacity;
					} else {
						footer.style.opacity = '0';
					}
				});
				}
			}
		},
		{
			key: '_footerFormSubmit',
			value: function _footerFormSubmit(form) {
				const formData = new FormData(form);
				const email = formData.get('email');
				const name = formData.get('name') || ''; // Default to empty string if name is null/undefined
				const formType = form.getAttribute('data-signup-form') || 'other';
				// Check for custom list ID first, fall back to default footer list ID
				const listID = form.getAttribute('data-klaviyoList') || window.theme.klaviyoFooterListID;
				const klaviyoPublicAPI = window.theme.klaviyoAPIKey;

				// Create profile attributes object
				const profileAttributes = {
					email: email
				};
			
				// Only add first_name if name is not empty
				if (name.trim()) {
					profileAttributes.first_name = name;
				}

				// First payload - subscribe to list (this part stays the same)
				const footerSignupPayload = {
					data: {
						type: "subscription",
						attributes: {
							custom_source: formType,
							profile: {
								data: {
									type: "profile",
									attributes: {
										first_name: name,
										email: email,
										subscriptions: {
											email: {
												marketing: {
													consent: "SUBSCRIBED"
												}
											}
										}
									}
								}
							}
						},
						relationships: {
							list: {
								data: {
									type: "list",
									id: listID
								}
							}
						}
					}
				};

				// Second payload - track the event
				const customerProperties = {
					$email: email
				};
				// Only add $first_name if name is not empty
				if (name.trim()) {
					customerProperties.$first_name = name;
				}
				

				// Second payload - track the event (simplified for Klaviyo's event tracking)
				const metricEventPayload = {
					token: klaviyoPublicAPI,
					event: "Newsletter API Signup",
					customer_properties: customerProperties,
					properties: {
						action: "submit",
						form_type: formType,
						page_url: window.location.href,
						page_type: window.location.pathname.includes('/products/') ? 'product' :
						window.location.pathname.match(/^\/collections(?!.*\/products)/) ? 'collection' : 
						'other'
					}
				};

				console.log('📧 Newsletter Signup (EVENT):', {
					email: email,
					name: name,
					formType: formType,
					pageType: metricEventPayload.properties.page_type,
					listID: listID,
					customerProperties: customerProperties
				});

				// Send subscription request
				fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${klaviyoPublicAPI}`, {
					method: 'POST',
					headers: {
						accept: 'application/vnd.api+json',
						revision: '2025-04-15',
						'content-type': 'application/vnd.api+json'
					},
					body: JSON.stringify(footerSignupPayload)
				})
				.then(response => {
					console.log('📧 Subscription API Response Status:', response.status);
					console.log('📧 Subscription API Response Headers:', response.headers);
					
					// Clone the response so we can read it twice
					const responseClone = response.clone();
					
					return responseClone.text().then(text => {
						console.log('📧 Subscription API Response Body:', text);
						
						if (!response.ok) {
							console.error('❌ Subscription API Error:', text);
							throw new Error('Subscription request failed');
						}
						
						console.log('✅ Subscription API Success!');
						
						// After successful subscription, track the event using Klaviyo's track endpoint
						return fetch(`https://a.klaviyo.com/api/track`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							},
							body: `data=${encodeURIComponent(JSON.stringify(metricEventPayload))}`
						});
					});
				})
				.then(response => {
					console.log('�� Event Tracking API Response Status:', response.status);
					
					if (!response.ok) {
						return response.text().then(text => {
							console.error('❌ Event tracking failed:', text);
							throw new Error('Event tracking failed');
						});
					}
					
					console.log('✅ Event tracking successful!');
					console.log('✅ Newsletter signup successful!');
					console.log('�� Final payload sent:', footerSignupPayload);
					
					// Handle success UI
					let formContainer = form.parentNode;
					let submitButton = formContainer.querySelector('button');
					let successMessage = formContainer.querySelector('.successMessage');
					form.style.display = 'none';
					submitButton.style.display = 'none';
					successMessage.style.display = 'block';
					
					// Close popup if needed
					setTimeout(() => {
						let newsletterPopup = document.querySelector('.NewsletterPopup');
						if (newsletterPopup) {
							newsletterPopup.querySelector('.NewsletterPopup__Close').click();
							newsletterPopup.remove();
						}
					}, 3000);
				})
				.catch(error => {
					console.error("❌ Newsletter signup error:", error);
				});
			}
		}]);

		return FooterSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = FooterSection;

	/***/
},
/* 40 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var GiftCardSection = function () {
		function GiftCardSection(container) {
			_classCallCheck(this, GiftCardSection);

			this.element = container;

			this._createQrCode();
			this._setupPrint();
		}

		_createClass(GiftCardSection, [{
			key: '_createQrCode',
			value: function _createQrCode() {
				var qrCodeElement = document.getElementById('QrCode');

				new QRCode(qrCodeElement, {
					text: qrCodeElement.getAttribute('data-identifier'),
					width: 120,
					height: 120
				});
			}
		}, {
			key: '_setupPrint',
			value: function _setupPrint() {
				var printElement = document.getElementById('PrintGiftCard');

				if (printElement) {
					printElement.addEventListener('click', function () {
						window.print();
					});
				}
			}
		}]);

		return GiftCardSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = GiftCardSection;

	/***/
},
/* 41 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Responsive__ = __webpack_require__(1);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__components_Popover__ = __webpack_require__(3);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(21);

	var HeaderSection = function () {
		function HeaderSection(container) {
			var _this50 = this;

			_classCallCheck(this, HeaderSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.body);
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
			this.lastScrollPosition = -1;
			this.isTouch = window.matchMedia('(-moz-touch-enabled: 1), (hover: none)').matches;

			this.appearance = {
				windowScrollY: window.scrollY,
				downThreshold: 20,
				upThreshold: 20,
				invalidPages: ["help-centre", "help-center"],
				invalidTemplates: ["collection", "product"]
			};
			

			if (this.options['isSticky']) {
				Stickyfill.addOne(this.element.parentNode);
			}

			// Set up the search bar
			this.searchBar = new __WEBPACK_IMPORTED_MODULE_3__components__["SearchBar"]();

			this._attachListeners();
			this._verifyNavigationOverlap();

			// We set again some CSS variables that are used for some calculations in CSS
			var mainLogo = this.element.querySelector('.Header__LogoImage--primary');

			if (mainLogo && !mainLogo.complete) {
				mainLogo.addEventListener('load', function () {
					fastdom.measure(function () {
						document.documentElement.style.setProperty('--header-height', _this50.element.clientHeight + 'px');
						document.documentElement.style.setProperty('--header-is-not-transparent', _this50.options['hasTransparentHeader'] ? 0 : 1);
					});
				});
			} else {
				fastdom.measure(function () {
					document.documentElement.style.setProperty('--header-height', _this50.element.clientHeight + 'px');
					document.documentElement.style.setProperty('--header-is-not-transparent', _this50.options['hasTransparentHeader'] ? 0 : 1);
				});
			}
			this._checkTransparentHeader("initial");
			this._setupLocalizationPopovers();
			this._handleMenuImages();
		}
 
		_createClass(HeaderSection, [{
			key: 'checkMousePosition',
			value: function checkMousePosition(event) {
				let element = event.target.closest(".Header");
				if (element) {
					this._focusNavigation();
				}
			}
		}, {
			key: 'onUnload',
			value: function onUnload() {
				this.element.removeEventListener('mouseleave', this._closeNavigationListener);
				this.element.removeEventListener('mouseenter', this._focusNavigationListener);
				this.element.removeEventListener('focusin', this._focusNavigationListener);

				this.delegateElement.off();

				window.removeEventListener('scroll', this._checkTransparentHeaderListener);
				window.removeEventListener('resize', this._verifyNavigationOverlapListener);

				if (this.options['isSticky']) {
					Stickyfill.removeOne(this.element.parentNode);
				}

				this.searchBar.destroy();

				this.localizationPopovers.forEach(function (localizationPopover) {
					localizationPopover.destroy();
				});
			}
		}, {
			key: 'onSelect',
			value: function onSelect() {
				this._checkTransparentHeader();
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				var _this51 = this;

				_this51.element.removeEventListener('mouseleave', this._closeNavigationListener);

				var listItem = event.target.closest('.HorizontalList__Item');

				fastdom.mutate(function () {
					event.target.setAttribute('aria-hidden', 'false');

					if (listItem) {
						listItem.classList.add('is-expanded');

						__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].getSiblings(listItem, '.is-expanded').forEach(function (item) {
							item.classList.remove('is-expanded');
						});
					}
					_this51.element.classList.remove('MobileHeader--transparent');
					_this51.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible
				});
			}
		}, {
			key: 'onBlockDeselect',
			value: function onBlockDeselect(event) {
				var listItem = event.target.closest('.HorizontalList__Item');

				this.element.addEventListener('mouseleave', this._closeNavigationListener);

				fastdom.mutate(function () {
					event.target.setAttribute('aria-hidden', 'true');

					if (listItem) {
						listItem.classList.remove('is-expanded');
					}
				});

				this._checkTransparentHeader();
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._checkTransparentHeaderListener = this._checkTransparentHeader.bind(this);
				this._closeNavigationListener = this._closeNavigation.bind(this);
				this._focusNavigationListener = this._focusNavigation.bind(this);
				this._verifyNavigationOverlapListener = this._verifyNavigationOverlap.bind(this);
				this._checkMousePositionListener = this.checkMousePosition.bind(this);

				this._handleDrawerOpenEventListener = this._handleDrawerOpenEvent.bind(this);
				this._handleDrawerCloseEventListener = this._handleDrawerCloseEvent.bind(this);
				
				this.element.addEventListener('mouseleave', this._closeNavigationListener);

				window.addEventListener('mousemove', this._checkMousePositionListener, {once: true});

				this.delegateElement.on('mouseenter', '.Header__MainNav .HorizontalList__Item, [aria-haspopup]', this._openMenu.bind(this), true);
				this.delegateElement.on('focusin', '[aria-haspopup]', this._openMenu.bind(this), true);
				this.delegateElement.on('focusout', '[aria-haspopup]', this._closeMenu.bind(this), true);

				this.delegateElement.on('click', '[data-action="toggle-search"]', this._closeNavigationListener);
				this.delegateElement.on('mouseleave', '.DropdownMenu [aria-haspopup]', this._closeMenu.bind(this), true);
				this.delegateElement.on('mouseenter', '.DropdownMenu [aria-haspopup]', this._adjustDropdownPosition.bind(this), true);

				if (this.isTouch) {
					this.delegateElement.on('click', '.Header__MainNav [aria-haspopup]', this._handleTouchMenu.bind(this));
				}

				if (this.options['hasTransparentHeader'] || this.options['hasMobileTransparentHeader']) {
					this.element.addEventListener('mouseenter', this._focusNavigationListener);
					this.element.addEventListener('focusin', this._focusNavigationListener);
				}

				if (this.options['isSticky'] && (this.options['hasTransparentHeader'] || this.options['hasMobileTransparentHeader'])) {
					window.addEventListener('scroll', this._checkTransparentHeaderListener);
				}

				if (this.options['navigationStyle'] === 'inline' || this.options['navigationStyle'] === 'logoLeft') {
					window.addEventListener('resize', this._verifyNavigationOverlapListener);
				}
				
				document.addEventListener('drawer:open', this._handleDrawerOpenEventListener);
				document.addEventListener('drawer:close', this._handleDrawerCloseEventListener);
				document.addEventListener('drawer:close:transitionend', this._checkTransparentHeaderListener);
				document.addEventListener('search:close:transitionend', this._checkTransparentHeaderListener);
				window.addEventListener('resize', this._handleMenuImages.bind(this));
				window.addEventListener('scroll', this.headerAppearance.bind(this));
			}
		}, {
			key: '_handleDrawerOpenEvent',
			value: function _handleDrawerOpenEvent(event) {
				this.element.removeEventListener('mouseleave', this._closeNavigationListener);
			}
		}, {
			key: '_handleDrawerCloseEvent',
			value: function _handleDrawerCloseEvent(event) {
				this.element.addEventListener('mouseleave', this._closeNavigationListener);
			}
		}, {
			key: '_setupLocalizationPopovers',
			value: function _setupLocalizationPopovers() {
				// Prestige is an extremely complex theme, especially in the header due to the various layouts that power different
				// features. One issue that arises with this is that we output the localization elements twice in the DOM (with the
				// same ID as we're doing a capture in Liquid), and then depending on the screen size one layout is choosen. We therefore
				// have to de-duplicate the ID here. This is honestly not the cleanest code on earth, but I prefer handling this here
				// rather than duplicating too much Liquid
				this.localizationPopovers = [];

				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll('#header-locale-popover')).forEach(function (item, index) {
					item.id = item.id + '-' + index;
				});
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll('[aria-controls="header-locale-popover"]')).forEach(function (item, index) {
					item.setAttribute('aria-controls', item.getAttribute('aria-controls') + '-' + index);
				});

				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll('#header-currency-popover')).forEach(function (item, index) {
					item.id = item.id + '-' + index;
				});
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll('[aria-controls="header-currency-popover"]')).forEach(function (item, index) {
					item.setAttribute('aria-controls', item.getAttribute('aria-controls') + '-' + index);
				});

				var localePopoverElement1 = document.getElementById('header-locale-popover-0');
				if (localePopoverElement1) {
					this.localizationPopovers.push(new __WEBPACK_IMPORTED_MODULE_2__components_Popover__["default"](localePopoverElement1, { preferredAlignment: 'center', preferredPosition: 'bottom', threshold: 12 }));
				}
				var localePopoverElement2 = document.getElementById('header-locale-popover-1');
				if (localePopoverElement2) {
					this.localizationPopovers.push(new __WEBPACK_IMPORTED_MODULE_2__components_Popover__["default"](localePopoverElement2, { preferredAlignment: 'center', preferredPosition: 'bottom', threshold: 12 }));
				}

				var currencyPopoverElement1 = document.getElementById('header-currency-popover-0');
				if (currencyPopoverElement1) {
					this.localizationPopovers.push(new __WEBPACK_IMPORTED_MODULE_2__components_Popover__["default"](currencyPopoverElement1, { preferredAlignment: 'center', preferredPosition: 'bottom', threshold: 12 }));
				}
				var currencyPopoverElement2 = document.getElementById('header-currency-popover-1');
				if (currencyPopoverElement2) {
					this.localizationPopovers.push(new __WEBPACK_IMPORTED_MODULE_2__components_Popover__["default"](currencyPopoverElement2, { preferredAlignment: 'center', preferredPosition: 'bottom', threshold: 12 }));
				}
			}
		}, {
			key: '_focusNavigation',
			value: function _focusNavigation() {
				var _this52 = this;
				if ( __WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('tablet-and-up')) {
					this.disableTransparentCheck = true;
				}
				fastdom.mutate(function () {
					if (_this52.options['hasTransparentHeader']) {
						if (!_this52.isTouch || __WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('tablet-and-up')) {
							_this52.element.classList.remove('Header--transparent');
						}
					}
					if (_this52.options['hasMobileTransparentHeader']) {
						if (_this52.isTouch || __WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('phone')) {
							_this52.element.classList.remove('MobileHeader--transparent');
						}
					}
				});
			}
		}, {
			key: '_closeNavigation',
			value: function _closeNavigation(event) {
				var _this53 = this;
				this.disableTransparentCheck = false;
				fastdom.mutate(function () {
					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(_this53.element.querySelectorAll('.is-expanded')).forEach(function (item) {
						item.classList.remove('is-expanded');
					});

					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(_this53.element.querySelectorAll('.Header__MainNav [aria-hidden="false"]')).forEach(function (item) {
						item.setAttribute('aria-hidden', 'true');
					});
				});
				
				if (event) {
					if ((this.options['hasTransparentHeader'] || this.options['hasMobileTransparentHeader']) && event.toElement != null && !event.toElement.classList.contains("PageOverlay")) {
						this._checkTransparentHeader();
					}
				}
			}
		}, {
			key: '_openMenu',
			value: function _openMenu(event, target) {
				if (event.type === 'mouseenter' && target !== event.target) {
					return;
				}
				
				fastdom.mutate(function () {
					target.classList.add('is-expanded');
					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(target.children, '.Header__MainNav [aria-hidden="true"]').forEach(function (item) {
						item.setAttribute('aria-hidden', 'false');
						item.style.zIndex = "100";
						setTimeout(()=>{
							item.style.zIndex = null;
						}, 310)
					});

					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].getSiblings(target, '.is-expanded').forEach(function (item) {
						item.classList.remove('is-expanded');

						__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(item.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
							item.setAttribute('aria-hidden', 'true');
							item.style.zIndex = "-1";
							setTimeout(()=>{
								item.style.zIndex = null;
							}, 510)
						});
					});
				});
			}
		}, {
			key: '_closeMenu',
			value: function _closeMenu(event, target) {
				
				if (event.type === 'mouseleave' && target !== event.target) {
					return;
				}

				fastdom.mutate(function () {
					target.classList.remove('is-expanded');
					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(target.children, '.Header__MainNav [aria-hidden="false"]').forEach(function (item) {
						item.setAttribute('aria-hidden', 'true');
					});
				});
			}
		}, {
			key: '_adjustDropdownPosition',
			value: function _adjustDropdownPosition(event, target) {
				var nestedMenus = __WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(target.querySelectorAll('.DropdownMenu')),
						shouldOpenLeft = false;

				fastdom.measure(function () {
					var windowWidth = window.innerWidth,
							rightEdge = target.getBoundingClientRect().right;

					nestedMenus.forEach(function (item) {
						if (rightEdge + item.offsetWidth > windowWidth) {
							shouldOpenLeft = true;
						}
					});
				});

				fastdom.mutate(function () {
					if (shouldOpenLeft) {
						nestedMenus.forEach(function (item) {
							item.classList.add('DropdownMenu--reversed');
						});
					} else {
						nestedMenus.forEach(function (item) {
							item.classList.remove('DropdownMenu--reversed');
						});
					}
				});
			}

			/**
			 * On touch devices where we display the standard menu (like landscape iPad or Surface) we need to do additional code to properly
			 * handle the opening of menu. Especially, what we do is that if an item has a sub-menu, a click does not follow the link but instead open
			 * the sub-menu. If this link is clicked a second twice, then the menu is followed
			 */

		}, {
			key: '_handleTouchMenu',
			value: function _handleTouchMenu(event, target) {
				if (!target.classList.contains('is-expanded')) {
					event.preventDefault();
				}
			}
		}, {
			key: '_verifyNavigationOverlap',
			value: function _verifyNavigationOverlap() {
				var _this54 = this;
				var isOverlapping = false;

				fastdom.measure(function () {
					// To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
					var mainTopMenu = _this54.element.querySelector('.Header__MainNav');

					if (mainTopMenu) {
						// Get the first element
						var firstNavElementHeight = __WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].outerHeightWithMargin(mainTopMenu.querySelector('.HorizontalList__Item')),
								mainNavHeight = mainTopMenu.scrollHeight;
						
						if (mainNavHeight > firstNavElementHeight) {
							// isOverlapping = true;
						}
					}
				});

				this.element.classList.remove('Header--logoLeft', 'Header--inline', 'Header--center');
				this.element.classList.add('Header--' + this.options['navigationStyle']);
				this.element.clientWidth; // Forces a reflow

				fastdom.mutate(function () {
					if (isOverlapping) {
						_this54.element.classList.remove('Header--' + _this54.options['navigationStyle']);
						_this54.element.classList.add('Header--center');
					} else {
						_this54.element.classList.add('Header--' + _this54.options['navigationStyle']);
						_this54.element.classList.remove('Header--center');
					}

					_this54.element.classList.add('Header--initialized');

					fastdom.measure(function () {
						document.documentElement.style.setProperty('--header-height', _this54.element.clientHeight + 'px');
					});
				});
			}

			/**
			 * If the header mode is set to "transparent", we have to do extra work to automatically make it with fill colors when the
			 * user starts scrolling. For performance we are using fastDOM to do that (which relies of requestAnimationFrame instead of
			 * scroll listener)
			 */

		}, {
			key: '_checkTransparentHeader',
			value: function _checkTransparentHeader(string) {
				if (this.disableTransparentCheck) return;
				var _this55 = this;
				let activeClass;
				
				if (__WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('phone')) {
					this.element.classList.remove("Header--transparent");
					activeClass = "MobileHeader--transparent";
				}

				if (__WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('tablet-and-up')) {
					this.element.classList.remove("MobileHeader--transparent");
					activeClass = "Header--transparent";
				}

				if (!this.options['hasTransparentHeader'] && __WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('tablet-and-up')) {
					this.element.classList.remove("Header--transparent");
					return;
				}

				if (!this.options['hasMobileTransparentHeader'] && __WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('phone')) {
					this.element.classList.remove("MobileHeader--transparent");
					return;
				}

				var scrollThreshold = 10; // Threshold for initial scroll detection
				var whiteThreshold = 300; // Threshold for turning header white (desktop only)
				var isDesktop = __WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('tablet-and-up');
				// Use 300px threshold only on desktop, use 10px threshold on mobile
				var effectiveThreshold = isDesktop ? whiteThreshold : scrollThreshold;

				fastdom.measure(function () {
					_this55.lastScrollPosition = window.scrollY;
				});

				fastdom.mutate(function () {
					if (_this55.lastScrollPosition <= effectiveThreshold) {
						// Desktop: At top or between 10px-300px - keep transparent
						// Mobile: At top or <= 10px - keep transparent (but mobile uses 10px threshold, so this is same as scrollThreshold)
						_this55.element.classList.add(activeClass);
					} else {
						// Desktop: Scrolled past 300px - remove transparent class to turn white
						// Mobile: Scrolled past 10px - remove transparent class immediately
						if (string === "initial") {
							_this55.element.classList.add("FastTransparency");
							_this55.element.classList.remove(activeClass);
							let onTransitionEnd = function onTransitionEnd(event) {
								if (event.propertyName === 'background-color') {
									_this55.element.classList.remove("FastTransparency");
									_this55.element.removeEventListener('transitionend', onTransitionEnd);
								}
							};
							_this55.element.addEventListener('transitionend', onTransitionEnd);
						} else {
							_this55.element.classList.remove(activeClass);
						}
					}
				});
				
			}
		}, {
			key: '_handleMenuImages',
			value: function __handleMenuImages(event) {
				let imageItemContainers = this.element.querySelectorAll(".blocks_part");
				Array.from(imageItemContainers).forEach( container => {
					let coords = container.getBoundingClientRect();
					let imageWidth = parseInt(getComputedStyle(container).getPropertyValue('--min-width').match(/\d+/)[0]);
					let gap = parseInt(getComputedStyle(container).getPropertyValue('--gap').match(/\d+/)[0]);
					let counter = Math.floor(coords.width / (imageWidth + gap));
					let images = container.querySelectorAll(".MegaMenu__Push");
					Array.from(images).forEach( (image,index) => {
						if (index >= counter) {
							image.style.display = "none";
						} else {
							image.style.display = "inline-block";
						}
					})
				})
			}
		}, {
			key: "headerAppearance",
			value: function headerAppearance(event) {

				// double logo with animations
				// START
				/*
				let desktopHideableLogo = document.querySelector('.onLoadLogo');
				let mainHeaderEl = document.querySelector('#shopify-section-header');
				if (this.appearance.invalidPages.includes(this.options.pageHandle) || 
				this.appearance.invalidTemplates.includes(this.options.pageTemplate)) {
					this.element.setAttribute("data-appearance", "visible");
					desktopHideableLogo.setAttribute("data-appearance", "visible");
					mainHeaderEl.setAttribute("data-appearance", "visible");
					return;
				} 
				if ( !__WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('tablet-and-up')) {
					this.element.setAttribute("data-appearance", "visible")
					desktopHideableLogo.setAttribute("data-appearance", "visible");
					mainHeaderEl.setAttribute("data-appearance", "visible");
				} else {
					if (this.appearance.windowScrollY - window.scrollY < 0 && window.scrollY > 0) {
						// scrolling down
						if (this.element.dataset.appearance == 'hidden') {
							this.appearance.windowScrollY = window.scrollY;
							return;
						}
						if (Math.abs(this.appearance.windowScrollY - window.scrollY) > this.appearance.downThreshold) {
							this._closeNavigation();
							this.element.setAttribute("data-appearance", "hidden")
							desktopHideableLogo.setAttribute("data-appearance", "hidden");
							mainHeaderEl.setAttribute("data-appearance", "hidden");
							this.appearance.windowScrollY = window.scrollY;
						}
					} else {
						// scrolling up
						if (this.element.dataset.appearance == 'visible') {
							this.appearance.windowScrollY = window.scrollY;
							return;
						}
						if (Math.abs(this.appearance.windowScrollY - window.scrollY) > this.appearance.upThreshold) {
							this.element.setAttribute("data-appearance", "visible");
							desktopHideableLogo.setAttribute("data-appearance", "visible");
							mainHeaderEl.setAttribute("data-appearance", "visible");
							this.appearance.windowScrollY = window.scrollY;
						}
					}
				}
				*/
				// END
				
								// comment out for fixed header. All pages now have fixed header:
				// this.element.setAttribute("data-appearance", "visible");
				// 	return;


				if (this.appearance.invalidPages.includes(this.options.pageHandle) || 
				this.appearance.invalidTemplates.includes(this.options.pageTemplate)) {
					this.element.setAttribute("data-appearance", "visible");
					return;
				} 

				if ( !__WEBPACK_IMPORTED_MODULE_1__helper_Responsive__["default"].matchesBreakpoint('tablet-and-up')) {
					this.element.setAttribute("data-appearance", "visible")
				} else {
					if (this.appearance.windowScrollY - window.scrollY < 0 && window.scrollY > 0) {
						// scrolling down
						if (this.element.dataset.appearance == 'hidden') {
							this.appearance.windowScrollY = window.scrollY;
							return;
						}
						if (Math.abs(this.appearance.windowScrollY - window.scrollY) > this.appearance.downThreshold) {
							this._closeNavigation();
							this.element.setAttribute("data-appearance", "hidden")
							this.appearance.windowScrollY = window.scrollY;
						}
					} else {
						// scrolling up
						if (this.element.dataset.appearance == 'visible') {
							this.appearance.windowScrollY = window.scrollY;
							return;
						}
						if (Math.abs(this.appearance.windowScrollY - window.scrollY) > this.appearance.upThreshold) {
							this.element.setAttribute("data-appearance", "visible")
							this.appearance.windowScrollY = window.scrollY;
						}
					}
				}

			}
		}]);

		return HeaderSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = HeaderSection;

	/***/
},
/* 42 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var ImageWithTextBlockSection = function () {
		function ImageWithTextBlockSection(container) {
			_classCallCheck(this, ImageWithTextBlockSection);

			this.element = container;
		}

		_createClass(ImageWithTextBlockSection, []);

		return ImageWithTextBlockSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ImageWithTextBlockSection;

	/***/
},
/* 43 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var LoginSection = function () {
		function LoginSection(container) {
			_classCallCheck(this, LoginSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.timelineLite = new TimelineLite();

			this.customerLoginForm = this.element.querySelector('#customer_login');
			this.recoverPasswordForm = this.element.querySelector('#recover_customer_password');

			this.delegateElement.on('click', '[data-action="toggle-recover-form"]', this._showRecoverPassword.bind(this));
		}

		_createClass(LoginSection, [{
			key: '_showRecoverPassword',
			value: function _showRecoverPassword() {
				var isLoginActive = this.customerLoginForm.style.display === 'block';

				if (isLoginActive) {
					this.timelineLite.fromTo(this.customerLoginForm, 0.5, { autoAlpha: 1, display: 'block', y: 0 }, { autoAlpha: 0, y: 20, display: 'none' }).fromTo(this.recoverPasswordForm, 0.5, { autoAlpha: 0, display: 'none', y: 20 }, { autoAlpha: 1, display: 'block', y: 0, delay: 0.25 });
				} else {
					this.timelineLite.fromTo(this.recoverPasswordForm, 0.5, { autoAlpha: 1, display: 'block', y: 0 }, { autoAlpha: 0, y: 20, display: 'none' }).fromTo(this.customerLoginForm, 0.5, { autoAlpha: 0, display: 'none', y: 20 }, { autoAlpha: 1, display: 'block', y: 0, delay: 0.25 });
				}
			}
		}]);

		return LoginSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = LoginSection;

	/***/
},
/* 44 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var MapSection = function () {
		function MapSection(element) {
			_classCallCheck(this, MapSection);

			this.element = element;
			this.options = JSON.parse(element.getAttribute('data-section-settings'));

			if (this.options['apiKey'] && this.options['mapAddress']) {
				this._loadScript().then(this._initMap.bind(this));
			}
		}

		_createClass(MapSection, [{
			key: '_loadScript',
			value: function _loadScript() {
				var _this56 = this;

				return new Promise(function (resolve, reject) {
					var script = document.createElement('script');
					document.body.appendChild(script);
					script.onload = resolve;
					script.onerror = reject;
					script.async = true;
					script.src = 'https://maps.googleapis.com/maps/api/js?key=' + _this56.options['apiKey'];
				});
			}
		}, {
			key: '_initMap',
			value: function _initMap() {
				var _this57 = this;

				var geocoder = new google.maps.Geocoder();

				geocoder.geocode({ address: this.options['mapAddress'] }, function (results, status) {
					if (status !== google.maps.GeocoderStatus.OK) {
						if (Shopify.designMode) {}
					} else {
						var mapOptions = {
							zoom: _this57.options['zoom'],
							center: results[0].geometry.location,
							draggable: false,
							clickableIcons: false,
							scrollwheel: false,
							disableDoubleClickZoom: true,
							disableDefaultUI: true
						};

						var map = new google.maps.Map(_this57.element.querySelector('.FeaturedMap__GMap'), mapOptions),
								center = map.getCenter();

						map.setCenter(center);

						var icon = {
							path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
							fillColor: _this57.options['markerColor'],
							fillOpacity: 1,
							anchor: new google.maps.Point(15, 55),
							strokeWeight: 0,
							scale: 0.6
						};

						new google.maps.Marker({
							map: map,
							position: map.getCenter(),
							icon: icon
						});

						var styledMapType = new google.maps.StyledMapType(JSON.parse(_this57.element.querySelector('[data-gmap-style]').innerHTML));

						map.mapTypes.set('styled_map', styledMapType);
						map.setMapTypeId('styled_map');

						google.maps.event.addDomListener(window, 'resize', function () {
							google.maps.event.trigger(map, 'resize');
							map.setCenter(center);
						});
					}
				});
			}
		}]);

		return MapSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = MapSection;

	/***/
},
/* 45 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Responsive__ = __webpack_require__(1);

	var NewsletterPopupSection = function () {
		function NewsletterPopupSection(element) {
			_classCallCheck(this, NewsletterPopupSection);

			this.element = element;
			this.form = this.element.querySelector("#popup_newsletter_form");

			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);
			this.options = JSON.parse(element.getAttribute('data-section-settings'));
			this.overlay = document.querySelector(".PageOverlay");

			this.triggerPopup = this._readLocalStorage();
			this.profileSent = false;

			this._attachListeners();
			this._init();
		}

		_createClass(NewsletterPopupSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.delegateElement.off();
			}
		}, {
			key: 'onSelect',
			value: function onSelect() {
				this._openPopup();
				let content = this.element.querySelector(".NewsletterPopup-main");
				content.classList.add("customizing");
			}
		}, {
			key: 'onDeselect',
			value: function onDeselect() {
				this._closePopup();
				let content = this.element.querySelector(".NewsletterPopup-main");
				content.classList.remove("customizing");
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));
				this.documentDelegate.on('click', '[data-action="close-popup"]', this._closePopup.bind(this));

				var _this = this;
				this.documentDelegate.on('newsletterPopup:open', function(){
					_this._init();
				});
				this.documentDelegate.on('newsletterPopup:profileSent', function(){
					_this.profileSent = true;
				});
				window.addEventListener('scroll', this._handleScroll.bind(this));
			}
		},{
			key: '_trackPopupView',
			value: function _trackPopupView() {
					// Check if we've already tracked a view for this session
					const EXPIRY_DAYS = 7;
					const MS_PER_DAY = 24 * 60 * 60 * 1000;

					// Helper function to check if storage is available
					const isStorageAvailable = (type) => {
						try {
							const storage = window[type];
							const x = '__storage_test__';
							storage.setItem(x, x);
							storage.removeItem(x);
							return true;
						} catch (e) {
							return false;
						}
					};

					// Helper to set view flag using available method
					const setViewFlag = () => {
						const expiryDate = new Date();
						expiryDate.setTime(expiryDate.getTime() + (EXPIRY_DAYS * MS_PER_DAY));

						if (isStorageAvailable('localStorage')) {
							localStorage.setItem('popup_view_tracked', 'true');
							localStorage.setItem('popup_view_time', new Date().getTime().toString());
							localStorage.setItem('popup_view_expiry', expiryDate.getTime().toString());
							return;
						}
						
						if (navigator.cookieEnabled) {
							document.cookie = `popup_view_tracked=true; expires=${expiryDate.toUTCString()}; path=/`;
						}
					};

					// Helper to check if view was already tracked and not expired
					const isViewTracked = () => {
						const now = new Date().getTime();

						if (isStorageAvailable('localStorage')) {
							const expiry = localStorage.getItem('popup_view_expiry');
							if (expiry && now < parseInt(expiry)) {
								return true;
							}
							// Clear expired data
							localStorage.removeItem('popup_view_tracked');
							localStorage.removeItem('popup_view_time');
							localStorage.removeItem('popup_view_expiry');
							return false;
						}
						
						if (navigator.cookieEnabled) {
							return document.cookie.split(';').some(c => {
								return c.trim().startsWith('popup_view_tracked=');
							});
						}

						return true; // If no storage available, consider it tracked to prevent sending event
					};

					// Create Intersection Observer to track when popup becomes visible
					const popupElement = document.querySelector('.NewsletterPopup');  // Updated selector
					if (!popupElement) return;

					let hasTrackedView = false;  // Ensure we only track once per session

					const observerCallback = (entries, observer) => {
						entries.forEach(entry => {
							if (entry.isIntersecting && !hasTrackedView) {
								hasTrackedView = true;  // Set flag to prevent multiple tracks
								
								// Check if already tracked or no storage available
								if (isViewTracked() || (!isStorageAvailable('localStorage') && !navigator.cookieEnabled)) {
									console.log('View already tracked or no storage available');
									observer.disconnect();  // Stop observing once tracked
									return;
								}

								const klaviyoPublicAPI = window.theme.klaviyoAPIKey;
								
								const viewEventPayload = {
									data: {
										type: "event",
										attributes: {
											properties: {
												action: "view",
												page_url: window.location.href,
												page_type: window.location.pathname.includes('/products/') ? 'product' :
														window.location.pathname.match(/^\/collections(?!.*\/products)/) ? 'collection' : 
														'other'
											},
											value: 0,
											profile: {
												data: {
													type: "profile",
													attributes: {
														email: "newsletter-view-events@internal-tracking.com"
													}
												}
											},
											metric: {
												data: {
													type: "metric",
													attributes: {
														name: "Sticky Form Viewed (CP/PDP)"
													}
												}
											}
										}
									}
								};

								fetch(`https://a.klaviyo.com/client/events?company_id=${klaviyoPublicAPI}`, {
									method: 'POST',
									headers: {
										'Content-Type': 'application/json',
										'revision': '2024-02-15'
									},
									body: JSON.stringify(viewEventPayload)
								})
								.then(response => {
									if (!response.ok) {
										return response.text().then(text => {
											throw new Error(`HTTP error! status: ${response.status}, body: ${text}`);
										});
									}
									return response.text();
								})
								.then(data => {
									console.log('✅ Popup view tracked successfully (7-day expiry):', data);
									setViewFlag();
									observer.disconnect();  // Stop observing once tracked
								})
								.catch(error => {
									console.error("❌ Error tracking popup view:", {
										message: error.message,
										payload: viewEventPayload,
										stack: error.stack
									});
								});
							}
						});
					};

					// Create and start the observer
					const observer = new IntersectionObserver(observerCallback, {
						threshold: 0.5  // Trigger when 50% of popup is visible
					});

					observer.observe(popupElement);
				}
		},
		{
			key: '_handleScroll',
			value: function _handleScroll(event) {
				const popup = document.querySelector('.NewsletterPopup');
				if (!popup) return;
				
				const popupRect = popup.getBoundingClientRect();
				const viewportHeight = window.innerHeight;
				const buffer = 20; // Adding a small buffer for smoother transition
				
				// Check if popup bottom is in viewport
				const isBottomVisible = popupRect.bottom <= viewportHeight + buffer;
				// Check if popup top is still in viewport
				const isTopVisible = popupRect.top >= -popupRect.height;
				
				if (isBottomVisible && isTopVisible) {
					if (!popup.classList.contains('is-fixed')) {
						popup.classList.add('is-fixed');
					}
				} else {
					if (popup.classList.contains('is-fixed')) {
						popup.classList.remove('is-fixed');
					}
				}
			}
		},
		{
			key: '_init',
			value: function _init() {
				try {
					if (window.location.hash === '#newsletter-popup' && window.theme.pageType !== null) {
						this._openPopup();
						this._trackPopupView(); // Add view tracking
					} else if (this.triggerPopup && window.location.pathname != "/pages/privacy" && 
							   window.theme.newsletterPopupEnabled && !window.theme.hideNewsletterPopupOnThisPage && 
							   JSON.parse(localStorage.getItem("LocalStore"))) {
						this._openPopup();
						this._trackPopupView(); // Add view tracking
					} else {
						this.element.style.display = 'none';
						document.querySelector('#AjaxinateContainer')?.classList.add('popupRemoved');
						return;
					}
				} catch(e) {
					console.error("Newsletter popup initialization error:", e);
				}
			}
		}, {
			key: '_openPopup',
			value: function _openPopup() {
				// this.overlay.classList.add("syncAnimations");

				this.element.setAttribute('aria-hidden', 'false');
				
				if(__WEBPACK_IMPORTED_MODULE_0__helper_Responsive__["default"].matchesBreakpoint('phone')) {
					// this.overlay.classList.add("activeByPopup");
					// this.overlay.setAttribute("data-action", "close-popup");
					// document.documentElement.classList.add('no-scroll');
				}
			}
		}, {
			key: '_closePopup',
			value: function _closePopup() {
				this.element.setAttribute('aria-hidden', 'true');

				this.overlay.classList.remove("activeByPopup");
				this.overlay.removeAttribute("data-action");
				document.documentElement.classList.remove('no-scroll');
				let popupData = localStorage.getItem('themePopup');
				
				let subscribed;
				if (this.profileSent) {
					subscribed = true;
				} else {
					subscribed = false;
				}

				let time = new Date().getTime();
				let data = {
					'subscribed': subscribed,
					'timestamp': time
				}
				localStorage.setItem("themePopup", JSON.stringify(data));

				var _this = this;
				setTimeout (function(){
					_this.overlay.classList.remove("syncAnimations");
				}, 610);

				document.querySelector('#AjaxinateContainer')?.classList.add('popupRemoved');
			}
		}, {
			key: '_readLocalStorage',
			value: function _readLocalStorage() {
				let popupData = localStorage.getItem('themePopup');
				if (popupData == null) {
					return true;
				}
				let popupDataJSON = JSON.parse(popupData);
				let subscribed = popupDataJSON['subscribed'];
				let time = popupDataJSON['timestamp'];
				let timeNow = new Date().getTime();
				let timePassed = timeNow - time;

				// console.log(timePassed );

				// console.log(`Year -> ${365 * 24 * 60 * 60 * 1000}`);
				// console.log(`Month -> ${30 * 24 * 60 * 60 * 1000}`);

				// console.log(`More than year -> ${timePassed > 365 * 24 * 60 * 60 * 1000}`);
				// console.log(`More than month -> ${timePassed > 30 * 24 * 60 * 60 * 1000}`);

				if (subscribed) {
					if (timePassed > 365 * 24 * 60 * 60 * 1000) {
						return true;
					} else {
						return false;
					}
				} else {
					if (timePassed > 30 * 24 * 60 * 60 * 1000) {
						return true;
					} else {
						return false;
					}
				}
			}
		}]);

		return NewsletterPopupSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = NewsletterPopupSection;

	/***/
},
/* 46 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__ = __webpack_require__(4);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__components_RowTabs__ = __webpack_require__(59);

	var ProductRecommendationsSection = function () {
		function ProductRecommendationsSection(container) {
			_classCallCheck(this, ProductRecommendationsSection);
	 
			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
			this.delegateElement = new domDelegate.Delegate(this.element);

			var _thisRec = this;

			if (this.options['useRecommendations']) {
				this._loadRecommendations().then(this._createSlideshow.bind(this)).then(function(){
						_thisRec.tabs = new __WEBPACK_IMPORTED_MODULE_2__components_RowTabs__["default"](_thisRec.element);
					}
				);
			} else {
				this._createSlideshow();
				this.tabs = new __WEBPACK_IMPORTED_MODULE_2__components_RowTabs__["default"](_thisRec.element);
			}
		}

		_createClass(ProductRecommendationsSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.carousel.destroy();
			}
		}, {
			key: '_loadRecommendations',
			value: function _loadRecommendations() {
				var _this58 = this;

				if (this.options.updatedDesign == true) {
					var url = window.routes.productRecommendationsUrl + '?section_id=product-recommendations-updated&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsCount'];
				} else if(this.options.updatedDesign == "mobile") {
						var url = window.routes.productRecommendationsUrl + '?section_id=product-mobile-recommendations&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsCount'];

				} else {
					var url = window.routes.productRecommendationsUrl + '?section_id=product-recommendations&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsCount'];
				}
				
				return fetch(url).then(function (response) {
					return response.text().then(function (content) {
						var container = document.createElement('div');
						container.innerHTML = content;
						_this58.element.querySelector('.ProductRecommendations').innerHTML = container.querySelector('.ProductRecommendations').innerHTML;
					});
				});
			}
		}, {
			key: '_createSlideshow',
			value: function _createSlideshow() {
				var carousels = document.querySelectorAll('[data-flickity-config]');
				var _thisHack = this;
				[...carousels].forEach(function(ele) {
					_thisHack.carousel = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](ele);

					// Setup product item color swatch
					new __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__["default"](_thisHack.element);
				})
			}
		}]);

		return ProductRecommendationsSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductRecommendationsSection;

	/***/
},
/* 47 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_ProductModel__ = __webpack_require__(15);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__components_ProductVariants__ = __webpack_require__(11);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__components_ProductImageZoom__ = __webpack_require__(14);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__components_ProductReviews__ = __webpack_require__(16);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__components_ProductVideo__ = __webpack_require__(18);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__components_ScrollSpy__ = __webpack_require__(19);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_8__components_OverflowScroller__ = __webpack_require__(13);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_9__helper_Responsive__ = __webpack_require__(1);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__components_RowTabs__ = __webpack_require__(59);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_10__helper_Animation__ = __webpack_require__(7);

	var ProductSection = function () {
		function ProductSection(container) {
			var _this59 = this;

			_classCallCheck(this, ProductSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

			this.viewInSpaceElement = this.element.querySelector('[data-shopify-xr]');

			if (this.options['templateSuffix'] !== 'coming-soon') {
				this.productVariants = new __WEBPACK_IMPORTED_MODULE_2__components_ProductVariants__["default"](container, this.options);
			}

			this.tabs = new __WEBPACK_IMPORTED_MODULE_4__components_RowTabs__["default"](this.element);

			var productSlideshowElement = this.element.querySelector('.Product__Slideshow');

			// If there is no image at all, there is nothing to init
			if (productSlideshowElement) {
				this.productSlideshow = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](productSlideshowElement, { onSelect: this._onImageChanged.bind(this), onSettle: this._onImageSettled.bind(this) }, { draggable: !__WEBPACK_IMPORTED_MODULE_9__helper_Responsive__["default"].matchesBreakpoint('supports-hover') });
				this.mediaList = {}; // We keep track of a list of media element
				this.previouslySelectedMedia = null; // Keep track of the previously selected media

				// For each model and video, we register a media
				productSlideshowElement.querySelectorAll('[data-media-type="model"]').forEach(function (model) {
					_this59.mediaList[model.getAttribute('data-media-id')] = new __WEBPACK_IMPORTED_MODULE_1__components_ProductModel__["default"](model, _this59.options['stackProductImages']);
				});

				productSlideshowElement.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function (video) {
					_this59.mediaList[video.getAttribute('data-media-id')] = new __WEBPACK_IMPORTED_MODULE_5__components_ProductVideo__["default"](video, _this59.options['stackProductImages'], _this59.options['enableVideoLooping']);
				});

				if (this.options['stackProductImages']) {
					this.slideshowNavDots = this.element.querySelector('.Product__SlideshowNav--dots');
					this.slideshowNavDotsItems = this.slideshowNavDots ? __WEBPACK_IMPORTED_MODULE_7__helper_Dom__["default"].nodeListToArray(this.slideshowNavDots.querySelectorAll('a')) : [];
				}

				if (this.options['showThumbnails']) {
					this.slideshowNavThumbnails = this.element.querySelector('.Product__SlideshowNav--thumbnails');
					this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? __WEBPACK_IMPORTED_MODULE_7__helper_Dom__["default"].nodeListToArray(this.slideshowNavThumbnails.querySelectorAll('.Product__SlideshowNavImage')) : [];
				}

				this.slideshowImages = __WEBPACK_IMPORTED_MODULE_7__helper_Dom__["default"].nodeListToArray(productSlideshowElement.querySelectorAll('.Carousel__Cell'));

				// Setup the mobile nav
				this._setupSlideshowMobileNav();
			}

			this.productWrapperElement = this.element.querySelector('.Product__Wrapper');
			this.productInfoElement = this.element.querySelector('.Product__Info');
			this.productAsideElement = this.element.querySelector('.Product__Aside');
			this.productGalleryElement = this.element.querySelector('.Product__Gallery');
			this.quickNav = this.element.querySelector('.Product__QuickNav');

			if (this.options['enableImageZoom']) {
				this.imageZoomInstance = new __WEBPACK_IMPORTED_MODULE_3__components_ProductImageZoom__["default"](this.element, this.productSlideshow);
			}
			if (!this.productInfoElement.classList.contains("notSticky")) {
				Stickyfill.addOne(this.productInfoElement);
			}

			// We have to re-order elements in the DOM
			var offscreenElement = this.element.querySelector('.Product__OffScreen');

			if (offscreenElement) {
				this.element.appendChild(offscreenElement);
			}

			this._setupDeviceFeatures();
			this._attachListeners();
		}

		_createClass(ProductSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.delegateElement.off('click');
				this.productReviews.destroy();

				if (this.productVariants) {
					this.productVariants.destroy();
				}

				if (this.productSlideshow) {
					this.productSlideshow.destroy();
				}

				if (this.options['enableImageZoom']) {
					this.imageZoomInstance.destroy();
				}

				if (this.carouselNavScrollSpy) {
					this.carouselNavScrollSpy.destroy();
				}

				if (this.quickNav) {
					window.removeEventListener('scroll', this._checkQuickNavListener);
				}

				if (this.productInfoScroller) {
					this.productInfoScroller.destroy();
				}

				if (this.productThumbnailsScroller) {
					this.productThumbnailsScroller.destroy();
				}

				if (window.ResizeObserver && this.productInfoResizeObserver) {
					this.productInfoResizeObserver.disconnect();
				}
				if (!this.productInfoElement.classList.contains("notSticky")) {
					Stickyfill.removeOne(this.productInfoElement);
				}
				document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._onBreakpointChangedListener = this._setupDeviceFeatures.bind(this);
				this._checkQuickNavListener = this._checkQuickNav.bind(this);

				this.delegateElement.on('click', '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this));
				this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
				this.delegateElement.on('scrollspy:target:changed', this._onScrollTargetChanged.bind(this));

				this.delegateElement.on('model:played', this._onMediaPlayed.bind(this));
				this.delegateElement.on('video:played', this._onMediaPlayed.bind(this));

				this.delegateElement.on('model:paused', this._onMediaPaused.bind(this));
				this.delegateElement.on('video:paused', this._onMediaPaused.bind(this));

				document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);

				if (this.quickNav) {
					window.addEventListener('scroll', this._checkQuickNavListener);
				}

				if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
					this.delegateElement.on('click', '.Product__SlideshowNavImage', this._switchToImage.bind(this));
				}

				this.delegateElement.on('click', '[data-action="toggle-social-share"]', this._toggleSocialShare.bind(this));

				this.delegateElement.on('click', '[data-open-tab]', this._scrollToTab.bind(this));
				
			}
		}, {
			key: '_setupSlideshowMobileNav',
			value: function _setupSlideshowMobileNav() {
				var _this60 = this;

				this.slideshowMobileNav = this.element.querySelector('.Product__SlideshowMobileNav');

				if (this.slideshowMobileNav) {
					var slideshowMobileNavDelegate = new domDelegate.Delegate(this.slideshowMobileNav);

					// Handle the dot
					slideshowMobileNavDelegate.on('click', '.dot', function (event, element) {
						_this60._slideWillChange();
						_this60.productSlideshow.selectCell(parseInt(element.getAttribute('data-index')));
					});

					// Handle the buttons
					slideshowMobileNavDelegate.on('click', '.Product__SlideshowNavArrow', function (event, element) {
						_this60._slideWillChange();

						if (element.getAttribute('data-direction') === 'next') {
							_this60.productSlideshow.next();
						} else {
							_this60.productSlideshow.previous();
						}
					});
				}
			}

			/**
			 * Update the main carousel image
			 */

		}, {
			key: '_updateSlideshowImage',
			value: function _updateSlideshowImage(event) {
				var variant = event.detail.variant,
						previousVariant = event.detail.previousVariant;

				if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
					return;
				}

				// We have two logic here: if we are on pocket mode, we switch using the carousel, otherwise we simulate a link to the anchor
				this._slideWillChange();

				if (__WEBPACK_IMPORTED_MODULE_9__helper_Responsive__["default"].matchesBreakpoint('pocket') || !this.options['stackProductImages']) {
					for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
						var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
								mediaId = parseInt(cellElement.getAttribute('data-media-id'));

						if (mediaId === variant['featured_media']['id']) {
							this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
						}
					}
				} else {
					document.querySelector('[href="#Media' + variant['featured_media']['id'] + '"]').click();
					//document.getElementById(`Media${variant['featured_media']['id']}`).scrollIntoView({behavior: 'smooth'});
				}
			}

			/**
			 * This happens when a media is played
			 */

		}, {
			key: '_onMediaPlayed',
			value: function _onMediaPlayed(event) {
				// Remove draggability
				this.productSlideshow.getFlickityInstance().options.draggable = false;
				this.productSlideshow.getFlickityInstance().unbindDrag();

				// If there is a previously enabled media, we disable it
				if (this.previouslySelectedMedia && this.previouslySelectedMedia !== event.target) {
					this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
				}

				// If the slideshow is configured to stack images, the "select" method from the carousel is not called, so we
				// have to keep track of it here
				if (this.options['stackProductImages']) {
					this.previouslySelectedMedia = event.target;
				}
			}

			/**
			 * This happens when a given media is paused
			 */

		}, {
			key: '_onMediaPaused',
			value: function _onMediaPaused() {
				// Enable draggability
				this.productSlideshow.getFlickityInstance().options.draggable = !__WEBPACK_IMPORTED_MODULE_9__helper_Responsive__["default"].matchesBreakpoint('supports-hover');
				this.productSlideshow.getFlickityInstance().bindDrag();
			}

			/**
			 * This method is called when a media changed in the slideshow
			 */

		}, {
			key: '_handleMedia',
			value: function _handleMedia(item) {
				// First, we need to turn off the previous media (if any)
				if (this.previouslySelectedMedia && this.previouslySelectedMedia !== item) {
					switch (this.previouslySelectedMedia.getAttribute('data-media-type')) {
						case 'video':
						case 'external_video':
						case 'model':
							this.mediaList[this.previouslySelectedMedia.getAttribute('data-media-id')].hasBeenDeselected();
					}

					// If the previous media was a model, we need to adjust the "view in space" button to go back to initial value
					if (this.previouslySelectedMedia.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
						this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', this.viewInSpaceElement.getAttribute('data-shopify-model3d-default-id'));
					}
				}

				// Then, we have to handle the currently selected media
				switch (item.getAttribute('data-media-type')) {
					case 'video':
					case 'external_video':
					case 'model':
						this.mediaList[item.getAttribute('data-media-id')].hasBeenSelected();
						break;
				}

				// If the media is a model, we need to adjust the "view in space" button
				if (item.getAttribute('data-media-type') === 'model' && this.viewInSpaceElement) {
					this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', item.getAttribute('data-media-id'));
				}

				// We set the previously selected media to the currently new one, so that when it changes it can be properly accounted
				this.previouslySelectedMedia = item;
			}

			/**
			 * Callback when the target changes
			 */

		}, {
			key: '_onScrollTargetChanged',
			value: function _onScrollTargetChanged(event) {
				// The scrollspy emit also an "oldTarget", but when scrolling very fast with Firefox or Safari, it prevents the old to be removed, so we
				// manually iterate through all of them to remove it first
				if (this.options['stackProductImages']) {
					this.slideshowNavDotsItems.forEach(function (item) {
						return item.classList.remove('is-selected');
					});
					this.slideshowNavDotsItems[parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1].classList.add('is-selected');

					if (this.options['showThumbnails']) {
						this.slideshowNavThumbnailsItems.forEach(function (item) {
							return item.classList.remove('is-selected');
						});
						this.slideshowNavThumbnailsItems[parseInt(event.detail.newTarget.getAttribute('data-media-position')) - 1].classList.add('is-selected');
					}
				}
			}
		}, {
			key: '_switchToImage',
			value: function _switchToImage(event, target) {
				event.preventDefault();

				this._slideWillChange();

				for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
					var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
							mediaId = parseInt(cellElement.getAttribute('data-media-id'));

					if (mediaId === parseInt(target.getAttribute('data-media-id'))) {
						this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
					}
				}
			}

			/**
			 * Check the quick nav
			 */

		}, {
			key: '_checkQuickNav',
			value: function _checkQuickNav() {
				var _this61 = this;

				var showAsideQuickNav = false;

				fastdom.measure(function () {
					showAsideQuickNav = window.scrollY >= _this61.productAsideElement.offsetTop - _this61.productAsideElement.clientHeight;
				});

				fastdom.mutate(function () {
					if (showAsideQuickNav) {
						_this61.quickNav.classList.add('is-flipped');
					} else {
						_this61.quickNav.classList.remove('is-flipped');
					}
				});
			}

			/**
			 * Toggle the social share icons
			 */

		}, {
			key: '_toggleSocialShare',
			value: function _toggleSocialShare(event, target) {
				target.classList.toggle('is-active');
				target.classList.toggle('RoundButton--secondaryState');

				target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
				target.nextElementSibling.setAttribute('aria-hidden', target.nextElementSibling.getAttribute('aria-hidden') === 'true' ? 'false' : 'true');
			}
		}, {
			key: '_onImageChanged',
			value: function _onImageChanged(event, cell) {
				// If cell is video or model, we hide the action list
				if (__WEBPACK_IMPORTED_MODULE_9__helper_Responsive__["default"].matchesBreakpoint('pocket')) {
					var productGalleryActionListElement = this.element.querySelector('.Product__Gallery .Product__ActionList');

					if (productGalleryActionListElement) {
						if (cell.classList.contains('Product__SlideItem--image') && !cell.classList.contains('Alternative_Featured_Image')) {
							productGalleryActionListElement.classList.remove('is-hidden');
						} else {
							productGalleryActionListElement.classList.add('is-hidden');
						}
					}
				}

				// If we have non-stacked with thumbnails, update it
				if (!this.options['stackProductImages'] && this.options['showThumbnails']) {
					var mediaId = cell.getAttribute('data-media-id');

					this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
						if (thumbnail.getAttribute('data-media-id') === mediaId) {
							thumbnail.classList.add('is-selected');
						} else {
							thumbnail.classList.remove('is-selected');
						}
					});
				}

				// If we have the mobile navigation, we also update it
				if (this.slideshowMobileNav) {
					let selectedIndex;
					let firstDot = this.slideshowMobileNav.querySelector(".AltenativeImageDot");
					if (firstDot) {
						selectedIndex = parseInt(cell.getAttribute('data-media-position')); 
					} else {
						selectedIndex = parseInt(cell.getAttribute('data-media-position')) - 1; // The -1 is to make it 0 indexed
					}

					__WEBPACK_IMPORTED_MODULE_7__helper_Dom__["default"].nodeListToArray(this.slideshowMobileNav.querySelectorAll('.dot')).forEach(function (item, index) {
						if (index === selectedIndex) {
							item.classList.add('is-selected');
						} else {
							item.classList.remove('is-selected');
						}
					});
				}
			}
		}, {
			key: '_onImageSettled',
			value: function _onImageSettled(index, cell) {
				this._handleMedia(cell);

				if (__WEBPACK_IMPORTED_MODULE_9__helper_Responsive__["default"].matchesBreakpoint('lap-and-up')) {
					var slides = this.element.querySelectorAll('.Product__SlideItem:not(.is-selected)');
					slides.forEach(function (slide) {
						slide.classList.add('Product__SlideItem--hidden');
					});
				}
			}
		}, {
			key: '_slideWillChange',
			value: function _slideWillChange() {
				if (__WEBPACK_IMPORTED_MODULE_9__helper_Responsive__["default"].matchesBreakpoint('lap-and-up')) {

					var slides = this.element.querySelectorAll('.Product__SlideItem');
					slides.forEach(function (slide) {
						slide.classList.remove('Product__SlideItem--hidden');
					});
				}
			}

			/**
			 * Verify when the screen size changes to create additional stuff on non pocket mode
			 */

		}, {
			key: '_setupDeviceFeatures',
			value: function _setupDeviceFeatures(event) {
				var _this62 = this;

				var currentBreakpoint = event ? event.detail.currentBreakpoint : __WEBPACK_IMPORTED_MODULE_9__helper_Responsive__["default"].getCurrentBreakpoint(),
						previousBreakpoint = event ? event.detail.previousBreakpoint : null;

				if (currentBreakpoint === previousBreakpoint) {
					return; // Nothing has changed, no specific setup to do
				}

				if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
					if (this.carouselNavScrollSpy) {
						this.carouselNavScrollSpy.destroy();
					}

					if (this.productInfoScroller) {
						this.productInfoScroller.destroy();
					}

					if (this.productThumbnailsScroller) {
						this.productThumbnailsScroller.destroy();
					}

					if (this.productAsideElement) {
						this.productAsideElement.style.minHeight = null;
					} else {
						this.productWrapperElement.style.minHeight = null;
					}

					this.productInfoElement.parentNode.style.maxHeight = null;

				} else {
					// 1st: scrollspy for the dots and image
					if (this.slideshowImages && this.slideshowImages.length > 1) {
						var offsetTop = 0;

						if (this.options['stackProductImages'] && this.slideshowNavDots) {
							offsetTop = this.slideshowNavDots.firstElementChild.offsetTop;
						}

						if (this.options['showThumbnails'] && __WEBPACK_IMPORTED_MODULE_9__helper_Responsive__["default"].matchesBreakpoint('desk')) {
							offsetTop = 250;
						}

						this.carouselNavScrollSpy = new __WEBPACK_IMPORTED_MODULE_6__components_ScrollSpy__["default"](this.element, this.slideshowImages, {
							rootMargin: '-' + offsetTop + 'px 0px 0px 0px'
						});
					}

					var productInfoStyles = window.getComputedStyle(this.productInfoElement),
							productInfoPadding = parseInt(productInfoStyles.paddingTop) + parseInt(productInfoStyles.paddingBottom),
							productGalleryHeight = this.productGalleryElement ? parseInt(this.productGalleryElement.scrollHeight) : 0;

					// 2nd: making sure to set up enough space in aside part
					var calculateMinHeight = function calculateMinHeight() {
						if (_this62.productAsideElement) {
							_this62.productAsideElement.style.minHeight = _this62.productInfoElement.scrollHeight - productInfoPadding - productGalleryHeight + 'px';
							_this62.productInfoElement.closest('.Product__InfoWrapper').style.maxHeight = _this62.productAsideElement.offsetTop + _this62.productInfoElement.scrollHeight - productInfoPadding + 'px';
						} else {
							_this62.productWrapperElement.style.minHeight = _this62.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop) + 'px';
						}
					};

					calculateMinHeight();

					// This code actually works well, but if a merchant is using an app that dynamically adds content (such as ReCharge or any other widget-based app), this
					// will mess the min height. There is a clean solution to this issue, which is by using ResizeObserver. However it's only supported in Chrome for now,
					// but I feel it's already good to have a clean fix
					if (window.ResizeObserver) {
						this.productInfoResizeObserver = new ResizeObserver(function () {
							calculateMinHeight(); // We currently do not take advantage of the values returned by the observer as our calculation depends on other values
						});

						this.productInfoResizeObserver.observe(this.productInfoElement);
					}

					// 3rd: let's handle the scroll for the product info
					if (!this.productInfoElement.classList.contains("notSticky")) {
					this.productInfoScroller = new __WEBPACK_IMPORTED_MODULE_8__components_OverflowScroller__["default"](this.productInfoElement);
					}

					// 4th: let's handle the scroll for the thumbnails
					if (this.options['showThumbnails'] && this.slideshowNavThumbnails) {
						this.productThumbnailsScroller = new __WEBPACK_IMPORTED_MODULE_8__components_OverflowScroller__["default"](this.slideshowNavThumbnails);
					}
				}
				// On 'phone' remove show only first 6 slides
				// if (currentBreakpoint === 'phone') {

				//   console.log(this.productSlideshow.getFlickityInstance());
				//}
			}
		},{
			key: '_scrollToTab',
			value: function _scrollToTab(event,target){
				var id = target.getAttribute("data-open-tab");
				if (window.innerWidth > 768) {
					var element = document.querySelector(`[data-target-tab='${id}']`);
					if (!element) return;
					element.dispatchEvent(new Event("click", {
						"bubbles": true
					}));
				} else {
					var element = document.querySelector(`[data-target-tab-mobile='${id}']`);
					if (!element) return;
					element.setAttribute('aria-expanded', 'true');
					element.nextElementSibling.style.overflow = 'visible';
					__WEBPACK_IMPORTED_MODULE_10__helper_Animation__["default"].slideDown(element.nextElementSibling);

					var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height'));
					
					window.scrollTo({
						top: element.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop - headerHeight,
						behavior: 'smooth'
					});

				}
			}
		}]);

		return ProductSection;
	}();
	/* harmony export (immutable) */

	window.ProductSection = ProductSection;

	__webpack_exports__["default"] = ProductSection;

	/***/
},
/* 48 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__ = __webpack_require__(4);

	var RecentlyViewedProductsSection = function () {
		function RecentlyViewedProductsSection(container) {
			_classCallCheck(this, RecentlyViewedProductsSection);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

			if (this.options['productId']) {
				this._saveProduct(this.options['productId']);
			}

			// Setup product item color swatch
			new __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__["default"](this.element);

			this._fetchProducts();
		}

		_createClass(RecentlyViewedProductsSection, [{
			key: 'onUnload',
			value: function onUnload() {
				if (this.carousel) {
					this.carousel.destroy();
				}
			}

			/**
			 * When we are on a product page, we need to save the current product into local storage
			 */

		}, {
			key: '_saveProduct',
			value: function _saveProduct(productId) {
				var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

				// We check if the current product already exists, and if it does not, we add it at the start
				if (!items.includes(productId)) {
					items.unshift(productId);
				}

				// Then, we save the current product into the local storage, by keeping only the 8 most recent
				try {
					localStorage.setItem('recentlyViewedProducts', JSON.stringify(items.slice(0, 8)));
				} catch (error) {
					// Do nothing, this may happen in Safari in incognito mode
				}
			}

			/**
			 * In order to get the products to display, we hit the search template with the given IDS
			 */

		}, {
			key: '_fetchProducts',
			value: function _fetchProducts() {
				var _this63 = this;

				var queryString = this._getSearchQueryString();

				if (queryString === '') {
					return;
				}

				// If we have a non empty query string we do a search query
				fetch(window.routes.searchUrl + '?view=recently-viewed-products&type=product&q=' + queryString, {
					credentials: 'same-origin',
					method: 'GET'
				}).then(function (response) {
					response.text().then(function (content) {
						var tempElement = document.createElement('div');
						tempElement.innerHTML = content;

						// Set the content
						_this63.element.innerHTML = tempElement.querySelector('.Section').innerHTML;

						// Show the section
						_this63.element.parentNode.style.display = 'block';

						// And finally let's create the carousel !
						_this63.carousel = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](_this63.element.querySelector('[data-flickity-config]'));
					});
				});
			}
		}, {
			key: '_getSearchQueryString',
			value: function _getSearchQueryString() {
				var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

				// If we are on a product template, we make sure to remove the main product from the related product
				if (items.includes(this.options['productId'])) {
					items.splice(items.indexOf(this.options['productId']), 1);
				}

				return items.map(function (item) {
					return 'id:' + item;
				}).join(' OR ');
			}
		}]);

		return RecentlyViewedProductsSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = RecentlyViewedProductsSection;

	/***/
},
/* 49 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var SearchSection = function () {
		function SearchSection(container) {
			_classCallCheck(this, SearchSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);

			this._setupAnimation();
		}

		_createClass(SearchSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.intersectionObserver.disconnect();
				this.timeline.kill();
			}
		}, {
			key: '_setupAnimation',
			value: function _setupAnimation() {
				var _this64 = this;

				if (this.intersectionObserver) {
					this.intersectionObserver.disconnect();
				}

				this.timeline = new TimelineLite({ delay: 0.5 });

				if (window.theme.showElementStaggering) {
					this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));

					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.ProductList .ProductItem, .ArticleList .ArticleItem')).forEach(function (item) {
						_this64.intersectionObserver.observe(item);
					});
				}
			}
		}, {
			key: '_reveal',
			value: function _reveal(results) {
				var _this65 = this;

				var toReveal = [];

				results.forEach(function (result) {
					if (result.isIntersecting || result.intersectionRatio > 0) {
						// isIntersecting does not exist on Samsung Android browser
						toReveal.push(result.target);
						_this65.intersectionObserver.unobserve(result.target);
					}
				});

				if (toReveal.length === 0) {
					return;
				}

				this.timeline.staggerFromTo(toReveal, 0.6, { autoAlpha: 0, y: 25 }, { autoAlpha: 1, y: 0 }, 0.2);
			}
		}]);

		return SearchSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = SearchSection;

	/***/
},
/* 50 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	/**
	 * This code is extracted from Slate
	 */

	var SectionContainer = function () {
		function SectionContainer() {
			_classCallCheck(this, SectionContainer);

			this.constructors = [];
			this.instances = [];

			this._attachListeners();
		}

		_createClass(SectionContainer, [{
			key: '_attachListeners',
			value: function _attachListeners() {
				document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
				document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
				document.addEventListener('shopify:section:select', this._onSelect.bind(this));
				document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
				document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
				document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
				document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
			}
		}, {
			key: 'register',
			value: function register(type, constructor) {
				var _this66 = this;
				this.constructors[type] = constructor;

				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll('[data-section-type=' + type + ']')).forEach(function (container) {
					_this66._createInstance(container, constructor);
				});
			}

			/**
			 * Return an object from an array of objects that matches the provided key and value
			 */

		}, {
			key: '_findInstance',
			value: function _findInstance(array, key, value) {
				for (var i = 0; i < array.length; i++) {
					if (array[i][key] === value) {
						return array[i];
					}
				}
			}

			/**
			 * Remove an object from an array of objects by matching the provided key and value
			 */

		}, {
			key: '_removeInstance',
			value: function _removeInstance(array, key, value) {
				var i = array.length;

				while (i--) {
					if (array[i][key] === value) {
						array.splice(i, 1);
						break;
					}
				}

				return array;
			}
		}, {
			key: '_onSectionLoad',
			value: function _onSectionLoad(event) {
				var container = event.target.querySelector('[data-section-id]');

				if (container) {
					this._createInstance(container);
				}
			}
		}, {
			key: '_onSectionUnload',
			value: function _onSectionUnload(event) {
				var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

				if (!instance) {
					return;
				}

				if (typeof instance.onUnload === 'function') {
					instance.onUnload(event);
				}

				this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
			}
		}, {
			key: '_onSelect',
			value: function _onSelect(event) {
				var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

				if (instance && typeof instance.onSelect === 'function') {
					instance.onSelect(event);
				}
			}
		}, {
			key: '_onDeselect',
			value: function _onDeselect(event) {
				var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

				if (instance && typeof instance.onDeselect === 'function') {
					instance.onDeselect(event);
				}
			}
		}, {
			key: '_onReorder',
			value: function _onReorder(event) {
				var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

				if (instance && typeof instance.onReorder === 'function') {
					instance.onReorder(event);
				}
			}
		}, {
			key: '_onBlockSelect',
			value: function _onBlockSelect(event) {
				var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);
				
				if (instance && typeof instance.onBlockSelect === 'function') {
					instance.onBlockSelect(event);
				}
				
			}
		}, {
			key: '_onBlockDeselect',
			value: function _onBlockDeselect(event) {
				var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

				if (instance && typeof instance.onBlockDeselect === 'function') {
					instance.onBlockDeselect(event);
				}
			}
		}, {
			key: '_createInstance',
			value: function _createInstance(container, constructor) {
				var id = container.getAttribute('data-section-id'),
						type = container.getAttribute('data-section-type');

				constructor = constructor || this.constructors[type];

				if (typeof constructor === 'undefined') {
					return;
				}

				var instance = Object.assign(new constructor(container), {
					id: id,
					type: type,
					container: container
				});

				this.instances.push(instance);
			}
		}]);

		return SectionContainer;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = SectionContainer;

	/***/
},
/* 51 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__ = __webpack_require__(4);

	var ShopNowSection = function () {
		function ShopNowSection(container) {
			_classCallCheck(this, ShopNowSection);

			this.element = container;
			this.carousel = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](this.element.querySelector('[data-flickity-config]'));

			// Setup product item color swatch
			new __WEBPACK_IMPORTED_MODULE_1__components_ProductItemColorSwatch__["default"](this.element);
		}

		_createClass(ShopNowSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.carousel.destroy();
			}
		}]);

		return ShopNowSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ShopNowSection;

	/***/
},
/* 52 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_Popover__ = __webpack_require__(3);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__helper_Responsive__ = __webpack_require__(1);

	var ShopTheLookSection = function () {
		function ShopTheLookSection(container) {
			_classCallCheck(this, ShopTheLookSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.usePocketMode = __WEBPACK_IMPORTED_MODULE_3__helper_Responsive__["default"].matchesBreakpoint('pocket');
			this.pocketActivatorButton = this.element.querySelector('[data-action="open-look"]');

			this._createOuterCarousel();
			this._createPocketPopovers();

			this._attachListeners();
		}

		_createClass(ShopTheLookSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.outerCarousel.destroy();
				this.innerCarousels.forEach(function (item) {
					item.forEach(function (innerItem) {
						return innerItem.destroy();
					});
				});

				this.popovers.forEach(function (item) {
					return item.destroy();
				});

				this.delegateElement.off();
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				this.outerCarousel.selectCell(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
			}

			/**
			 * Attach all the listeners
			 */

		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '.ShopTheLook__Dot', this._onDotClicked.bind(this));
			}

			/**
			 * There is one mobile and tablet popover per look, so we pre-create them
			 */

		}, {
			key: '_createPocketPopovers',
			value: function _createPocketPopovers() {
				var _this67 = this;

				this.popovers = [];

				__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.Popover')).forEach(function (popover) {
					_this67.popovers.push(new __WEBPACK_IMPORTED_MODULE_1__components_Popover__["default"](popover, {
						activator: _this67.pocketActivatorButton,
						showOverlay: false,
						onOpen: _this67._openPocketZoom.bind(_this67),
						onClose: _this67._closePocketZoom.bind(_this67)
					}));
				});
			}

			/**
			 * The outer carousel is the carousel that holds the main one (all the looks). Internally, it also creates
			 * a sub-carousel for each inner carousel
			 */

		}, {
			key: '_createOuterCarousel',
			value: function _createOuterCarousel() {
				var _this68 = this;

				this.outerCarousel = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](this.element.querySelector('.ShopTheLook'), {
					onSelect: this._onLookChanged.bind(this)
				});

				this.innerCarousels = new Array(this.outerCarousel.flickityInstance.cells.length);

				for (var i = 0; i !== this.innerCarousels.length; ++i) {
					this.innerCarousels[i] = [];
				}

				// We need to create ALL the carousels (both in desktop and mobile). Fortunately Flickity is quite fast, but
				// we have no other choices if we want to have proper animations everywhere.
				__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.ShopTheLook__ProductList')).forEach(function (item) {
					var lookIndex = parseInt(item.getAttribute('data-look-index'));
					_this68.innerCarousels[lookIndex].push(new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](item, { onSelect: _this68._onProductChanged.bind(_this68) }));

					// By default, Flickity will append the carousel, hence making the "ViewButton" before the carousel. We need to manipulate it to move it after
					item.insertBefore(item.querySelector('.flickity-viewport'), item.querySelector('.ShopTheLook__ViewButton'));
				});

				this.outerCarousel.resize(); // Needed in case the products are taller than the image
			}

			/**
			 * This function is called whenever the main look has changed, so that we can modify the popover activator
			 */

		}, {
			key: '_onLookChanged',
			value: function _onLookChanged(selectedIndex, selectedCell) {
				// Then, we update the mobile button so that it opens the correct block
				this.pocketActivatorButton.setAttribute('aria-controls', selectedCell.getAttribute('id') + '-popover');
			}

			/**
			 * This function is called whenever a product is changed in the list for a given look. This allows to focus the main dot
			 */

		}, {
			key: '_onProductChanged',
			value: function _onProductChanged(selectedIndex, selectedCell) {
				var lookItem = this.outerCarousel.getSelectedCell(),
						activeDot = null;

				__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(lookItem.querySelectorAll('.ShopTheLook__Dot')).forEach(function (dot, index) {
					dot.classList.remove('is-active'); // IE11 and lower does not support "toggle" with second parameter :(

					if (index === selectedIndex) {
						dot.classList.add('is-active');
						activeDot = dot;
					}
				});

				// Update the link to the product (if using the desktop view)
				lookItem.querySelector('.ShopTheLook__ViewButton').setAttribute('href', selectedCell.getAttribute('data-product-url'));

				// We trigger an event so that when the dot change we can recalculate the position
				lookItem.dispatchEvent(new CustomEvent('product:changed', { detail: { dot: activeDot } }));
			}

			/**
			 * This function is called whenever you explicitly click on a dot.
			 *
			 * On mobile and tablet, this must open the appropriate popver
			 */

		}, {
			key: '_onDotClicked',
			value: function _onDotClicked(event, target) {
				var shouldAnimateCarousel = false,
						hasOnePopoverOpen = false,
						lookIndex = this.outerCarousel.getSelectedIndex();

				this.popovers.forEach(function (item) {
					if (item.isOpen) {
						hasOnePopoverOpen = true;
						shouldAnimateCarousel = true;
					}
				});

				// Each inner carousel has a mobile AND desktop version, so we change both
				this.innerCarousels[lookIndex].forEach(function (innerCarousel) {
					innerCarousel.selectCell(parseInt(target.getAttribute('data-product-index')) - 1, false, shouldAnimateCarousel);
				});

				if (this.usePocketMode && !hasOnePopoverOpen) {
					this.popovers[lookIndex].open();
				}
			}

			/**
			 * This is called when, on mobile, the popover is open. We must open the image in full resolution
			 */

		}, {
			key: '_openPocketZoom',
			value: function _openPocketZoom(popover) {
				var _this69 = this;

				this._calculateImageTransform(popover);

				fastdom.mutate(function () {
					// We need to animate the header to avoid a slightly ugly effect if image overlap the header
					document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(-100%); transition: transform 0.3s ease-in-out;';

					_this69.outerCarousel.flickityInstance.unbindDrag(); // Prevent changing the active slide
					_this69.outerCarousel.flickityInstance.element.classList.add('is-zoomed');
					_this69.outerCarousel.getSelectedCell().classList.add('is-expanded');
				});
			}

			/**
			 * When the mobile zoom is open, and whenever the active dot changes, we need to potentially re-calculate the transform
			 */

		}, {
			key: '_calculateImageTransform',
			value: function _calculateImageTransform(openPopover) {
				var _this70 = this;

				var selectedCell = this.outerCarousel.getSelectedCell();

				fastdom.measure(function () {
					// We first need to compute the initial transform and scale factor
					var scale = window.innerWidth / (selectedCell.offsetWidth - parseInt(window.getComputedStyle(selectedCell).paddingLeft) * 2),
							heightAfterScale = Math.round(selectedCell.offsetHeight * scale),
							// Height of the selected cell once the scale transform is applied
					hiddenImageHeight = Math.round(Math.max(heightAfterScale - (window.innerHeight - openPopover.element.offsetHeight), 0)),
							// Part of image that is below popover
					visibleImageHeight = heightAfterScale - hiddenImageHeight,
							// Part of the image that is visible in the viewport
					minTranslateY = Math.round(-(selectedCell.getBoundingClientRect().top - (heightAfterScale - selectedCell.offsetHeight) / 2)),
							// The minimum translate Y transform allowed so that image is visible
					maxTranslateY = Math.round(minTranslateY - hiddenImageHeight); // The maximum translate Y transform allowed so that image is visible

					_this70._calculateTransformForDotListener = function (event) {
						var dotTopPosition = Math.round((event.detail.dot.offsetTop + event.detail.dot.offsetHeight / 2) * scale),
								offsetToMove = Math.round(dotTopPosition - visibleImageHeight / 2),
								translateY = Math.min(Math.max(minTranslateY - offsetToMove, maxTranslateY), minTranslateY);

						fastdom.mutate(function () {
							_this70.outerCarousel.flickityInstance.viewport.style.transform = 'translate3d(0, ' + Math.round(translateY) + 'px, 0) scale(' + scale + ')';
						});
					};

					// We manually generate an event the first time to trigger the positioning

					selectedCell.addEventListener('product:changed', _this70._calculateTransformForDotListener);
					selectedCell.dispatchEvent(new CustomEvent('product:changed', {
						detail: { dot: selectedCell.querySelector('.ShopTheLook__Dot.is-active') }
					}));
				});
			}

			/**
			 * Close the mobile zoom (which close the popover and remove any transform
			 */

		}, {
			key: '_closePocketZoom',
			value: function _closePocketZoom() {
				var _this71 = this;

				var selectedCell = this.outerCarousel.getSelectedCell();

				selectedCell.removeEventListener('product:changed', this._calculateTransformForDotListener);

				fastdom.mutate(function () {
					document.getElementById('shopify-section-header').style.cssText = 'transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;';

					_this71.outerCarousel.flickityInstance.bindDrag();
					_this71.outerCarousel.flickityInstance.element.classList.remove('is-zoomed');
					_this71.outerCarousel.flickityInstance.viewport.style.transform = null;

					selectedCell.classList.remove('is-expanded');
				});
			}
		}]);

		return ShopTheLookSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ShopTheLookSection;

	/***/
},
/* 53 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Drawer__ = __webpack_require__(6);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__components_SearchBar__ = __webpack_require__(21);

	var SidebarMenuSection = function () {
		function SidebarMenuSection(container) {
			_classCallCheck(this, SidebarMenuSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);

			this.searchBarCustom = new __WEBPACK_IMPORTED_MODULE_1__components_SearchBar__["SearchBarCustom"]();
	
			this.sidebarDrawer = new __WEBPACK_IMPORTED_MODULE_0__components_Drawer__["default"](container, {
				onClose: this.searchBarCustom._clearSearch.bind(this.searchBarCustom)
			});
			
			
			let _this = this;
			fastdom.measure(function () {
				document.documentElement.style.setProperty('--menu-search-height', _this.searchBarCustom.searchElement.clientHeight + 'px');
			});

			document.addEventListener('drawer:close:transitionend', this.resetMenuState.bind(this));
			window.addEventListener('resize', this.setWrapperHeight.bind(this));

			this.buildMenuMarkup();
			this._attachListeners();
		}

		_createClass(SidebarMenuSection, [{
			key: "buildMenuMarkup",
			value: function buildMenuMarkup() {
				let containers = this.element.querySelectorAll(".Drawer__Container");
				containers.forEach( container => {
					let nextLevelContainer = container.nextElementSibling;
					if (!nextLevelContainer) return;

					// Handle ordinary nested LinkList
					let itemsContainer = container.querySelector(".Sidebar--menu_block--items");
					if (itemsContainer) {						
						let items = Array.from(itemsContainer.children);
						items.forEach( item => {
							let nestedBlock = item.querySelector(".Sidebar--menu_block");
							if (nestedBlock) {
								nextLevelContainer.append(nestedBlock)
							}
						});
					}

					// Handle full nested LinkList(button "See all")
					let blocks = container.querySelectorAll(".Sidebar--menu_block [data-block]");
					Array.from(blocks).forEach( (block) => {
						nextLevelContainer.append(block)
					});
				});
				this.setWrapperHeight(true);
			}
		}, {
			key: "resetMenuState",
			value: function resetMenuState() {
				let contaiers = this.element.querySelectorAll("[data-transform]");
				contaiers.forEach( (item, index) => {
					if (index == 0) {
						item.setAttribute("data-transform", "unset")
					} else {
						item.setAttribute("data-transform", "right")
					}
				});
				this.setWrapperHeight();
			}
		}, {
			key: "_attachListeners",
			value: function _attachListeners() {
				this.delegateElement.on('click', '[data-next-menu]', this.openNextMenu.bind(this));
				this.delegateElement.on('click', '[data-previous-menu]', this.openPrevMenu.bind(this));
			}
		}, {
			key: "openNextMenu",
			value: function openNextMenu(event, element) {
				this.setActiveLinklist(element)
				let currentMenu = element.closest(".Drawer__Container");
				let nextMenu = currentMenu.nextElementSibling;
				currentMenu.setAttribute("data-transform", "left");
				nextMenu.scrollTop = 0;
				nextMenu.setAttribute("data-transform", "unset");
				this.setWrapperHeight();
			}
		}, {
			key: "openPrevMenu",
			value: function openPrevMenu(event, element) {
				let currentMenu = element.closest(".Drawer__Container");
				let prevMenu = currentMenu.previousElementSibling;
				prevMenu.setAttribute("data-transform", "unset");
				currentMenu.setAttribute("data-transform", "right");
				prevMenu.scrollTop = 0;				
				this.setWrapperHeight();
			}
		}, {
			key: "setActiveLinklist",
			value: function setActiveLinklist(element) {
				let linkListID = element.dataset.nextMenu;
				let targetList = this.element.querySelector(`[data-block="${linkListID}"]`);
				if (!targetList) return;
				let allLists = targetList.closest(".Drawer__Container").querySelectorAll("[data-block]");
				allLists.forEach(item=>{
					if (item == targetList) {
						item.classList.add("Active");
					} else {
						item.classList.remove("Active");
					}
				});
			}
		}, {
			key: "setWrapperHeight",
			value: function setWrapperHeight(initial = false) {
				let targetContainer = this.element.querySelector(".Drawer__Main--wrapper");
				let activeContainer = this.element.querySelector(".Drawer__Container[data-transform='unset']");
				let height = activeContainer.offsetHeight;

				let drawerFooter = this.element.querySelector(".Drawer__Footer");
				let onTransitionEnd = function onTransitionEnd(event) {
					if (event.propertyName === 'transform') {
						drawerFooter.style.visibility = "visible";
						drawerFooter.style.opacity = 1;
						targetContainer.removeEventListener('transitionend', onTransitionEnd);
					}
				};
				targetContainer.addEventListener('transitionend', onTransitionEnd);

				targetContainer.style.height = height + "px";

			}
		}, {
			key: 'onUnload',
			value: function onUnload() {
				this.sidebarDrawer.destroy();
			}
		}, {
			key: 'onSelect',
			value: function onSelect() {
				this.sidebarDrawer.open();
			}
		}, {
			key: 'onDeselect',
			value: function onDeselect() {
				this.sidebarDrawer.close();
			}
		}]);

		return SidebarMenuSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = SidebarMenuSection;

	/***/
},
/* 54 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__ = __webpack_require__(1);

	var SlideshowSection = function () {
		function SlideshowSection(container) {
			_classCallCheck(this, SlideshowSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.slideshow = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](this.element.querySelector('[data-flickity-config]'), { onSelect: this._onSlideChanged.bind(this) });
			this.selectedSlide = null;
			this.shouldAnimate = true;
			this.timeline = new TimelineLite({ delay: window.theme.showPageTransition ? 0.5 : 0 });

			if (this.slideshow.flickityInstance.cells.length > 0) {
				this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, true);
			}

			this._attachListeners();
		}

		_createClass(SlideshowSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.slideshow.destroy();
				this.timeline.kill();
				this.delegateElement.off();

				document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				if (this.slideshow.flickityInstance.options.autoPlay) {
					this.slideshow.flickityInstance.stopPlayer();
				}

				this.shouldAnimate = !event.detail.load;
				this.slideshow.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);
			}
		}, {
			key: 'onBlockDeselect',
			value: function onBlockDeselect() {
				this.shouldAnimate = true;

				if (this.slideshow.flickityInstance.options.autoPlay) {
					this.slideshow.flickityInstance.playPlayer();
				}
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);

				this.delegateElement.on('mouseenter', '.Button', this._pauseSlideshow.bind(this), true);
				this.delegateElement.on('mouseleave', '.Button', this._resumeSlideshow.bind(this), true);

				document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
			}
		}, {
			key: '_pauseSlideshow',
			value: function _pauseSlideshow() {
				if (this.slideshow.flickityInstance.options.autoPlay) {
					this.slideshow.flickityInstance.pausePlayer();
				}
			}
		}, {
			key: '_resumeSlideshow',
			value: function _resumeSlideshow() {
				if (this.slideshow.flickityInstance.options.autoPlay) {
					this.slideshow.flickityInstance.unpausePlayer();
				}
			}
		}, {
			key: '_onSlideChanged',
			value: function _onSlideChanged(index, element) {
				this._transitionToSlide(element);
			}
		}, {
			key: '_transitionToSlide',
			value: function _transitionToSlide(slide) {
				var _this72 = this;

				this.timeline.clear();

				// First, we check if there is a previous slide selected, if that's the case
				if (this.selectedSlide) {
					this._slideLeave(this.selectedSlide);
					this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0);
				}

				// We get the next slide (if any) to preload it
				this._lazyLoadNextImage();

				this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, { autoAlpha: 0 }, { autoAlpha: 1, ease: Cubic.easeInOut }, 'enter');

				// The image may take 1s or more to load depending on the network, so we make sure to pause the player, and restart it once it has transitioned
				if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'playing') {
					this.slideshow.flickityInstance.pausePlayer();
				}

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(slide.querySelectorAll('.Slideshow__Image')).forEach(function (image) {
					if (image.classList.contains('Image--lazyLoading') || image.classList.contains('Image--lazyLoad')) {
						image.addEventListener('lazyloaded', _this72._slideEnter.bind(_this72, slide));
					} else {
						_this72._slideEnter(slide);
					}
				});

				this.selectedSlide = slide;
			}
		}, {
			key: '_slideLeave',
			value: function _slideLeave(slide) {
				var content = slide.querySelector('.SectionHeader'),
						buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');

				this.timeline.fromTo(slide, this.shouldAnimate ? 0.3 : 0, { autoAlpha: 1 }, { autoAlpha: 0, ease: Cubic.easeInOut, delay: this.shouldAnimate ? 0.35 : 0 });

				if (content) {
					this.timeline.fromTo(content, this.shouldAnimate ? 0.4 : 0, { autoAlpha: 1, y: 0 }, { autoAlpha: 0, y: 20, ease: Cubic.easeIn }, 0);
				}

				if (buttonWrapper) {
					this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.4 : 0, { autoAlpha: 1, y: 0 }, { autoAlpha: 0, y: 10, ease: Cubic.easeIn }, 0);
				}
			}
		}, {
			key: '_slideEnter',
			value: function _slideEnter(slide) {
				var images = slide.querySelectorAll('.Slideshow__Image'),
						content = slide.querySelector('.SectionHeader'),
						buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');

				if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'paused') {
					this.slideshow.flickityInstance.unpausePlayer();
				}

				if (window.CSS && window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')) {
					if (window.theme.showImageZooming) {
						this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, { opacity: 0, scale: 1.2 }, { opacity: 1, scale: 1, ease: Quad.easeOut }, 'enter');
					} else {
						this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, { opacity: 0 }, { opacity: 1, ease: Quad.easeOut }, 'enter');
					}
				}

				if (content) {
					this.timeline.fromTo(content, this.shouldAnimate ? 0.8 : 0, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, delay: this.shouldAnimate ? 0.8 : 0, ease: Cubic.easeOut }, 'enter');
				}

				if (buttonWrapper) {
					this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.8 : 0, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: this.shouldAnimate ? 0.8 : 0, ease: Cubic.easeOut }, 'enter');
				}
			}
		}, {
			key: '_lazyLoadNextImage',
			value: function _lazyLoadNextImage() {
				var currentIndex = this.slideshow.flickityInstance.selectedIndex,
						breakpoint = __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__["default"].getCurrentBreakpoint();

				if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
					var nextCellElement = this.slideshow.flickityInstance.cells[currentIndex + 1].element,
							imageContainers = __WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(nextCellElement.querySelectorAll('.Slideshow__ImageContainer')),
							imageToReveal = null;

					if (breakpoint === 'phone') {
						imageToReveal = imageContainers[0];
					} else {
						imageToReveal = imageContainers[1];
					}

					if (window.lazySizes && imageToReveal && imageToReveal.classList.contains('Image--lazyLoad')) {
						lazySizes.loader.unveil(imageToReveal.firstElementChild);
					}
				}
			}
		}, {
			key: '_onBreakpointChanged',
			value: function _onBreakpointChanged(event) {
				if (event.detail.previousBreakpoint === 'phone' && event.detail.currentBreakpoint !== 'phone' || event.detail.previousBreakpoint !== 'phone' && event.detail.currentBreakpoint === 'phone') {
					this.selectedSlide = null;
					this._transitionToSlide(this.slideshow.flickityInstance.selectedElement);
				}
			}
		}]);

		return SlideshowSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = SlideshowSection;

	/***/
},
/* 55 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);

	var TestimonialsSection = function () {
		function TestimonialsSection(container) {
			_classCallCheck(this, TestimonialsSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.navItems = __WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.TestimonialNav__Item'));

			this.carousel = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](this.element.querySelector('.TestimonialList'), {
				onSelect: this._testimonialChanged.bind(this)
			});

			this._attachListeners();
		}

		_createClass(TestimonialsSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.carousel.destroy();
				this.delegateElement.off('click');
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true);
			}
		}, {
			key: 'onBlockDeselect',
			value: function onBlockDeselect() {
				this.carousel.unpausePlayer();
			}
		}, {
			key: '_testimonialClicked',
			value: function _testimonialClicked(event, target) {
				this.carousel.pausePlayer();
				this.carousel.selectCell(parseInt(target.getAttribute('data-index')));
				this.carousel.unpausePlayer();
			}
		}, {
			key: '_testimonialChanged',
			value: function _testimonialChanged(newIndex) {
				this.navItems.forEach(function (item, index) {
					item.classList.remove('is-selected'); // IE11 and lower does not support classList.toggle

					if (newIndex === index) {
						item.classList.add('is-selected');
					}
				});
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '.TestimonialNav__Item', this._testimonialClicked.bind(this));
			}
		}]);

		return TestimonialsSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = TestimonialsSection;

	/***/
},
/* 56 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var TimelineSection = function () {
		function TimelineSection(container) {
			_classCallCheck(this, TimelineSection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.items = __WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.Timeline__Item'));
			this.navItems = __WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll('.Timeline__NavItem'));

			this._attachListeners();
		}

		_createClass(TimelineSection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.delegateElement.off('click');
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				this.navItems[parseInt(event.target.getAttribute('data-index'))].click(); // Simulate a click on the given nav item
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '.Timeline__NavItem', this._clickOnNavItem.bind(this));
			}
		}, {
			key: '_clickOnNavItem',
			value: function _clickOnNavItem(event, target) {
				var newItem = this.items[parseInt(target.getAttribute('data-index'))];

				if (newItem.classList.contains('is-selected')) {
					return;
				}

				var isContentLarger = false,
						navWrapper = target.parentNode,
						scrollableOffset = 0;

				fastdom.measure(function () {
					var scrollableWidth = navWrapper.scrollWidth,
							visibleWidth = navWrapper.offsetWidth;

					isContentLarger = visibleWidth < scrollableWidth;

					if (isContentLarger) {
						var beginBound = target.offsetLeft,
								endBound = beginBound + target.offsetWidth,
								closerToLeft = beginBound <= visibleWidth - endBound;

						var itemToUse = null;

						if (closerToLeft) {
							// If closer to left, we try to make the previous item visible (if possible)
							itemToUse = target.previousElementSibling || target;
						} else {
							// If closer to right, we try to make the next item visible (if possible)
							itemToUse = target.nextElementSibling || target;
						}

						var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
								itemEndBound = itemBeginBound + itemToUse.offsetWidth;

						if (itemEndBound > visibleWidth) {
							// Element is not visible from the right, so we must move by a given amount so that endBound is within viewable screen
							scrollableOffset = itemEndBound - visibleWidth;
						} else if (itemBeginBound < 0) {
							// Element is not visible from the left, so we simply use the opposite of the negative offset
							scrollableOffset = itemBeginBound;
						}
					}
				});

				fastdom.mutate(function () {
					if (isContentLarger) {
						navWrapper.scrollBy({ behavior: 'smooth', left: scrollableOffset });
					}

					// First we set the class on the selected item and remove it on siblings
					target.classList.add('is-selected');
					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].getSiblings(target, '.is-selected').forEach(function (item) {
						item.classList.remove('is-selected');
					});

					// Then we slide to the appropriate element
					newItem.classList.add('is-selected');
					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].getSiblings(newItem, '.is-selected').forEach(function (item) {
						item.classList.remove('is-selected');
					});
				});
			}
		}]);

		return TimelineSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = TimelineSection;

	/***/
},
/* 57 SearchBar in SideMenu */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var SearchBarCustom = function () {
		function SearchBarCustom() {
			_classCallCheck(this, SearchBarCustom);

			this.documentDelegate = new domDelegate.Delegate(document.body);

			this.searchElement = document.getElementById('Sidebar_Search');
			this.searchInputElement = this.searchElement.querySelector('[name="q"]');
			this.searchResultsElement = this.searchElement.querySelector('.Search__Results');
			this.closeButton = this.searchElement.querySelector(".Search__Close");
			this.queryMap = {};
			this.isOpen = false;

			this.pageOverlayElement = document.querySelector('.PageOverlay');
			this._attachListeners();
		}

		_createClass(SearchBarCustom, [{
			key: 'destroy',
			value: function destroy() {
				this.searchInputElement.removeEventListener('keydown', this._preventSubmissionListener);
				this.searchInputElement.removeEventListener('input', this._onInputListener);

				this.documentDelegate.off();
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this._preventSubmissionListener = this._preventSubmission.bind(this);
				this._onInputListener = this._debounce(this._onInput.bind(this), 250);

				this.searchInputElement.addEventListener('keydown', this._preventSubmissionListener);

				this.searchInputElement.addEventListener('input', this._onInputListener);
				this.documentDelegate.on('click', '[data-action="clear-search"]', this._clearSearch.bind(this));
				this.documentDelegate.on('click', '[data-action="toggle-sidebar-search"]', this._toggleSearchBar.bind(this));
			}

			/**
			 * In order to prevent an odd UX where hitting the enter always choose the product results, if the search is set to product + something else,
			 * then we disable submission using enter key
			 */

		},{
			key: '_clearSearch',
			value: function _clearSearch(event) {
				this.searchInputElement.value = '';
				this.closeButton.style.display = "none";
				this._resetSearch();
			}
		}, {
			key: '_preventSubmission',
			value: function _preventSubmission(event) {
				if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
					event.preventDefault();
				}
			}

			/**
			 * This is called when the user has stopped typing (after debounce delay)
			 */

		}, {
			key: '_onInput',
			value: function _onInput(event) {
				var _this25 = this;
				if (event.keyCode === 13) {
					return;
				}

				// Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
				// keep track of sent requests, and only use the results of the last one
				this.lastInputValue = event.target.value;

				if (this.lastInputValue === '') {
					this._resetSearch();
					this.closeButton.style.display = 'none';
					return;
				}
				this.closeButton.style.display = 'block';
				var queryOptions = { method: 'GET', credentials: 'same-origin' };

				// var queries = [fetch(window.routes.searchUrl + '?view=ajax&q=title:' + encodeURIComponent(this.lastInputValue) + '*&type=product', queryOptions)];
				var queries = [fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=product', queryOptions)];

				if (window.theme.searchMode !== 'product') {
					queries.push(fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(this.lastInputValue) + '*&type=' + window.theme.searchMode.replace('product,', ''), queryOptions));
				}

				this.queryMap[this.lastInputValue] = true;

				document.dispatchEvent(new CustomEvent('theme:loading:start'));

				Promise.all(queries).then(function (responses) {
					// If we receive the result for a query that is not the last one, we simply do not process the result
					if (_this25.lastInputValue !== event.target.value) {
						return;
					}

					delete _this25.queryMap[event.target.value];

					Promise.all(responses.map(function (response) {
						return response.text();
					})).then(function (contents) {
						// If we have only one content then we only have product, otherwise we have products and articles
						if (window.theme.searchMode === 'product') {
							_this25.searchResultsElement.innerHTML = contents[0];
						} else {
							_this25.searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">' + contents[0] + '</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">' + contents[1] + '</div>\n            </div>';
						}

						_this25.searchResultsElement.setAttribute('aria-hidden', 'false');
					});

					document.dispatchEvent(new CustomEvent('theme:loading:end'));
				});
			}
		}, {
			key: '_resetSearch',
			value: function _resetSearch() {
				if (window.theme.searchMode === 'product') {
					this.searchResultsElement.innerHTML = '';
				} else {
					this.searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>';
				}

				this.searchResultsElement.setAttribute('aria-hidden', 'true');

				document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
			}

			/**
			 * Simple function that allows to debounce
			 */

		}, {
			key: '_debounce',
			value: function _debounce(fn, delay) {
				var _this26 = this;

				var timer = null;

				return function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					clearTimeout(timer);

					timer = setTimeout(function () {
						fn.apply(_this26, args);
					}, delay);
				};
			}
		}, { 
			key: '_toggleSearchBar',
			value: function _toggleSearchBar(event) {
				event.preventDefault();
				let searchWrapper = this.searchElement.parentNode;
				let sideBarSection = this.searchElement.closest(".SidebarMenu");
				let mainMenuContainer = sideBarSection.querySelector(".Drawer__Content");
				if(this.isOpen) {
					this._resetSearch();
					searchWrapper.style.height = "0px";
					searchWrapper.style.overflow = "hidden";
					mainMenuContainer.classList.remove("HeightWithSearch")
					this.isOpen = false;
				} else {
					let onTransitionEnd = function onTransitionEnd(event) {
						if (event.propertyName === 'height') {
							searchWrapper.style.overflow = "visible";
							mainMenuContainer.classList.add("HeightWithSearch")
							searchWrapper.removeEventListener('transitionend', onTransitionEnd);
						}
					};
					searchWrapper.addEventListener('transitionend', onTransitionEnd);
					searchWrapper.style.height = this.searchElement.offsetHeight + "px";
					
					this.isOpen = true;
				}
			}
		}]);

		return SearchBarCustom;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = SearchBarCustom;

	/***/
},
/* 58 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	var ProductLooksSection = function () {
		function ProductLooksSection(container) {
			_classCallCheck(this, ProductLooksSection);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

			this._loadPageContent();
		}

		_createClass(ProductLooksSection, [{
			key: '_loadPageContent',
			value: function _loadPageContent(){
				var _this59 = this;
				var url = '/pages/'+this.options.productHandle+'-looks';

				return fetch(url).then(function (response) {
					return response.text().then(function (content) {
						var container = document.createElement('div');
						container.innerHTML = content;

						_this59.element.innerHTML = container.querySelector('.Looks_Wrapper').innerHTML;
					});
				});
			}
		}]);

		return ProductLooksSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductLooksSection;

	/***/
},
/* 59 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);

	var RowTabs = function() {
		function RowTabs(container) {
			_classCallCheck(this, RowTabs);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement); 
			this.element = container.querySelector("[data-row-tabs]") == null ? container : container.querySelector("[data-row-tabs]");
			this._buildMarkup(this.element);
			this._handleUnderline(this.element);
			this._handleParentHeight(this.element);
			var __this = this;
			window.addEventListener("resize", function(){
				__this._handleUnderline(__this.element);
			});
			this._attachListeners();
		}

		_createClass(RowTabs, [{
			key: '_attachListeners',
			value: function _attachListeners(){
				var _thisHack = this;

				this.documentDelegate.on('click', '[data-action="toggle-tab"]', this._handleClick.bind(this));
				window.addEventListener("resize", function(){
					_thisHack._handleParentHeight(_thisHack.element);
				});
				this.documentDelegate.on("reviews:loaded", function(){
					_thisHack._handleParentHeight(_thisHack.element);
				});
				this.documentDelegate.on("reviews:new", function(){
					_thisHack._handleParentHeight(_thisHack.element);
				})
			}
		}, {
			key: '_buildMarkup',
			value: function _buildMarkup(container){

				var children = container.children;

				let buttonsHTML = '';
				for (let i=0; i < children.length; i++) {
					let title = children[i].getAttribute('data-tab-title');

					let tabAnchor = children[i].getAttribute('data-tab-desktop-anchor');
					if (tabAnchor != null) {
						var additionalAttribute = `data-target-tab='${tabAnchor}'`;
					} else {
						var additionalAttribute = '';
					};

					if (i==0) {
						var state = 'aria-hidden="false"';
					} else {
						var state = 'aria-hidden="true"';
					}
					buttonsHTML += "<button data-action='toggle-tab' data-tab='"+title+"'"+state+additionalAttribute+">"+title+"</button>";
				}
				var initialHTML = "<div class='inner-container'>"+
														"<div class='line'></div>"+
														buttonsHTML+
													"</div>";
				var wrapper = document.createElement("div");
				wrapper.classList.add('toggle_buttons-container');
				if (children.length == 2) {
					wrapper.setAttribute("data-two-elements", true)
				}
				wrapper.innerHTML = initialHTML;
				container.insertBefore(wrapper, container.firstElementChild || null);
			}
		}, {
			key: '_handleClick',
			value: function _handleClick(event){
				if (event.target.getAttribute('aria-hidden') === 'false') {
					return;
				}
				var contaierID = event.target.getAttribute('data-tab');
				event.target.setAttribute("aria-hidden", false);
				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].getSiblings(event.target).forEach(function(item){
					item.setAttribute("aria-hidden", true);
				});

				var targetTab = event.target.closest("[data-row-tabs]").querySelector("[data-tab-title='"+contaierID+"']");

				targetTab.setAttribute("aria-expanded", true);

				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].getSiblings(targetTab, "[aria-expanded]").forEach(function(item){
					item.setAttribute("aria-expanded", false);
				});
				this._handleParentHeight(targetTab.parentElement);
				this._handleUnderline(event.target.closest("[data-row-tabs]"));

				// Only load reviews if the reviews tab is clicked
				if (contaierID === 'Reviews' && !targetTab.dataset.reviewsLoaded) {
					const productId = event.target.closest('[data-row-tabs]').getAttribute('data-product-id'); // or get productId another way
					loadAndRenderReviews(
						productId,
						targetTab.parentElement,
						this._handleParentHeight.bind(this)
					);
					targetTab.dataset.reviewsLoaded = "true"; // Prevent reloading on every click
				}
			}
		},{
			key: '_handleUnderline',
			value: function _handleUnderline(container){
				var line = container.querySelector(".line");
				var targetButton = container.querySelector("[aria-hidden='false']");

				var params = targetButton.getBoundingClientRect();
				var leftFix = targetButton.parentElement.getBoundingClientRect().x;
				var leftOffset = params.left - leftFix;
				var width = params.width;
				line.style.left = leftOffset + 'px';
				line.style.width = width + 'px';
			}
		}, {
			key: '_handleParentHeight',
			value: function _handleParentHeight(container){
				var buttonsContainer = container.querySelector(".toggle_buttons-container");
				var targetContainer = container.querySelector("[aria-expanded='true']");
				var height = buttonsContainer.offsetHeight + targetContainer.offsetHeight;
				container.style.height = height + 'px';
			}
		}]);

		return RowTabs;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = RowTabs;

	/***/
},
/* 60 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var ProductCompleteTheLookSection = function() {
		function ProductCompleteTheLookSection(container) {
			_classCallCheck(this, ProductCompleteTheLookSection);

			this.element = container;
			 this.carousel = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](this.element.querySelector('.ProductCompleteTheLook_carousel'));

		}

		_createClass(ProductCompleteTheLookSection, []);

		return ProductCompleteTheLookSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductCompleteTheLookSection;

	/***/
},
/* 61 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__ = __webpack_require__(1);

	var IndexMainCollection = function() {
		function IndexMainCollection(container) {
			_classCallCheck(this, IndexMainCollection);

			this.element = container;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.slideshow = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](this.element.querySelector('[data-flickity-config]'), { onSelect: this._lazyLoadSlides.bind(this)});

			//this._lazyLoadSlides();
		}

		_createClass(IndexMainCollection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.slideshow.destroy();
			}
		}, {
			key: '_lazyLoadSlides',
			value: function _lazyLoadSlides() {

				var currentSlideIndex = this.slideshow.flickityInstance.selectedIndex;

				var nextSlideIndex = currentSlideIndex < this.slideshow.flickityInstance.slides.length - 1 ? currentSlideIndex + 1 : 0;
				var prevSlideIndex = currentSlideIndex - 1 < 0 ? this.slideshow.flickityInstance.slides.length - 1 : currentSlideIndex - 1;

				var nextSlide = this.slideshow.flickityInstance.slides[nextSlideIndex].cells;
				var prevSlide = this.slideshow.flickityInstance.slides[prevSlideIndex].cells;
				
				if (window.lazySizes) {          
					nextSlide.forEach(function(item){
						let image = item.element.querySelector(".Image--lazyLoad");
						if(image == null) {
							return;
						}
						lazySizes.loader.unveil(image);
					});

					prevSlide.forEach(function(item){
						let image = item.element.querySelector(".Image--lazyLoad");
						if(image == null) {
							return;
						}
						lazySizes.loader.unveil(image);
					})
				}
			}
		}]);

		return IndexMainCollection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = IndexMainCollection;

	/***/
},
/* 62 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);

	var IndexSecondaryCollection = function() {
		function IndexSecondaryCollection(container) {
			_classCallCheck(this, IndexSecondaryCollection);

			this.element = container;

			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement); 
			this.button = this.element.querySelector("a.Button");
			if (this.element.querySelector('[data-flickity-config]') != null) {
				this.slideshow = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](this.element.querySelector('[data-flickity-config]'));
			}
			this._attachListeners();
		}

		_createClass(IndexSecondaryCollection, [{
			key: 'onUnload',
			value: function onUnload() {
				this.slideshow.destroy();
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners(){
				this.delegateElement.on('click', '[data-action="link-to-collection"]', this._imageLinksToCollection.bind(this));
			}
		},{
			key: '_imageLinksToCollection',
			value: function _imageLinksToCollection(){
				if (this.button != null) {
					window.location.href = this.button.href;
				}
			}
		}]);

		return IndexSecondaryCollection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = IndexSecondaryCollection;

	/***/
},
/* 63 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper_Dom__ = __webpack_require__(0);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__ = __webpack_require__(1);


	var CustomPageTemplate = function() {
		function CustomPageTemplate(container) {
			_classCallCheck(this, CustomPageTemplate);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

			if (this.options?.enableInvertedHeader) {
				this._inverseHeaderColor();
				window.addEventListener("resize", function(){
					this._inverseHeaderColor();
				}.bind(this));
			}

			this._markChildren();
			this._populateClickEventOnImages();
			__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll(".Carousel")).forEach(function(carousel){
				new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](carousel);
			});

			if (this.options?.documentLayout) {
				document.body.setAttribute("data-layout", this.options.documentLayout)
			}

			if (this.options?.showNewsletterPopupOnThisPage == false) {
				window.theme.hideNewsletterPopupOnThisPage = true;
			}
			
			this.delegateElement = new domDelegate.Delegate(this.element);
			
			this.delegateElement.on("click", "[data-suspect]", this.guessTheMurderer.bind(this));
			this.delegateElement.on("click", "[data-suspect-mobile]", this.guessTheMurdererMobile.bind(this));
			
			// Set fancybox for evidence sections
			let evidencesSections = document.querySelectorAll("[data-evidence-section]");
			evidencesSections.forEach((section)=>{
				let sectionID = section.getAttribute("data-evidence-section");
				Fancybox.bind(`[data-fancybox="${sectionID}"]`);
			});
			
			let evidencesSectiosnMobile = document.querySelectorAll(".Evidences.Carousel");
			evidencesSectiosnMobile.forEach((section)=>{
				let fancyboxID = section.querySelector("div.AspectRatio").getAttribute("data-fancybox");
				Fancybox.bind(`[data-fancybox="${fancyboxID}"]`);
			});

		}

		_createClass(CustomPageTemplate, [{
			key: '_markChildren',
			value: function _markChildren() {
				var index = 1;
				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(this.element.children).forEach(function (item) {
					item.classList.add("child_"+index);
					index++;
				});
			} 
		}, {
			key: '_populateClickEventOnImages',
			value: function _populateClickEventOnImages() {
				if (!this.element.hasAttribute("data-populate-links")) {
					return;
				}
				var default_populated_link = this.element.getAttribute("data-populate-links");
				__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(this.element.children).forEach(function(item){
					var block_link = item.querySelector("a.Button");
					if (block_link == null) {
						return
					}
					var link_url = block_link.getAttribute("href") == "*" ? default_populated_link : block_link.getAttribute("href");
					__WEBPACK_IMPORTED_MODULE_1__helper_Dom__["default"].nodeListToArray(item.querySelectorAll("img")).forEach(function(image){
						image.setAttribute("onclick", "location='"+link_url+"'");
						image.style.cursor = "pointer";
					});
				})
			}
		}, {
			key: '_inverseHeaderColor',
			value: function _inverseHeaderColor() {
				let isMobile = __WEBPACK_IMPORTED_MODULE_2__helper_Responsive__["default"].matchesBreakpoint('phone');
				let header = document.querySelector("header#section-header");
				if (header.classList.contains("Header--inversedColores") && isMobile == false) {
					header.classList.remove("Header--inversedColores")
				} else if (!header.classList.contains("Header--inversedColores") && isMobile == true) {
					header.classList.add("Header--inversedColores")
				}
			}
		}, {
			key: 'guessTheMurderer',
			value: function guessTheMurderer(event, target) {
				let name = target.getAttribute("data-suspect");
				Array.from(target.parentNode.children).forEach((item)=>{
					let marker = item.querySelector(".GuessMarker");
					if (item == target) {
						marker.setAttribute("data-selected", true)
					} else {
						if (name == "Isabella") {
							marker.style.display = "none";
						} else {
							marker.setAttribute("data-selected", false)
						}
					}
				});
				let container = target.closest(".Page--investigation");
				let correctAnswer = container.querySelector(".CorrectAnswer");
				let wrongAnswer = container.querySelector(".WrongAnswer");
				$(wrongAnswer).hide();
				if (name == "Isabella") {
					$(wrongAnswer).hide();
					$(correctAnswer).fadeIn();
					this.delegateElement.off("click","[data-suspect]");
					container.classList.add("guessed")
				} else {
					$(wrongAnswer).fadeIn();
				}
			}
		}, {
			key: "guessTheMurdererMobile",
			value: function guessTheMurdererMobile(event, target) {
				let name = target.getAttribute("data-suspect-mobile");
				Array.from(target.parentNode.children).forEach((item)=>{
					let marker = item.querySelector(".GuessMarker");
					if (item == target) {
						marker.setAttribute("data-selected", true)
					} else {
						if (name == "Isabella") {
							marker.style.display = "none";
						} else {
							marker.setAttribute("data-selected", false)
						}
					}
				});
				let container = target.closest(".Page--Killer");
				let correctAnswer = container.querySelector(".RightAnswerMobile");
				let wrongAnswer = container.querySelector(".WrongAnswerMobile");
				let infoText = container.querySelector("p.info");
				let scrollTarget = container.querySelector(".ScrollTarget")
				$(wrongAnswer).hide();
				
				let headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height'));
				let announcementBarHeight = document.documentElement.style.getPropertyValue('--announcement-bar-height') ? parseInt(document.documentElement.style.getPropertyValue('--announcement-bar-height')) : 0;

				if (name == "Isabella") {
					$(wrongAnswer).hide();
					$(infoText).hide();
					$(correctAnswer).show();
					
					$("html, body").animate({
						scrollTop: scrollTarget.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop - headerHeight - announcementBarHeight - 5
					}, 1000)
					this.delegateElement.off("click","[data-suspect-mobile]");
				} else {
					$(wrongAnswer).fadeIn();
					let targetElement = container.querySelector(".Page--Killer--images")
					$("html, body").animate({
						scrollTop: targetElement.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop - headerHeight - announcementBarHeight - 5
					}, 500)
				}
			}
		}]);

		return CustomPageTemplate;    
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = CustomPageTemplate;

	/***/
},
/* 64 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var AccountNavigation = function() {
		function AccountNavigation(container) {
			_classCallCheck(this, AccountNavigation);

			this.element = container;

			this.documentDelegate = new domDelegate.Delegate(document.documentElement);
			this.documentDelegate.on('click', '[data-action="reorder-products"]', this._handleReorderButton);
			this._handleLinks();
		}

		_createClass(AccountNavigation, [{
			key: "_handleLinks",
			value: function _handleLinks(){
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll("a")).forEach(function(link){
					var linkObject = new URL(link.href);
					if (window.location.pathname === linkObject.pathname) {
						link.classList.add("active");
					}
				})
			}
		}, {
			key: '_handleReorderButton',
			value: function _handleReorderButton(){
				let reorder_data = this.getAttribute("data-reorder");
				fetch(window.routes.cartClearUrl + '.js', {
					credentials: 'same-origin',
					method: 'POST',
					headers: {
						 'Content-Type': 'application/json',
						 'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
					}
				}).then(function (response){
					return fetch(window.routes.cartAddUrl + '.js', {
						body: reorder_data,
						credentials: 'same-origin',
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
						}
					})
				}).then(function (response) {
					window.location.href = "/checkout";
				}).catch(function (response) {
				});
			}
		}]);

		return AccountNavigation;    
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = AccountNavigation;

	/***/
},
/* 65 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var AccountSection = function() {
		function AccountSection(container) {
			_classCallCheck(this, AccountSection);

			this.element = container;
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);
			this.timelineLite = new TimelineLite();

			this.accountSection = this.element.querySelector('#Account');
			this.profileSection = this.element.querySelector('#Profile');

			this.documentDelegate.on('click', '[data-action="show-profile-section"]', this._showProfileSection.bind(this));
			this.documentDelegate.on('click', '[data-action="show-account-section"]', this._showAccountSection.bind(this));
			if (window.location.hash == "#profile") {
				window.location.hash = '';
				this.accountSection.style.display = "none";
				this.profileSection.style.display = "block";
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll(".account_navigation_link")).forEach(function(link){
					if (link.getAttribute("data-action") != "show-profile-section") {
						link.classList.remove("active");
					} else {
						link.classList.add("active");
					}
				});
			}
		}

		_createClass(AccountSection, [{
			key: "_showProfileSection",
			value: function _showProfileSection() {
				var isProfileActive = this.profileSection.style.display === 'block';
				if (isProfileActive) return;
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll(".account_navigation_link")).forEach(function(link){
					if (link.getAttribute("data-action") != "show-profile-section") {
						link.classList.remove("active");
					} else {
						link.classList.add("active");
					}
				});
				this.timelineLite.fromTo(this.accountSection, 0.5, { autoAlpha: 1, display: 'block', y: 0 }, { autoAlpha: 0, y: 20, display: 'none' }).fromTo(this.profileSection, 0.5, { autoAlpha: 0, display: 'none', y: 20 }, { autoAlpha: 1, display: 'block', y: 0, delay: 0.25 });
			}
		}, {
			key: "_showAccountSection",
			value: function _showAccountSection() {
				var isAccountActive = this.accountSection.style.display === 'block';
				if (isAccountActive) return;
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll(".account_navigation_link")).forEach(function(link){
					if (link.getAttribute("data-action") != "show-account-section") {
						link.classList.remove("active");
					} else {
						link.classList.add("active");
					}
				});
				this.timelineLite.fromTo(this.profileSection, 0.5, { autoAlpha: 1, display: 'block', y: 0 }, { autoAlpha: 0, y: 20, display: 'none' }).fromTo(this.accountSection, 0.5, { autoAlpha: 0, display: 'none', y: 20 }, { autoAlpha: 1, display: 'block', y: 0, delay: 0.25 });
			}
		}]);

		return AccountSection;    
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = AccountSection;

	/***/
},
/* 66 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var RedirectPopup = function() {
		function RedirectPopup(element) {
			_classCallCheck(this, RedirectPopup);

			this.element = element;
			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);
			this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

			this.overlay = document.querySelector(".PageOverlay");
			this._attachListeners();

			if (new Date().getTime() - JSON.parse(localStorage.getItem("LocalStore"))?.['timeStamp'] > 2.419e9) {
				localStorage.removeItem("LocalStore");
			}
			// comment out for testing
			if (!JSON.parse(localStorage.getItem("LocalStore")) && !Shopify.designMode) {
				this._init();
			}
		} 

		_createClass(RedirectPopup, [{
			key: "_init",
			value: function _init(){
				var _this = this;
				fetch('https://api.ipdata.co/?api-key=dc3a80c77d88c377bd9509eb9e9749115832cd30cb5487002a19549f').then(function(response){
					return response.json();
				}).then(function(data){
					var enablePopup = _this._handleLocationButton(data);
					if (enablePopup) {
						_this._handleStoreButton(data);
						_this._openPopup();
					} else {
						let data = {
							storeHasBeenSelected: true,
							timeStamp: new Date().getTime()
						}
						localStorage.setItem("LocalStore", JSON.stringify(data));
						document.documentElement.dispatchEvent(new CustomEvent('newsletterPopup:open', {
							bubbles: true
						}));
					}
				}).catch(function(error){
					// Handle failed fetch
				});
			}
		}, {
			key: '_attachListeners',
			value: function _attachListeners() {
				this.delegateElement.on('click', '[data-action="close-redirect-popup"]', this._closePopup.bind(this));
				this.documentDelegate.on('click', '[data-action="close-redirect-popup"]', this._closePopup.bind(this));
			}
		}, {
			key: "_openPopup",
			value: function _openPopup(){
				this.element.setAttribute("aria-hidden", false);
				this.overlay.classList.add("activeByPopup");
				this.overlay.setAttribute("data-action", "close-redirect-popup");
				document.documentElement.classList.add('no-scroll');
				this.overlay.classList.add("syncAnimations");
			}
		},{
			key: "_closePopup",
			value: function _closePopup(){
				this.element.setAttribute("aria-hidden", true);
				this.overlay.classList.remove("activeByPopup");
				this.overlay.removeAttribute("data-action");
				document.documentElement.classList.remove('no-scroll');
				var _this = this;
				setTimeout (function(){
					_this.overlay.classList.remove("syncAnimations");
				}, 510);
				let data = {
					storeHasBeenSelected: true,
					timeStamp: new Date().getTime()
				}
				localStorage.setItem("LocalStore", JSON.stringify(data));
			}
		}, {
			key: "_handleStoreButton",
			value: function _handleStoreButton(clientData){
				var _this = this;
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll("[data-country]")).forEach((item) => {
					if (item.getAttribute("data-country") == _this.options.shopURL) {
						item.style.display = 'flex';
						item.style.cursor = 'pointer';
						item.removeAttribute("href");
						item.setAttribute("data-action", "close-redirect-popup");     
					};
					// if (item.getAttribute("data-country") == "World") {
					//   let flag = item.querySelector("img");
					//   let country_label = item.querySelector(".RedirectPopup-country_name");
					//   flag.setAttribute("src", clientData.flag);
					//   flag.setAttribute("alt", `${clientData.country_name} Flag`);
					//   country_label.textContent = clientData.country_name;
					// }
				})
			}
		}, {
			key: "_handleLocationButton",
			value: function _handleLocationButton(clientData){
				let country_codes = ["AU", "CA", "SG", "MY", "AE", "SA", "IL", "QA", "KW", "ZA", "JP", "MX", "KR", "HK", "IN"];
				if (country_codes.indexOf(clientData.country_code) > -1) {
					return false;
				}
				if (this.options.shopURL == "United States" && clientData.continent_code == "NA") {
					return false;
				} else if (this.options.shopURL == "United Kingdom" && clientData.country_name == "United Kingdom" ) {
					return false;
				} else if (this.options.shopURL == "Ireland" && clientData.is_eu == true) {
					return false;
				} else if (this.options.shopDomain.includes('world')) {
					return false;
				} else {
					if (clientData.continent_code == "NA") {            
						let requiredButton = this.element.querySelector("[data-country='United States']");
						requiredButton.style.display = "flex";
					} else if (clientData.country_name == "United Kingdom") {
						let requiredButton = this.element.querySelector("[data-country='United Kingdom']");
						requiredButton.style.display = "flex";
					} else if (clientData.is_eu == true) {
						let requiredButton = this.element.querySelector("[data-country='Ireland']");
						requiredButton.style.display = "flex";
						//this._handleCountryData(requiredButton, clientData);
					} else {
						let requiredButton = this.element.querySelector("[data-country='World']");
						requiredButton.style.display = "flex";
						this._handleCountryData(requiredButton, clientData);
					}
					return true;
				}
			}
		}, {
			key: "_handleCountryData",
			value: function _handleCountryData(element, clientData) {
				let countryFlag = element.querySelector(".CustomFlag");
				let country_label = element.querySelector(".RedirectPopup-country_name");
				countryFlag.setAttribute("src", clientData.flag);
				countryFlag.setAttribute("alt", `${clientData.country_name} Flag`);
				countryFlag.style.display = 'block';
				country_label.textContent = clientData.country_name;
				let defaultFlag = element.querySelector(".DefaultFlag");
				if (defaultFlag) {
					defaultFlag.style.display = "none";
				}
			}
		}, {
			key: 'onSelect',
			value: function onSelect() {
				this._openPopup();
			}
		}, {
			key: 'onDeselect',
			value: function onDeselect() {
				this._closePopup();
			}
		}]);

		return RedirectPopup;    
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = RedirectPopup;

	/***/
},
/* 67 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var WishList = function() {
		function WishList() {
			_classCallCheck(this, WishList);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);
			this.container = document.querySelector(".WishlistContainer");
			this.mainButton = document.querySelector("a.swym-wishlist");
			this.wishlistCounter = document.querySelector(".BookmarkText");
			this._init();
		}

		_createClass(WishList, [{
			key: "_init",
			value: function _init() {
				var $this = this;
				function initCallback(){
					window._swat.evtLayer.addEventListener("sw:addedtowishlist", function(eventData){
						var productData = eventData.detail.d;
						setTimeout(function() {
							$this._fetchWishlistProducts();
						}, 10);
					});
					window._swat.evtLayer.addEventListener("sw:removedfromwishlist", function(eventData){
						var productData = eventData.detail.d;
						$this._removeFromWishlistFix(productData);
					});
					window._swat.evtLayer.addEventListener("sw:requestoptions", function(eventData){
					});
					// window._swat.evtLayer.addEventListener("sw:requestparams", function(eventData, b){
					//   console.log("popup spotted 49");
					//   console.log(eventData, b)
					// });
				}
				if(!window.SwymCallbacks){
					window.SwymCallbacks = [];
				}
				window.SwymCallbacks.push(initCallback);
			}
		}, {
			key: "_removeFromWishlistFix",
			value: function _removeFromWishlistFix(data) {
				var productID = data.empi;
				var button = document.querySelector(".Button--wishlist[data-product-id='"+ productID +"']");
				var productPageWishlistButton = document.querySelector(".ProductWishlistButton");
				
				setTimeout(function() {
					if (button != null) {
						button.classList.remove("swym-added");
					}
					if (productPageWishlistButton != null) {
						productPageWishlistButton.classList.remove("swym-added");
					}          
				}, 10);
			}
		}, {
			key: "_fetchWishlistProducts",
			value: function _fetchWishlistProducts() {
				var _this = this;
				window._swat.fetch(function(products) {
					if (products.length == 1) {
						 var val = " item";
					} else {
						 var val = " items";
					};
					_this.wishlistCounter.innerHTML = products.length + val;
					_this.container.classList.add("ProductAdded");
					_this.timeout && clearTimeout(_this.timeout);
					_this.timeout = setTimeout(function(){
						_this.container.classList.remove("ProductAdded");
					}, 4000);
				});
			}
		}, {
			key: "_populateButtons",
			value: function _populateButtons() {
				var pageSelector = document.getElementById("swym-wishlist-render-container");
				if (!pageSelector) return;
				var wishlistProducts;

				window._swat.fetch(function(products) {
					wishlistProducts = products;
				});

				const targetNode = document.getElementById('swym-wishlist-render-container');
				const config = { attributes: false, childList: true, subtree: true };

				var counter = 0;

				const callback = function(mutationsList, observer) {
					for(const mutation of mutationsList) {
						if (mutation.type === 'childList') {
							console.log(mutation)
							__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(mutation.addedNodes).forEach((container) => {
								if (container.classList.contains("swym-wishlist-detail-content") && counter == 0) {
									counter++;
									var gridContainer = document.querySelector(".swym-wishlist-grid");
									__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(pageSelector.querySelectorAll(".swym-wishlist-item")).forEach((item) => {

										var wrapper = document.createElement('div');
										wrapper.className = "swym-wishlist-item-wrapper";
										item.parentNode.insertBefore(wrapper, item);
										wrapper.appendChild(item);

										var thumbnailTitle = item.querySelector(".swym-title");
										var thumbnailTitleText = thumbnailTitle.textContent;

										for (let i=0; i < wishlistProducts.length; i++) {
											var title = wishlistProducts[i]["dt"];
											if (title === thumbnailTitleText) {
												var productLink = wishlistProducts[i]["du"];
												var button = document.createElement("a");
												button.className = 'Button Button--primary';
												button.textContent = "View Item";
												button.setAttribute("href", productLink);
												wrapper.append(button);
												break;
											};
										}
									});
									gridContainer.classList.add("Updated");
								}
							});
						}
					}
				};
				const observer = new MutationObserver(callback);
				observer.observe(targetNode, config);        
			}
		}]);

		return WishList;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = WishList;

	/***/
},
/* 68 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);  
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var ProductInstagramGallery = function() {
		function ProductInstagramGallery(container) {
			_classCallCheck(this, ProductInstagramGallery);

			this.element = container;

			this.slideshow = new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](this.element.querySelector('[data-flickity-config]'));
		}

		_createClass(ProductInstagramGallery, [{
			key: '_attachListeners',
			value: function _attachListeners() {
			}
		}]);

		return ProductInstagramGallery;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = ProductInstagramGallery;

	/***/
},
/* 69 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var IPDetection = function() {
		function IPDetection() {
			_classCallCheck(this, IPDetection);
			this.init();
			// <li>Fully Tracked Delivery in <span data-ip-detection="country_name">EU</span></li>
		}

		_createClass(IPDetection, [{
			key: "init",
			value: function init() {
				let $this = this;
				// if (window.theme.selectedCountry != "US" && window.theme.shopLocation == "US") {
				// 	document.body.classList.add("hideRetailPrice");
				// }

				// Check if we have cached data first
				const cachedData = $this.getCachedIPData();
				if (cachedData) {
					$this.clientData = cachedData;
					$this.processIPData(cachedData);
					return;
				}

				// If no cached data, fetch from API
				fetch('https://api.ipdata.co/?api-key=dc3a80c77d88c377bd9509eb9e9749115832cd30cb5487002a19549f').then(function(response){
					console.log('IPData call made');
					return response.json();
				}).then(function(data){
					// Cache the response
					$this.cacheIPData(data);
					$this.clientData = data;
					$this.processIPData(data);
				}).catch(function(error){
					// Handle failed fetch
					console.error(error);
				});

			}
		}, {
			key: "getCachedIPData",
			value: function getCachedIPData() {
				try {
					const cached = localStorage.getItem('ipdata_cache');
					if (!cached) return null;
					
					const { data, timestamp } = JSON.parse(cached);
					const now = Date.now();
					const cacheExpiry = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
					
					// Check if cache is still valid
					if (now - timestamp < cacheExpiry) {
						console.log('Using cached IP data');
						return data;
					} else {
						// Cache expired, remove it
						localStorage.removeItem('ipdata_cache');
						return null;
					}
				} catch (error) {
					console.error('Error reading cached IP data:', error);
					return null;
				}
			}
		}, {
			key: "cacheIPData",
			value: function cacheIPData(data) {
				try {
					const cacheData = {
						data: data,
						timestamp: Date.now()
					};
					localStorage.setItem('ipdata_cache', JSON.stringify(cacheData));
					console.log('IP data cached successfully');
				} catch (error) {
					console.error('Error caching IP data:', error);
				}
			}
		}, {
			key: "processIPData",
			value: function processIPData(data) {
				let $this = this;
				
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll("[data-ip-detection]")).forEach((item) => {
					switch(item.getAttribute("data-ip-detection")) {
						case "country_name":
							item.textContent = data.country_name;
					}
				});

				$this.handleHeaderFlags();
				$this.handleRetailPrice();
				$this.handlePayPalMessage();
				$this.hideMobileNewsletter();
				$this.handleSizeChartTable();
				document.addEventListener("ipdata:received", $this.updateDrawerBar.bind($this));
				// try { document.documentElement.addEventListener('ipdata:received', $this.handleDrawerExpressShipping.bind($this)); } catch(e) {}
				// Register a one-time listener to avoid duplicate calls
				try { console.log('[EUFreeShip] registering ipdata:received listener for EU free shipping copy'); document.documentElement.addEventListener('ipdata:received', function onceEUFreeShip(){ $this.handleEUFreeShippingCopy(); document.documentElement.removeEventListener('ipdata:received', onceEUFreeShip); }); } catch(e) { console.warn('[EUFreeShip] listener registration failed', e); }
				$this.testIPDetection();
				$this.handleMobileFooterCopy();
				$this.handleFooterContactsBlock();
				$this.handleSizeGuideMainConversionTable();
				$this.handleSizeConversionTable();
				$this.handleFreeShippingSection();
				// $this.handleDrawerExpressShipping();
				try { console.log('[EUFreeShip] initial invoke'); $this.handleEUFreeShippingCopy(); } catch(e) { console.warn('[EUFreeShip] initial invoke failed', e); }
			}
		}, {
			key: "handleFreeShippingSection",
			value: function handleFreeShippingSection() {
				if (window.theme.shopLocation != "US") return;
				let target_info_tab = document.querySelector(".FreeShippingInfo[data-country-code='"+ this.clientData.country_code +"']");
				if (target_info_tab) {
					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(document.querySelectorAll(".FreeShippingInfo")).forEach((item) => {
						if (item.getAttribute("data-country-code") == this.clientData.country_code) {
							item.classList.add("Active");
							let desktop_button = document.querySelector("[data-target-tab='shipping_tab']");
							let mobile_button = document.querySelector("[data-target-tab-mobile='shipping_tab'] span:first-child");
							if (desktop_button) {
								desktop_button.textContent = item.getAttribute("data-local-tab-title");
							}
							if (mobile_button) {
								mobile_button.textContent = item.getAttribute("data-local-tab-title");
							}
						} else {
							console.log(item);
							item.classList.add("Disabled");
						}
					});
				}
			}
		},
		{
			key: "_updateOrderTimer",
			value: function _updateOrderTimer(){
					try {
						if (window.updateOrderTimer) {
							window.updateOrderTimer();
						}
					} catch (e) {
						console.error(e);
					}
			}
		}, 
		{
			key: "handleRetailPrice",
			value: function handleRetailPrice() {
				if (window.theme.shopLocation == "US" && this.clientData.country_code == "US") return;
				// if (window.theme.shopLocation == "UK" && this.clientData.country_code == "GB") return;
				// if (window.theme.shopLocation == "EU" && this.clientData.is_eu == true) return;

				// always show if enabled on UK and EU
				if (window.theme.shopLocation == "UK") return;
				if (window.theme.shopLocation == "EU") return;

				document.body.classList.add("hideRetailPrice");
			}
		}, {
			key: "handlePayPalMessage",
			value: function handlePayPalMessage() {
				if ((window.theme.shopLocation == "US" && this.clientData.country_code == "AU") || (window.theme.shopLocation == "US" && this.clientData.country_code == "CA")) {
					let payInThreeMessage = document.querySelector(".ProductMeta_secondary.pay_in_three")
					if (payInThreeMessage) {
						payInThreeMessage.style.display = "none";
					}
				}
				if (window.theme.shopLocation == "US" && this.clientData.country_code == "US") return;
				if (window.theme.shopLocation == "UK" && this.clientData.country_code == "GB") return;
				// if (window.theme.shopLocation == "EU" && this.clientData.is_eu == true ) return;
				let paypalDefaultMessage = document.querySelector(".Product__PayPal-message.Default");
				let paypalCustomMessage = document.querySelector(".Product__PayPal-message.Custom");
				if (paypalDefaultMessage) {
					paypalDefaultMessage.style.display = "none";
				}
				if (paypalDefaultMessage) {
					paypalDefaultMessage.style.display = "none";
				}
			}
		}, {
			key: "handleHeaderFlags",
			value: function handleHeaderFlags() {
				let default_flag_id, country_codes;
				if (window.theme.shopLocation == "US") {
					country_codes = ["AU", "CA", "SG", "MY", "AE", "SA", "IL", "QA", "KW", "ZA", "JP", "MX", "KR", "HK", "IN"];
					default_flag_id = "US";
				} else if (window.theme.shopLocation == "UK") {
					country_codes = [];
					default_flag_id = "UK";
				} else if (window.theme.shopLocation == "EU") {
					country_codes = ["FR", "DE", "IE", "CH", "NL", "LU", "SK", "SE", "PL", "HU", "SI", "LT", "LV", "NO", "AT", "BE", "BG", "HR", "CZ", "DK", "EE", "FI", "GR", "IT", "PT", "RO", "ES"];
					default_flag_id = "EU";
				} else {
					return;
				}
				// let regex = /(\/en-)/g;
				// let notLocal = regex.test(window.location.pathname);
				let flag_containers = document.querySelectorAll(".FlagContainer");
				if (country_codes.indexOf(this.clientData.country_code) > -1) {
					flag_containers.forEach(container => {
						let flag = container.querySelector(".FlagContainer_image img");
						flag.src = this.clientData.flag;
						flag.parentElement.style.display = "block";
					});
				} else {
					let default_flag_containers = document.querySelectorAll(".FlagCintainer--default_flags");
					for (let element of default_flag_containers) {
						let flag = element.querySelector(`div[data-image="${default_flag_id}"]`);
						flag.style.display = "block";
						element.style.display = "flex";
					}
				};
				flag_containers.forEach(container => {
					container.classList.add("Active")
				});
			}
		}, {
			key: "handleDeliveryLabel",
			value: function handleDeliveryLabel() {
				if (window.theme.shopLocation != "US") return;
				let labelStyles = getComputedStyle(deliveryLabel);
				if (labelStyles.display == "none") return;
				if (this.clientData.country_code == "AU") {
					deliveryLabel.textContent = "Fast Australia Shipping - Express Available";
				} else if (this.clientData.country_code == "CA") {
					deliveryLabel.textContent = "Canada Shipping - Express Available";
				} else if (this.clientData.country_code == "NZ") {
					deliveryLabel.textContent = "New Zealand Shipping - Express Available";
				} else if (this.clientData.country_code == "HK") {
					deliveryLabel.textContent = "Hong Kong Shipping - Express Available";
				} else if (this.clientData.country_code == "IN") {
					deliveryLabel.textContent = "Hong Kong Shipping - Express Available";
				} else if (this.clientData.country_code == "IL") {
					deliveryLabel.textContent = "Israel Shipping - Express Available";
				} else if (this.clientData.country_code == "JP") {
					deliveryLabel.textContent = "Japan Shipping - Express Available";
				} else if (this.clientData.country_code == "KW") {
					deliveryLabel.textContent = "Kuwait Shipping - Express Available";
				} else if (this.clientData.country_code == "MY") {
					deliveryLabel.textContent = "Malaysia Shipping - Express Available";
				} else if (this.clientData.country_code == "QA") {
					deliveryLabel.textContent = "Qatar Shipping - Express Available";
				} else if (this.clientData.country_code == "SA") {
					deliveryLabel.textContent = "Saudi Arabia Shipping - Express Available";
				} else if (this.clientData.country_code == "SG") {
					deliveryLabel.textContent = "Singapore Shipping - Express Available";
				} else if (this.clientData.country_code == "KR") {
					deliveryLabel.textContent = "South Korea Shipping - Express Available";
				} else if (this.clientData.country_code == "AE") {
					deliveryLabel.textContent = "UAE Shipping - Express Available";
				}
			}
		}, {
			key: "handleDrawerExpressShipping",
			value: function handleDrawerExpressShipping() {
				try {
					var span = document.querySelector('.Drawer__Prefooter .Drawer__Prefooter-content .express-shipping');
					var para = document.querySelector('.Drawer__Prefooter .Drawer__Prefooter-content p');
					if (!span && !para) return;

					var shopLocation = window.theme && window.theme.shopLocation || '';
					var ipData = this.clientData || null;
					if (!ipData || !ipData.country_name) return;

					var newLine = null;
					if (shopLocation == "US") {
						if (ipData.country_code && ipData.country_code != "US") {
							newLine = "Express " + ipData.country_name + " Shipping & Returns";
						} else {
							newLine = "Express USA Shipping & Returns";
						}
					} else if (shopLocation == "EU") {
						newLine = "Express " + ipData.country_name + " Delivery & Returns";
					}

					if (!newLine) return;

					if (span) {
						span.textContent = newLine;
					} else if (para) {
						var html = para.innerHTML;
						if (html.indexOf('<br>') > -1) {
							var first = html.split('<br>')[0];
							para.innerHTML = first + '<br>' + newLine;
						} else {
							para.innerHTML = html + '<br>' + newLine;
						}
					}
				} catch (e) {}
			}
		}, {
			key: "handleEUFreeShippingCopy",
			value: function handleEUFreeShippingCopy() {
				try {
					if (this._euFreeShipApplied) { console.log('[EUFreeShip] already applied'); return; }
					console.log('[EUFreeShip] tick');
					if (window.theme.shopLocation != "EU") { console.log('[EUFreeShip] not EU store'); return; }
					if (!this.clientData || !this.clientData.country_name) { console.log('[EUFreeShip] missing clientData.country_name'); return; }
					var containers = document.querySelectorAll('.FreeShippingInfo[data-country-code="default"]');
					console.log('[EUFreeShip] containers found:', containers ? containers.length : 0);
					if (!containers || containers.length === 0) return;

					var countryName = this.clientData.country_name;
					var updatedAny = false;
					__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(containers).forEach(function(item) {
						var lis = item.querySelectorAll('li');
						var updated = false;
						for (var i = 0; i < lis.length; i++) {
							var li = lis[i];
							var original = li.innerHTML;
							var replaced = original.replace(/^(\s*)(Free\s+(Delivery|Shipping))(.*)$/i, function(match, leading, base, type, rest) {
								return (leading || '') + 'Free ' + countryName + ' Delivery' + (rest || '');
							});
							if (replaced !== original) {
								li.innerHTML = replaced;
								console.log('[EUFreeShip] updated li:', li);
								updated = true;
								updatedAny = true;
								break; // Only update the first relevant li per container
							}
						}
						if (!updated) {
							console.log('[EUFreeShip] no change for element');
						}
					});
					if (updatedAny) { this._euFreeShipApplied = true; }
				} catch(e) { console.warn('[EUFreeShip] error', e); }
			}
		}, {
			key: "updateDrawerBar",
			value: function updateDrawerBar() {
			  let sideCartAnnouncementContainer = document.querySelector(".Drawer__Announcement");
			  if (!sideCartAnnouncementContainer) return;
			  
			  let targetText = sideCartAnnouncementContainer.querySelector(".Drawer__Announcement--message");
			  let cartItemsCount = sideCartAnnouncementContainer.dataset.cartItemsCount;
			  let cartTotal = sideCartAnnouncementContainer.dataset.cartTotal;

			  // First check if user is non-US on US store
			  if (window.theme.shopLocation == "US" && window.theme.cartEnableDiscount == false) {
				// Uncomment when ready to hide instead of showing different message:
				// sideCartAnnouncementContainer.classList.add('hidden');
				targetText.innerHTML = cartTotal < 200
				  ? window.languages.sideCartMessages.threshold1
				  : window.languages.sideCartMessages.threshold2;
			  } else {
				// Handle regular threshold messaging
				
				if (window.theme.cartEnableDiscount) {
				//   targetText.innerHTML = window.languages.sideCartMessages.cartDiscountEnabledMessage;
				  targetText.innerHTML = cartItemsCount > 1
					? window.languages.sideCartMessages.cartDiscountEnabledMessage2
					: window.languages.sideCartMessages.cartDiscountEnabledMessage;
				} else {
				  targetText.innerHTML = cartTotal < 100
					? window.languages.sideCartMessages.threshold1 
					: window.languages.sideCartMessages.threshold2;
				}
			  }
			}
		  }, {
			key: "hideMobileNewsletter",
			value: function hideMobileNewsletter() {
				let container = document.querySelector(".mobile_footer_newsletter");
				//let footer_contact = document.querySelector(".mobile_footer_block-contacts");
				// if (window.theme.shopLocation == "US" && this.clientData.country_code != "US" && container) {
				// 	container.style.display = "none"
				// }
				// if (window.theme.shopLocation == "US" && this.clientData.country_code != "US" && footer_contact) {
				//   footer_contact.style.display = "none"
				// }
			}
		}, {
			key: "handleSizeChartTable",
			value: function handleSizeChartTable() {
				let chart_table = document.querySelector("#modal-size-chart");
				if (!chart_table) return;
				if (window.theme.shopLocation == "US" && this.clientData.country_code != "US") {
					let table_headings = document.querySelectorAll("tr.table_heading[data-size="+this.clientData.country_code+"]");
					table_headings.forEach(row => {
						row.style.display = "table-row";
						let default_row = row.parentNode.querySelector("tr.table_heading[data-size='default']");
						default_row.style.display = "none";
					});
				}
			}
		}, {
			key: "testIPDetection",
			value: function testIPDetection() {				
				let container = document.querySelector("#ip_test");
				if (!container) return;
				let data = JSON.stringify(this.clientData, undefined, 4);
				let data2 = data.split(",").join("<br>");
				container.innerHTML = data;
			}
		}, {
			key: "handleMobileFooterCopy",
			value: function handleMobileFooterCopy() {
				if (window.theme.shopLocation == "EU" && this.clientData.is_eu == true) {

					let footer_newsletter_title = document.querySelector(".mobile_footer_newsletter .newsletter_title");
					footer_newsletter_title.textContent = `Free ${this.clientData.country_name} Delivery`;

					// let truck_icon_copy_1 = document.querySelector(".delivery-info .MainCopy span:first-child");
					// truck_icon_copy_1.textContent = `Free ${this.clientData.country_name} Delivery (2-3 Days)`;

					// let truck_icon_copy_2 = document.querySelector(".delivery-info .MainCopy span:last-child");
					// truck_icon_copy_2.textContent = `- Express Available`;
				}
			}
		}, {
			key: "handleFooterContactsBlock",
			value: function handleFooterContactsBlock() {
				if (window.theme.shopLocation == "EU" && this.clientData.is_eu == true) {
					let element = document.querySelector(".mobile_Footer__Inner .mobile_footer_block-contacts");
					element.style.display = "none";
				}
			}
		}, {
			key: "handleSizeGuideMainConversionTable",
			value: function handleSizeGuideMainConversionTable() {
				let $this = this;
				let targetTable = document.querySelector(".table_container.SizeConversion");
				if (!targetTable) return;
				if (window.theme.shopLocation == "US" && this.clientData.country_code == "US") {
					targetTable.setAttribute("aria-hidden", true);
					return;
				}
				// let allRows = targetTable.querySelectorAll("tr[data-country-code]");
				// for(let row of allRows) {
				// 	if (row.getAttribute("data-country-code") == "International") {
				// 		row.style.display = "table-row";
				// 	} else {
				// 		row.style.display = "none";
				// 	}
				// }
			} 
		}, {
			key: "handleSizeConversionTable",
			value: function handleSizeConversionTable() {
				let $this = this;
				let targetModal = document.querySelector(".Modal.SizeChart");
				if (!targetModal) return;

				let targetRows = [];
				let allRows = targetModal.querySelectorAll("tr[data-country-code]");
				for (let row of allRows) {
					let row_countries = row.dataset.countryCode.split(",");
					if (row_countries.indexOf($this.clientData.country_code) >= 0) {
						targetRows.push(row);
						if (window.theme.shopLocation == "EU") {
							let target_td = row.firstElementChild;
							target_td.textContent = $this.clientData.country_name;
						}
					}
				}
				
				if (targetRows.length > 0) {
					for(let row of allRows) {
						if (targetRows.indexOf(row) < 0) {
							row.style.display = "none";
						}
					}
				} else {
					let default_rows = Array.from(targetModal.querySelectorAll("tr[data-default]"));
					if (default_rows.length > 0) {
						for(let row of allRows) {
							if (default_rows.indexOf(row) >= 0) {
								if (window.theme.shopLocation == "EU") {
									let row_td = row.firstElementChild;
									row_td.textContent = "EU Size";
								} else if (window.theme.shopLocation == "US") {
									row.style.display = "table-row";
								}
							} else {
								row.style.display = "none";
							}
						}	
					}
				}
			}
		}]);

		return IPDetection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = IPDetection;

	/***/
},
/* 70 collection price range filter */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var PriceRange = function() {
		function PriceRange(container) {
			_classCallCheck(this, PriceRange);

			this.element = container;
			this.data = JSON.parse(this.element.getAttribute("data-snippet-settings"));


			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);

			this.oneStepInPercents = 100 / this.data.range;

			this.priceRangeData = {
				minValue: this.data.min_value,
				maxValue: this.data.max_value
			}

			this._init();
			this._attachListeners();
		}

		_createClass(PriceRange, [{
			key: '_init',
			value: function _init() {

				let searchParams = new URLSearchParams(window.location.search);  
				if (!searchParams.toString()) {          
					this.priceRangeData = {
						minValue: 0,
						maxValue: this.data.range
					}
				} else {
					for (const [key, value] of searchParams.entries()) {
						if (key == "filter.v.price.gte") {
							this.priceRangeData.minValue = value;
						}
						if (key == "filter.v.price.lte" ) {
							this.priceRangeData.maxValue = value;
						}
					}
				}

				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll("[data-price-range-button]")).forEach(function (button) {
					let label = button.querySelector("label");
					let input = button.querySelector("input");

					if (button.getAttribute("data-price-range-button") == "min") {
						button.style.left = `${this.priceRangeData.minValue * this.oneStepInPercents}%`;
						label.textContent = this.priceRangeData.minValue;
						input.value = this.priceRangeData.minValue;
					} else {
						button.style.left = `${this.priceRangeData.maxValue * this.oneStepInPercents}%`;
						label.textContent = this.priceRangeData.maxValue;
						input.value = this.priceRangeData.maxValue;
					}
				}.bind(this));

				this._handleActiveTrack();
				this.element.style.opacity = 1;
			} 
		}, {
			key: "_getLowestProductPrice",
			value: function _getLowestProductPrice() {
				// In the future
			}
		}, {
			key: "_attachListeners",
			value: function _attachListeners() {
				this.delegateElement.on('mousedown', '[data-price-range-button]', this._priceRangeButtonMoveStart.bind(this));
				this.delegateElement.on("click", ".PriceRange--track", this._trackClick.bind(this))
			}
		}, {
			key: "_priceRangeButtonMoveStart",
			value: function _priceRangeButtonMoveStart(event, target) {
				this.documentDelegate.on("mousemove", this._priceRangeButtonMove.bind(this, target));
				this.documentDelegate.on('mouseup', this._priceRangeButtonMoveEnd.bind(this));

				let html = document.body.parentNode;
				html.classList.add("grabbing");
				this._setInputNames();
			}
		}, {
			key: "_priceRangeButtonMoveEnd",
			value: function _priceRangeButtonMoveEnd() {
				this.documentDelegate.off("mousemove");
				this.documentDelegate.off("mouseup");
				let html = document.body.parentNode;
				html.classList.remove("grabbing");
			}
		}, {
			key: "_priceRangeButtonMove",
			value: function _priceRangeButtonMove(button, mouseEvent) {
				this._handleButtonGrab(button, mouseEvent);
			} 
		}, {
			key: "_handleButtonGrab",
			value: function _handleButtonGrab(button, mouseEvent) {
				this._setInputNames();
				let containerXLeft = this.element.getBoundingClientRect().left;
				let containerXRight = this.element.getBoundingClientRect().right;
				let toMovePercent, delta, steps;
				let label = button.querySelector("label");
				let input = button.querySelector("input");

				if (mouseEvent.clientX >= containerXRight) {
					steps = +this.data.range;
				} else if (mouseEvent.clientX <= containerXLeft) {
					steps = 0;
				} else {
					delta = mouseEvent.clientX - containerXLeft;
					steps = Math.round(delta / this.element.clientWidth * 100 / this.oneStepInPercents);
				}
				
				let buttonType = button.getAttribute("data-price-range-button");
				if (buttonType === "min") {
					if (steps >= this.priceRangeData.maxValue) return;
					this.priceRangeData.minValue = steps;
				} else if (buttonType === "max")  {
					if (steps <= this.priceRangeData.minValue) return;
					this.priceRangeData.maxValue = steps;
				}

				label.textContent = steps;
				input.value = steps;

				toMovePercent = steps * this.oneStepInPercents;
				button.style.left = `${toMovePercent}%`;

				this._handleActiveTrack();        
				
				//return;

				document.documentElement.dispatchEvent(new CustomEvent('price-range:change', { 
						bubbles: true, 
						detail: {
							form: this.element.closest("form")
						} 
				}));
			}
		}, {
			key: "_trackClick",
			value: function _trackClick(event, target) {
				let button = this._findClosestButton(event);
				this._handleButtonGrab(button, event);
			}
		}, {
			key: "_findClosestButton",
			value: function _findClosestButton(event) {
				let minButton = this.element.querySelector("[data-price-range-button='min']");
				let maxButton = this.element.querySelector("[data-price-range-button='max']");
				
				let minButtonCenterPosition = minButton.getBoundingClientRect().left + minButton.clientWidth / 2;
				let maxButtonCenterPosition = maxButton.getBoundingClientRect().left + maxButton.clientWidth / 2;

				let minClickDistance = Math.abs(minButtonCenterPosition - event.clientX);
				let maxClickDistance = Math.abs(maxButtonCenterPosition - event.clientX);

				return minClickDistance < maxClickDistance ? minButton : maxButton;
			}
		}, {
			key: "_handleActiveTrack",
			value: function _handleActiveTrack() {
				let activeTrack = this.element.querySelector(".PriceRange--track");
				let leftPosition = this.oneStepInPercents * this.priceRangeData.minValue;
				let trackWidth = (this.priceRangeData.maxValue - this.priceRangeData.minValue) * this.oneStepInPercents;
				activeTrack.style.setProperty("--active-track-left", `${leftPosition}%`);
				activeTrack.style.setProperty("--active-track-width", `${trackWidth}%`);
			}
		}, {
			key: "_clearPriceRange",
			value: function _clearPriceRange() {
				let _this = this;
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll("input[type='number']")).forEach(function (input) {
					input.name = "";
					input.value = "";
					if (input.parentNode.getAttribute("data-price-range-button") == "min") {
						input.previousElementSibling.textContent = 0;
					} else {
						input.previousElementSibling.textContent = _this.data.range;
					}
				});

			}
		}, {
			key: "_setInputNames",
			value: function _setInputNames() {
				let _this = this;
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll("input[type='number']")).forEach(function (input) {
					input.setAttribute("name", input.getAttribute("data-name-storage"));
				});

			}
		}]);

		return PriceRange;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = PriceRange;

	/***/
},
/* 71 announcement bar */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var AnnouncementBar = function() {
		function AnnouncementBar(container) {
			_classCallCheck(this, AnnouncementBar);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

			this.slideshow = this.element.querySelector(".Carousel");
			this.slides = this.slideshow.querySelectorAll('.AnnouncementBar__Slide');
			this.sliderOption = {
				adaptiveHeight: true,
				infinite: true,
				vertical: true,
				autoplay: true,
				arrows: false,
				speed: 1500,
				verticalSwiping: true,
				swipeToSlide: true
			};
			if (this.options.initSlider) {
				this.init();
			}
		}

		_createClass(AnnouncementBar, [{
			key: 'init',
			value: function init() {
				if (this.slideshow) {
					this.handleSlidesHeight();
					$(this.slideshow).slick(this.sliderOption);
					this.windowWidth = $(window).width();
					window.addEventListener('resize', this.reInit.bind(this))
					// setTimeout(()=> {
					// 	this.handleSlidesHeight().bind(this);
					// }, 3000)
				}
			}
		},{
			key: 'reInit',
			value: function reInit(event) {
				// if ($(window).width() > 640) {
				// 	this.windowWidth = $(window).width();
				// 	this.slideshow.slick.unslick();
				// } else if ($(window).width() != this.windowWidth) {
				// 	this.windowWidth = $(window).width();
				// 	this.slideshow.slick.unslick();
				// 	this.handleSlidesHeight();
				// 	$(this.slideshow).slick(this.sliderOption);
				// }

				if ($(window).width() != this.windowWidth) {
					this.windowWidth = $(window).width();
					this.slideshow.slick.unslick();
					this.handleSlidesHeight();
					$(this.slideshow).slick(this.sliderOption);
				}
			}
		}, {
			key: 'onSelect',
			value: function onSelect() {
				$(this.slideshow).slick("slickPause");
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				$(this.slideshow).slick("slickGoTo", event.target.dataset.slideIndex, true);
			}
		}, {
			key: 'onDeselect',
			value: function() {
				$(this.slideshow).slick("slickPlay");
			}
		}, {
			key: 'handleSlidesHeight',
			value: function handleSlidesHeight() {
				let maxHeight = -1;
				$(this.slides).each(function() {
					if ($(this).height() > maxHeight) {
						maxHeight = $(this).height();
					}
				});
				this.slides.forEach(slide => {
					if ($(slide).height() < maxHeight) {
						let padding = parseInt(getComputedStyle(slide).getPropertyValue('--padding-block').replace(/\D/g, ""));
						$(slide).css('padding-block', padding + (maxHeight-$(slide).height())/2 + 'px');
					}
				});
			}
		}]);

		return AnnouncementBar;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = AnnouncementBar;

	/***/
},
/* 72 mobile instagram carousel */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var MobileInstagram = function() {
		function MobileInstagram(container) {
			_classCallCheck(this, MobileInstagram);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
			this.carouselElement = this.element.querySelector(".MobileSection--instagram--carousel");
			let carouselOptions = {
				prevNextButtons: false,
				wrapAround: true
			}
			if (this.options.blocks > 1 && this.carouselElement) {
				this.carousel = new Flickity(this.carouselElement, carouselOptions);
			}
		}

		_createClass(MobileInstagram, [ {
			key: '_onSelect',
			value: function _onSelect() {
				this.carousel.stopPlayer();
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				this.carousel.select(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
			}
		}, {
			key: 'onDeselect',
			value: function() {
				 
			}
		}]);

		return MobileInstagram;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = MobileInstagram;

	/***/
},
/* 73 mobile PCL */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__helper_Dom__ = __webpack_require__(0);

	var PCLSection = function() {
		function PCLSection(container) {
			_classCallCheck(this, PCLSection);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
			
				__WEBPACK_IMPORTED_MODULE_0__helper_Dom__["default"].nodeListToArray(this.element.querySelectorAll("[data-flickity-config]")).forEach(function (carousel) {
					new __WEBPACK_IMPORTED_MODULE_0__components_Carousel__["default"](carousel);
				});
				
		}

		_createClass(PCLSection, []);

		return PCLSection;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = PCLSection;

	/***/
},
/* 74 all videos page */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__helper_Dom__ = __webpack_require__(0);

	var VideosPage = function() {
		function VideosPage(container) {
			_classCallCheck(this, VideosPage);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
			this.players = [];
			this._loadScript().then(this._setupPlayers.bind(this));
		}

		_createClass(VideosPage, [{
			key: '_loadScript',
			value: function _loadScript() {
				return new Promise(function (resolve, reject) {
					var script = document.createElement('script');
					document.body.appendChild(script);
					script.onload = resolve;
					script.onerror = reject;
					script.async = true;
					script.src = '//player.vimeo.com/api/player.js';
				});
			}
		}, {
			key: 'onUnload',
			value: function onUnload() {
				if (this.player) {
					this.player.destroy(); // Both YouTube and Vimeo use the same function name
				}
			}
		}, {
			key: '_setupPlayers',
			value: function _setupPlayers() {
				let _this34 = this;
				let playerLoadingInterval = setInterval(function () {
					if (window.Vimeo) {
						__WEBPACK_IMPORTED_MODULE_2__helper_Dom__["default"].nodeListToArray(_this34.element.querySelectorAll('iframe')).forEach(function (video) {
							_this34.players.push(new Vimeo.Player(video, {
								id: video.dataset.videoID,
								autoplay: false,
								autopause: false,
								muted: true,
								background: true,
								/*height: '100%',
								width: '100%',*/
								loop: true
							}));
						});
						// _this34.players[0].requestFullscreen();
						// _this34.players[0].play();
						clearInterval(playerLoadingInterval);
					}
				}, 50);
			}
		}]);

		return VideosPage;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = VideosPage;

	/***/
},
/* 75 branded video */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(10);

	var BrandedVideo = function() {
		function BrandedVideo(container) {
			_classCallCheck(this, BrandedVideo);

			this.element = container;

			this.delegateElement = new domDelegate.Delegate(this.element);
			this.documentDelegate = new domDelegate.Delegate(document.documentElement);

			this._init();
			this._attachListeners();
			this._switchVideoSource();
		}

		_createClass(BrandedVideo, [{
				key: "_init",
				value: function _init(){
					let video = this.element.querySelector("video");
					video.outerHTML = `<div class="BrandedVideoWrapper">${video.outerHTML}</div>`;
					this.player = this.element.querySelector("video");
					this.playerWrapper = this.element.querySelector(".BrandedVideoWrapper");
				}
			},{
				key: "_attachListeners",
				value: function _attachListeners() {

					this.player.addEventListener("loadedmetadata", this._createControls.bind(this), {once: true});
					this.player.addEventListener("timeupdate", this._handleProgressBar.bind(this));
					this.player.addEventListener("pause", this._setVideoState.bind(this));
					this.player.addEventListener("play", this._setVideoState.bind(this));

					this.delegateElement.on('click', '[data-action="play"]', this._play.bind(this));
					this.delegateElement.on('click', '[data-action="pause"]', this._pause.bind(this));
					this.delegateElement.on('click', '[data-action="forward"]', this._handleForwardButton.bind(this));
					this.delegateElement.on('click', '[data-action="fullscreen"]', this._handleFullscreenButton.bind(this));
					this.delegateElement.on('click', '[data-action="mute"]', this._handleMuteButton.bind(this));
					window.addEventListener("resize", this._switchVideoSource.bind(this));
				}
			},{
				key: "_createControls",
				value: function _createControls() {
					let controlsWrapper = document.createElement("div");
					controlsWrapper.classList.add("BrandedVideo--controls");

					let playPauseButton = this._createPlayPauseButton();
					controlsWrapper.append(playPauseButton);

					let progressBar = this._createProgressBar();
					controlsWrapper.append(progressBar);

					let forwardButton = this._createForwardButton();
					controlsWrapper.append(forwardButton);

					let fullScreenButton = this._createFullScreenButton();
					controlsWrapper.append(fullScreenButton);

					let muteButton = this._createMuteButon();
					controlsWrapper.append(muteButton);

					this.playerWrapper.append(controlsWrapper);
				}
			},{
				key: "_createPlayPauseButton",
				value: function _createPlayPauseButton() {
					let button = document.createElement("button");
					button.classList.add("BrandedVideo--controls--play_pause");
					button.setAttribute("data-action", "play")
					button.innerHTML = `<svg class="BrandedVideo--controls--play" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 22v-20l18 10-18 10z"/></svg><svg class="BrandedVideo--controls--pause" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M11 22h-4v-20h4v20zm6-20h-4v20h4v-20z"/></svg>`;
					this.playPauseButton = button;
					return button;
				}
			},{
				key: "_createProgressBar",
				value: function _createProgressBar() {
					let progressBarWrapper = document.createElement("div");
					progressBarWrapper.classList.add("BrandedVideo--progress_bar--wrapper");

					let progressBar = document.createElement("progress");
					progressBar.classList.add("BrandedVideo--progress_bar");
					progressBar.value = 0;
					progressBar.min = 0;
					progressBar.max = Math.floor(this.player.duration);
					this.progressBar = progressBar;

					let progressBarInput = document.createElement("input");
					progressBarInput.classList.add("BrandedVideo--progress-input");
					progressBarInput.type = "range";
					progressBarInput.value = 0;
					progressBarInput.min = 0;
					progressBarInput.max = Math.floor(this.player.duration);
					progressBar.step = 1;
					this.progressBarInput = progressBarInput;
					this.progressBarInput.addEventListener("change", this._handleProgressBarInput.bind(this));

					progressBarWrapper.append(progressBar);
					progressBarWrapper.append(progressBarInput);
					return progressBarWrapper;
				}
			},{
				key: "_createForwardButton",
				value: function _createForwardButton() {
					let button = document.createElement("button");
					button.classList.add("BrandedVideo--controls--forward");
					button.setAttribute("data-action", "forward");
					button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path class="ct0" d="M12 12l-12 8v-16l12 8zm0-8v16l12-8-12-8z"/></svg>`;
					return button;
				}
			},{
				key: "_createFullScreenButton",
				value: function _createFullScreenButton() {
					let button = document.createElement("button");
					button.classList.add("BrandedVideo--controls--fullscreen");
					button.setAttribute("data-action", "fullscreen");
					button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 9h-2v-4h-4v-2h6v6zm-6 12v-2h4v-4h2v6h-6zm-18-6h2v4h4v2h-6v-6zm6-12v2h-4v4h-2v-6h6z"/></svg>`;
					return button;
				}
			},{
				key: "_createMuteButon",
				value: function _createMuteButon() {
					let button = document.createElement("button");
					button.classList.add("BrandedVideo--controls--mute");
					button.setAttribute("data-action", "mute");
					button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14px" height="28px" viewBox="0 0 10 7" version="1.1">
						<g>
							<rect id="bar1" transform="translate(0.500000, 6.000000) rotate(180.000000) translate(-0.500000, -6.000000) " x="0" y="5" width="1" height="2px"/>
							<rect id="bar2" transform="translate(3.500000, 4.500000) rotate(180.000000) translate(-3.500000, -4.500000) " x="3" y="2" width="1" height="5"/>
							<rect id="bar3" transform="translate(6.500000, 3.500000) rotate(180.000000) translate(-6.500000, -3.500000) " x="6" y="0" width="1" height="7"/>
							<rect id="bar4" transform="translate(9.500000, 5.000000) rotate(180.000000) translate(-9.500000, -5.000000) " x="9" y="3" width="1" height="4"/>
						</g>
					</svg>`;
					return button;
				}
			},{
				key: "_setVideoState",
				value: function _setVideoState(event) {
					this.element.setAttribute("data-state", event.type);
					this.playPauseButton.setAttribute("data-action", event.type == "play" ? "pause" : "play");
				}
			},{
				key: "_play",
				value: function _play(event, target) {
					this.player.play();
				}
			},{
				key: "_pause",
				value: function _pause(event, target) {
					this.player.pause();
				}
			},{
				key: "_handleProgressBar",
				value: function _handleProgressBar(event, target) {
					if (this.progressBar) this.progressBar.value = event.srcElement.currentTime;
				}
			},{
				key: "_handleProgressBarInput",
				value: function _handleProgressBarInput(event) {
					this.player.currentTime = event.srcElement.value;
				}
			},{
				key: "_handleForwardButton",
				value: function __handleForwardButton() {
					this.player.currentTime = this.player.currentTime + this.player.duration * 0.05;
				}
			},{
				key: "_handleFullscreenButton",
				value: function _handleFullscreenButton() {
					if (document.fullscreenElement?.className == "BrandedVideoWrapper") {
						document.exitFullscreen();
					} else {
						if (this.player.parentNode.requestFullscreen) {
							this.player.parentNode.requestFullscreen();
						} else if (this.player.parentNode.mozRequestFullScreen) {
							this.player.parentNode.mozRequestFullScreen();
						} else if (this.player.parentNode.webkitRequestFullscreen) {
							this.player.parentNode.webkitRequestFullscreen();
						} else if (this.player.parentNode.msRequestFullscreen) { 
							this.player.parentNode.msRequestFullscreen();
						} else if (this.player.webkitSupportsFullscreen) {
							this.player.webkitEnterFullScreen();
						}
					}
				}
			},{
				key: "_handleMuteButton",
				value: function _handleMuteButton() {
					this.player.muted ? this.player.muted = false : this.player.muted = true;
				}
			},{
				key: "_switchVideoSource",
				value: function _switchVideoSource() {
					let condition = window.matchMedia("(min-width: 641px)");
					let source_src, current_src;
					if (condition.matches) {
						source_src = this.playerWrapper.parentNode.dataset.urlDesktop;
						current_src = this.player.currentSrc;
						if (source_src == current_src) return;
					} else {
						source_src = this.playerWrapper.parentNode.dataset.urlMobile;
						current_src = this.player.currentSrc;
						if (source_src == current_src) return;
					}
					let paused = this.player.paused;
					let time_played = this.player.currentTime;
					if (!paused) {
						this._pause();
					}
					this.player.src = source_src;
					this.player.load();
					this.player.currentTime = time_played;
					if (!paused) {
						this._play();
					}
				}
			}
		]);

		return BrandedVideo;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = BrandedVideo;

	/***/
},
/* 76 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__AddressesSection__ = __webpack_require__(29);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "AddressesSection", function () {
		return __WEBPACK_IMPORTED_MODULE_0__AddressesSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__ArticleListSection__ = __webpack_require__(30);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ArticleListSection", function () {
		return __WEBPACK_IMPORTED_MODULE_1__ArticleListSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__ArticleSection__ = __webpack_require__(31);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ArticleSection", function () {
		return __WEBPACK_IMPORTED_MODULE_2__ArticleSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_3__CartSection__ = __webpack_require__(33);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "CartSection", function () {
		return __WEBPACK_IMPORTED_MODULE_3__CartSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_4__CollectionListSection__ = __webpack_require__(34);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "CollectionListSection", function () {
		return __WEBPACK_IMPORTED_MODULE_4__CollectionListSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_5__CollectionSection__ = __webpack_require__(35);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "CollectionSection", function () {
		return __WEBPACK_IMPORTED_MODULE_5__CollectionSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_6__FaqSection__ = __webpack_require__(36);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "FaqSection", function () {
		return __WEBPACK_IMPORTED_MODULE_6__FaqSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_7__FeaturedCollectionsSection__ = __webpack_require__(37);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "FeaturedCollectionsSection", function () {
		return __WEBPACK_IMPORTED_MODULE_7__FeaturedCollectionsSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_8__FeaturedProductSection__ = __webpack_require__(38);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "FeaturedProductSection", function () {
		return __WEBPACK_IMPORTED_MODULE_8__FeaturedProductSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_9__BackgroundVideoSection__ = __webpack_require__(32);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "BackgroundVideoSection", function () {
		return __WEBPACK_IMPORTED_MODULE_9__BackgroundVideoSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_10__GiftCardSection__ = __webpack_require__(40);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "GiftCardSection", function () {
		return __WEBPACK_IMPORTED_MODULE_10__GiftCardSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_11__HeaderSection__ = __webpack_require__(41);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "HeaderSection", function () {
		return __WEBPACK_IMPORTED_MODULE_11__HeaderSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_12__FooterSection__ = __webpack_require__(39);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "FooterSection", function () {
		return __WEBPACK_IMPORTED_MODULE_12__FooterSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_13__ImageWithTextBlockSection__ = __webpack_require__(42);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ImageWithTextBlockSection", function () {
		return __WEBPACK_IMPORTED_MODULE_13__ImageWithTextBlockSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_14__LoginSection__ = __webpack_require__(43);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "LoginSection", function () {
		return __WEBPACK_IMPORTED_MODULE_14__LoginSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_15__MapSection__ = __webpack_require__(44);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "MapSection", function () {
		return __WEBPACK_IMPORTED_MODULE_15__MapSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_16__NewsletterPopupSection__ = __webpack_require__(45);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "NewsletterPopupSection", function () {
		return __WEBPACK_IMPORTED_MODULE_16__NewsletterPopupSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_17__ProductRecommendationsSection__ = __webpack_require__(46);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductRecommendationsSection", function () {
		return __WEBPACK_IMPORTED_MODULE_17__ProductRecommendationsSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_18__ProductSection__ = __webpack_require__(47);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductSection", function () {
		return __WEBPACK_IMPORTED_MODULE_18__ProductSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_19__RecentlyViewedProductsSection__ = __webpack_require__(48);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "RecentlyViewedProductsSection", function () {
		return __WEBPACK_IMPORTED_MODULE_19__RecentlyViewedProductsSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_20__SectionContainer__ = __webpack_require__(50);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "SectionContainer", function () {
		return __WEBPACK_IMPORTED_MODULE_20__SectionContainer__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_21__SearchSection__ = __webpack_require__(49);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "SearchSection", function () {
		return __WEBPACK_IMPORTED_MODULE_21__SearchSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_22__ShopNowSection__ = __webpack_require__(51);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ShopNowSection", function () {
		return __WEBPACK_IMPORTED_MODULE_22__ShopNowSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_23__ShopTheLookSection__ = __webpack_require__(52);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ShopTheLookSection", function () {
		return __WEBPACK_IMPORTED_MODULE_23__ShopTheLookSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_24__SidebarMenuSection__ = __webpack_require__(53);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "SidebarMenuSection", function () {
		return __WEBPACK_IMPORTED_MODULE_24__SidebarMenuSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_25__SlideshowSection__ = __webpack_require__(54);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "SlideshowSection", function () {
		return __WEBPACK_IMPORTED_MODULE_25__SlideshowSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_26__TestimonialsSection__ = __webpack_require__(55);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "TestimonialsSection", function () {
		return __WEBPACK_IMPORTED_MODULE_26__TestimonialsSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_27__TimelineSection__ = __webpack_require__(56);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "TimelineSection", function () {
		return __WEBPACK_IMPORTED_MODULE_27__TimelineSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_28__ProductLooksSection__ = __webpack_require__(58);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductLooksSection", function () {
		return __WEBPACK_IMPORTED_MODULE_28__ProductLooksSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_29__ProductCompleteTheLookSection__ = __webpack_require__(60);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductCompleteTheLookSection", function () {
		return __WEBPACK_IMPORTED_MODULE_29__ProductCompleteTheLookSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_30__IndexMainCollection__ = __webpack_require__(61);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "IndexMainCollection", function () {
		return __WEBPACK_IMPORTED_MODULE_30__IndexMainCollection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_30__IndexSecondaryCollection__ = __webpack_require__(62);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "IndexSecondaryCollection", function () {
		return __WEBPACK_IMPORTED_MODULE_30__IndexSecondaryCollection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_30__CustomPageTemplate__ = __webpack_require__(63);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "CustomPageTemplate", function () {
		return __WEBPACK_IMPORTED_MODULE_30__CustomPageTemplate__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_33__AccountNavigation__ = __webpack_require__(64);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "AccountNavigation", function () {
		return __WEBPACK_IMPORTED_MODULE_33__AccountNavigation__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_34__AccountSection__ = __webpack_require__(65);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "AccountSection", function () {
		return __WEBPACK_IMPORTED_MODULE_34__AccountSection__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_35__RedirectPopup__ = __webpack_require__(66);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "RedirectPopup", function () {
		return __WEBPACK_IMPORTED_MODULE_35__RedirectPopup__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_37__ProductInstagramGallery__ = __webpack_require__(68);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "ProductInstagramGallery", function () {
		return __WEBPACK_IMPORTED_MODULE_37__ProductInstagramGallery__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_38__AnnouncementBar__ = __webpack_require__(71);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "AnnouncementBar", function () {
		return __WEBPACK_IMPORTED_MODULE_38__AnnouncementBar__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_39__MobileInstagram__ = __webpack_require__(72);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "MobileInstagram", function () {
		return __WEBPACK_IMPORTED_MODULE_39__MobileInstagram__["default"];
	});
	/***/
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_40__PCLSection__ = __webpack_require__(73);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "PCL", function () {
		return __WEBPACK_IMPORTED_MODULE_40__PCLSection__["default"];
	});
	/***/
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_41__VideosPage__ = __webpack_require__(74);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "VideosPage", function () {
		return __WEBPACK_IMPORTED_MODULE_41__VideosPage__["default"];
	});
	/***/
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_41__BrandedVideo__ = __webpack_require__(75);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "BrandedVideo", function () {
		return __WEBPACK_IMPORTED_MODULE_41__BrandedVideo__["default"];
	});

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_42__MobilePress__ = __webpack_require__(79);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "MobilePress", function () {
		return __WEBPACK_IMPORTED_MODULE_42__MobilePress__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_42__KeyFeatures__ = __webpack_require__(80);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "KeyFeatures", function () {
		return __WEBPACK_IMPORTED_MODULE_42__KeyFeatures__["default"];
	});
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_42__StyledWith__ = __webpack_require__(81);
	/* harmony reexport (binding) */__webpack_require__.d(__webpack_exports__, "StyledWith", function () {
		return __WEBPACK_IMPORTED_MODULE_42__StyledWith__["default"];
	});


},
/* 77 */
/***/function (module, exports, __webpack_require__) {

	__webpack_require__(5);
	__webpack_require__(7);
	__webpack_require__(8);
	__webpack_require__(0);
	__webpack_require__(22);
	__webpack_require__(9);
	__webpack_require__(1);
	__webpack_require__(10);
	__webpack_require__(2);
	__webpack_require__(23);
	__webpack_require__(12);
	__webpack_require__(6);
	__webpack_require__(24);
	__webpack_require__(25);
	__webpack_require__(13);
	__webpack_require__(26);
	__webpack_require__(3);
	__webpack_require__(14);
	__webpack_require__(4);
	__webpack_require__(15);
	__webpack_require__(16);
	__webpack_require__(11);
	__webpack_require__(18);
	__webpack_require__(19);
	__webpack_require__(28);
	__webpack_require__(57);
	__webpack_require__(20);
	__webpack_require__(27);
	__webpack_require__(17);
	__webpack_require__(21);
	__webpack_require__(29);
	__webpack_require__(30);
	__webpack_require__(31);
	__webpack_require__(32);
	__webpack_require__(33);
	__webpack_require__(34);
	__webpack_require__(35);
	__webpack_require__(36);
	__webpack_require__(37);
	__webpack_require__(38);
	__webpack_require__(39);
	__webpack_require__(40);
	__webpack_require__(41);
	__webpack_require__(42);
	__webpack_require__(43);
	__webpack_require__(44);
	__webpack_require__(45);
	__webpack_require__(46);
	__webpack_require__(47);
	__webpack_require__(48);
	__webpack_require__(49);
	__webpack_require__(50);
	__webpack_require__(51);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(56);
	__webpack_require__(58);
	__webpack_require__(59);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(69);
	__webpack_require__(71);
	__webpack_require__(72);
	__webpack_require__(73);
	__webpack_require__(74);
	__webpack_require__(75);
	__webpack_require__(76);
	__webpack_require__(79);
	module.exports = __webpack_require__(78);

	/***/
},
/* 78 */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";

	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(21);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(10);
	/* harmony import */var __WEBPACK_IMPORTED_MODULE_2__sections__ = __webpack_require__(76);

	(function () {
		// First, we register all plugins that are used for all pages
		new __WEBPACK_IMPORTED_MODULE_0__components__["Collapsible"]();
		new __WEBPACK_IMPORTED_MODULE_0__components__["Modal"]();
		new __WEBPACK_IMPORTED_MODULE_1__helper__["ResponsiveHelper"]();
		new __WEBPACK_IMPORTED_MODULE_0__components__["IPDetection"]();

		// Global, robust order timer updater with fallbacks
		if (!window.updateOrderTimer) {
			window.updateOrderTimer = function(){
				try {
					var container = document.querySelector('#timer-container');
					if (!container) return;
					var wrapper = document.querySelector('.ProductMeta_secondary-order-timer');
					var cached = null, tzData = null, tzName = null;
					try { cached = localStorage.getItem('ipdata_cache'); } catch(e) {}
					if (cached) {
						try {
							var parsed = JSON.parse(cached);
							if (parsed && parsed.data && parsed.data.time_zone) {
								tzData = parsed.data.time_zone;
								tzName = tzData.name || tzData.timezone || null;
							}
						} catch(e) {}
					}

					var hour24 = null;
					var minutes = null;
					// Try with Intl and timezone name first
					if (tzName && typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
						try {
							var parts = new Intl.DateTimeFormat('en-US', { timeZone: tzName, hour: 'numeric', minute: 'numeric', hour12: true }).formatToParts(new Date());
							var hStr = null, mStr = null, dp = null;
							for (var i = 0; i < parts.length; i++) {
								var p = parts[i];
								if (p.type === 'hour') hStr = p.value;
								if (p.type === 'minute') mStr = p.value;
								if (p.type === 'dayPeriod') dp = p.value;
							}
							var hNum = parseInt(hStr, 10);
							var mNum = parseInt(mStr, 10);
							if (!isNaN(hNum) && !isNaN(mNum)) {
								if (dp && dp.toLowerCase() === 'pm' && hNum !== 12) { hour24 = hNum + 12; } else if (dp && dp.toLowerCase() === 'am' && hNum === 12) { hour24 = 0; } else { hour24 = hNum; }
								minutes = mNum;
							}
						} catch(e) {}
					}

					// Fallback to utc_offset math
					if ((hour24 === null || minutes === null) && tzData && tzData.utc_offset) {
						var base = new Date();
						var utcHours = base.getUTCHours();
						var utcMinutes = base.getUTCMinutes();
						var m = /^([+-])(\d{2}):(\d{2})$/.exec(String(tzData.utc_offset));
						if (m) {
							var sign = m[1] === '-' ? -1 : 1;
							var offMin = sign * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10));
							var totalMin = utcHours * 60 + utcMinutes + offMin;
							totalMin = ((totalMin % (24*60)) + (24*60)) % (24*60);
							hour24 = Math.floor(totalMin / 60);
							minutes = totalMin % 60;
						}
					}

					// Final fallback: browser local time
					if (hour24 === null || minutes === null) {
						var local = new Date();
						hour24 = local.getHours();
						minutes = local.getMinutes();
					}

					// Always show the next top of the hour in the computed timezone
					var nextHour = hour24 + 1;
					nextHour = ((nextHour % 24) + 24) % 24;
					var display = (nextHour % 12 === 0 ? 12 : (nextHour % 12)) + (nextHour < 12 ? 'am' : 'pm');
					container.innerHTML = display;
					if (wrapper) { wrapper.classList.remove('hidden'); }
				} catch (err) {
					try {
						var w = document.querySelector('.ProductMeta_secondary-order-timer');
						if (w) { w.classList.add('hidden'); }
					} catch(e) {}
					console.error('updateOrderTimer failed', err);
				}
			};
		}

		// Recompute once IP data arrives
		try {
			document.documentElement.addEventListener('ipdata:received', function(){
				if (window.updateOrderTimer) { window.updateOrderTimer(); }
			});
		} catch(e) {}

		if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
			new __WEBPACK_IMPORTED_MODULE_0__components__["LoadingBar"]();
		}

		var sections = new __WEBPACK_IMPORTED_MODULE_2__sections__["SectionContainer"]();

		sections.register('header', __WEBPACK_IMPORTED_MODULE_2__sections__["HeaderSection"]);
		sections.register('footer', __WEBPACK_IMPORTED_MODULE_2__sections__["FooterSection"]);
		sections.register('sidebar-menu', __WEBPACK_IMPORTED_MODULE_2__sections__["SidebarMenuSection"]);
		sections.register('cart', __WEBPACK_IMPORTED_MODULE_2__sections__["CartSection"]);
		sections.register('announcement-bar', __WEBPACK_IMPORTED_MODULE_2__sections__["AnnouncementBar"]);

		// Sections used on index
		sections.register('slideshow', __WEBPACK_IMPORTED_MODULE_2__sections__["SlideshowSection"]);
		sections.register('collection-list', __WEBPACK_IMPORTED_MODULE_2__sections__["CollectionListSection"]);
		sections.register('article-list', __WEBPACK_IMPORTED_MODULE_2__sections__["ArticleListSection"]);
		sections.register('featured-product', __WEBPACK_IMPORTED_MODULE_2__sections__["FeaturedProductSection"]);
		sections.register('image-with-text-block', __WEBPACK_IMPORTED_MODULE_2__sections__["ImageWithTextBlockSection"]);
		sections.register('timeline', __WEBPACK_IMPORTED_MODULE_2__sections__["TimelineSection"]);
		sections.register('map', __WEBPACK_IMPORTED_MODULE_2__sections__["MapSection"]);
		sections.register('featured-collections', __WEBPACK_IMPORTED_MODULE_2__sections__["FeaturedCollectionsSection"]);
		sections.register('shop-the-look', __WEBPACK_IMPORTED_MODULE_2__sections__["ShopTheLookSection"]);
		sections.register('testimonials', __WEBPACK_IMPORTED_MODULE_2__sections__["TestimonialsSection"]);
		sections.register('background-video', __WEBPACK_IMPORTED_MODULE_2__sections__["BackgroundVideoSection"]);
		sections.register('index_carousel', __WEBPACK_IMPORTED_MODULE_2__sections__["IndexMainCollection"]);
		sections.register('index_secondary_collection', __WEBPACK_IMPORTED_MODULE_2__sections__["IndexSecondaryCollection"]);

		// Sections used on product page
		sections.register('product', __WEBPACK_IMPORTED_MODULE_2__sections__["ProductSection"]);
		sections.register('product-recommendations', __WEBPACK_IMPORTED_MODULE_2__sections__["ProductRecommendationsSection"]);
		sections.register('product-looks', __WEBPACK_IMPORTED_MODULE_2__sections__["ProductLooksSection"]);
		sections.register('product-complete_the_look', __WEBPACK_IMPORTED_MODULE_2__sections__["ProductCompleteTheLookSection"]);
		sections.register('instagram-gallery', __WEBPACK_IMPORTED_MODULE_2__sections__["ProductInstagramGallery"]);
		sections.register('instagram_carousel', __WEBPACK_IMPORTED_MODULE_2__sections__["MobileInstagram"]);
		sections.register('press_carousel', __WEBPACK_IMPORTED_MODULE_2__sections__["MobilePress"]);
		sections.register('key_features', __WEBPACK_IMPORTED_MODULE_2__sections__["KeyFeatures"]);
		sections.register('styled_with_upsells', __WEBPACK_IMPORTED_MODULE_2__sections__["StyledWith"]);
		sections.register('PCL', __WEBPACK_IMPORTED_MODULE_2__sections__["PCL"]);


		// Sections used on collection page
		sections.register('collection', __WEBPACK_IMPORTED_MODULE_2__sections__["CollectionSection"]);

		// Sections used on blog page
		sections.register('article-list', __WEBPACK_IMPORTED_MODULE_2__sections__["ArticleListSection"]);

		// Sections used on article page
		sections.register('article', __WEBPACK_IMPORTED_MODULE_2__sections__["ArticleSection"]);

		// Sections used on content pages
		sections.register('faq', __WEBPACK_IMPORTED_MODULE_2__sections__["FaqSection"]);

		// Sections used on login page
		sections.register('login', __WEBPACK_IMPORTED_MODULE_2__sections__["LoginSection"]);

		// Sections used on addresses page
		sections.register('addresses', __WEBPACK_IMPORTED_MODULE_2__sections__["AddressesSection"]);

		// Sections used on gift card page
		sections.register('gift-card', __WEBPACK_IMPORTED_MODULE_2__sections__["GiftCardSection"]);

		// Sections used on search page
		sections.register('search', __WEBPACK_IMPORTED_MODULE_2__sections__["SearchSection"]);

		// Sections used on different pages
		sections.register('recently-viewed-products', __WEBPACK_IMPORTED_MODULE_2__sections__["RecentlyViewedProductsSection"]);
		sections.register('shop-now', __WEBPACK_IMPORTED_MODULE_2__sections__["ShopNowSection"]);
		sections.register('all_videos_page', __WEBPACK_IMPORTED_MODULE_2__sections__["VideosPage"]);
		sections.register('branded_video', __WEBPACK_IMPORTED_MODULE_2__sections__["BrandedVideo"]);

		sections.register('custom_page_template', __WEBPACK_IMPORTED_MODULE_2__sections__["CustomPageTemplate"]);
		sections.register('account-navigation', __WEBPACK_IMPORTED_MODULE_2__sections__["AccountNavigation"]);
		sections.register('account-template', __WEBPACK_IMPORTED_MODULE_2__sections__["AccountSection"]);

		// Popup init
		// We init them at the end for conditional invocation depending on pages/sections we are currently on
		// Redirect popup goes first coz of the higher priority

		sections.register('redirect-popup', __WEBPACK_IMPORTED_MODULE_2__sections__["RedirectPopup"]);
		sections.register('newsletter-popup', __WEBPACK_IMPORTED_MODULE_2__sections__["NewsletterPopupSection"]);

		/**
		 * ----------------------------------------------------------------------------
		 * FLICKITY
		 *
		 * Starting from iOS 11, Safari on iOS is experiencing a bug that prevents
		 * event.preventDefault to be called on dynamically added listeners, which is
		 * what Flickity is using.
		 *
		 * The bug is coming from iOS but it impacts indirectly Flickity. A temporary
		 * fix has been suggested here: https://github.com/metafizzy/flickity/issues/740
		 * and that we are using here as a temporary workaround, that should be removed
		 * once the bug is fixed on iOS
		 * ----------------------------------------------------------------------------
		 */

		Flickity.defaults.dragThreshold = 7;

		(function () {
			var touchingCarousel = false,
					touchStartCoords = void 0;

			document.body.addEventListener('touchstart', function (e) {
				if (e.target.closest('.flickity-slider')) {
					touchingCarousel = true;
				} else {
					touchingCarousel = false;
					return;
				}

				touchStartCoords = {
					x: e.touches[0].pageX,
					y: e.touches[0].pageY
				};
			});

			document.body.addEventListener('touchmove', function (e) {
				if (!(touchingCarousel && e.cancelable)) {
					return;
				}

				var moveVector = {
					x: e.touches[0].pageX - touchStartCoords.x,
					y: e.touches[0].pageY - touchStartCoords.y
				};

				if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold) e.preventDefault();
			}, { passive: false }); 
		})();

		/**
		 * ----------------------------------------------------------------------------
		 * RTE
		 * ----------------------------------------------------------------------------
		 */

		(function () {
			// We wrap each RTE table by a specific class to allow wrapping
			__WEBPACK_IMPORTED_MODULE_1__helper__["DomHelper"].nodeListToArray(document.querySelectorAll('.Rte table')).forEach(function (table) {
				table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>';
			});

			__WEBPACK_IMPORTED_MODULE_1__helper__["DomHelper"].nodeListToArray(document.querySelectorAll('.Rte iframe')).forEach(function (iframe) {
				// We scope the wrapping only for YouTube and Vimeo
				if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1) {
					iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>';

					// Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
					// https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar
					iframe.src = iframe.src;
				}
			});			
		})();

		/**
		 * ----------------------------------------------------------------------------
		 * UTILS
		 * ----------------------------------------------------------------------------
		 */

		(function () {
			var documentDelegate = new domDelegate.Delegate(document.body),
					announcementBar = document.querySelector('.AnnouncementBar');

			documentDelegate.on('click', '[href^="#"], [data-href]', function (event, target) {
				var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');

				if (selector === '#') {
					return;
				}

				var element = document.querySelector(selector),
						offset = parseInt(target.getAttribute('data-offset') || 0);

				if (announcementBar) {
					offset -= announcementBar.clientHeight;
				}

				if (target.hasAttribute('data-focus-on-click')) {
					var prevScrollY = window.pageYOffset;
					element.focus({ preventScroll: true });

					// hack to fix scroll jump after focus
					if (window.pageYOffset !== prevScrollY) {
						window.scrollTo(window.pageXOffset, prevScrollY);
					}

					element.focus();
				}

				window.scrollTo({ behavior: 'smooth', top: element.offsetTop - offset });

				event.preventDefault();
			});
		})();

		(function () {
			var windowWidth = window.innerWidth,
					headerSection = document.getElementById('shopify-section-header');
			var searchSection = document.getElementById("Search");

			window.addEventListener('resize', function () {
				var newWidth = -1;

				fastdom.measure(function () {
					newWidth = window.innerWidth;
				});

				fastdom.mutate(function () {
					if (newWidth === windowWidth) {
						return;
					}

					windowWidth = newWidth;

					document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');

					if (headerSection) {
						document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
						document.documentElement.style.setProperty('--search-height', searchSection.clientHeight + 'px');
					}
				});
			});
		})();

		(function () {
			function handleFirstTab(event) {
				if (event.keyCode === 9) {
					document.body.classList.add('is-tabbing');
					window.removeEventListener('keydown', handleFirstTab);
				}
			}

			window.addEventListener('keydown', handleFirstTab);
		})();

		// Handle loopreturns links
		(function(){
			var link = window.theme.loopreturns_link;
			 __WEBPACK_IMPORTED_MODULE_1__helper__["DomHelper"].nodeListToArray(document.querySelectorAll('[data-loopreturns-link]')).forEach(function (a) {
				a.setAttribute("href", link);
				a.setAttribute("target", "_blank");
			});
		})();

		/**
		 * ----------------------------------------------------------------------------
		 * ANIMATION
		 *
		 * Important: this has to be at the very end of the file
		 * ----------------------------------------------------------------------------
		 */

		if (window.theme.showPageTransition) {
			__WEBPACK_IMPORTED_MODULE_0__components__["PageTransition"].getInstance();
		}
	})();

	/***/
},

/* 79 mobile press carousel */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var MobilePress = function() {
		function MobilePress(container) {
			_classCallCheck(this, MobilePress);

			this.element = container;
			this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
			this.carouselElement = this.element.querySelector(".MobileSection--press--carousel");
			let carouselOptions = {
				prevNextButtons: false,
				wrapAround: true,
				adaptiveHeight: false
			}
			if (this.options.blocks > 1 && this.carouselElement) {
				this.carousel = new Flickity(this.carouselElement, carouselOptions);
			}
		}

		_createClass(MobilePress, [ {
			key: '_onSelect',
			value: function _onSelect() {
				this.carousel.stopPlayer();
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				this.carousel.select(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
			}
		}, {
			key: 'onDeselect',
			value: function() {
				 
			}
		}]);

		return MobilePress;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = MobilePress;

	/***/
},

/* 80 key features carousel */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var KeyFeatures = function() {
		function KeyFeatures(container) {
			_classCallCheck(this, KeyFeatures);

			this.element = container;
			this.carouselElement = this.element.querySelector(".keyFeatures--carousel");
			let carouselOptions = {
				prevNextButtons: false,
				pageDots: false,
				wrapAround: false,
				adaptiveHeight: false,
				cellAlign: "left",
      			contain: true,
				watchCSS: true
			}
			if (this.carouselElement) {
				this.carousel = new Flickity(this.carouselElement, carouselOptions);
				this.carousel.resize();
			}
		}

		_createClass(KeyFeatures, [ {
			key: '_onSelect',
			value: function _onSelect() {
				this.carousel.stopPlayer();
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				this.carousel.select(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
			}
		}, {
			key: 'onDeselect',
			value: function() {
				 
			}
		}]);

		window.addEventListener("load", (event) => {
			window.dispatchEvent(new Event('resize'));
			console.log("page is fully loaded");
		  });


		return KeyFeatures;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = KeyFeatures;

	/***/
},

/* 81 key features carousel */
/***/function (module, __webpack_exports__, __webpack_require__) {

	"use strict";
	Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

	/* harmony import */var __WEBPACK_IMPORTED_MODULE_0__components_Carousel__ = __webpack_require__(2);

	var StyledWith = function() {
		function StyledWith(container) {
			_classCallCheck(this, StyledWith);

			this.element = container;
			this.carouselElement = this.element.querySelector(".StyledWith--carousel");
			let carouselOptions = {
				prevNextButtons: false,
				pageDots: false,
				wrapAround: false,
				adaptiveHeight: false,
				cellAlign: "left",
      			contain: true,
				watchCSS: true
			}
			if (this.carouselElement) {
				this.carousel = new Flickity(this.carouselElement, carouselOptions);
				this.carousel.resize();
			}
		}

		_createClass(StyledWith, [ {
			key: '_onSelect',
			value: function _onSelect() {
				this.carousel.stopPlayer();
			}
		}, {
			key: 'onBlockSelect',
			value: function onBlockSelect(event) {
				this.carousel.select(event.target.getAttribute('data-slide-index'), true, !event.detail.load);
			}
		}, {
			key: 'onDeselect',
			value: function() {
				 
			}
		}]);

		window.addEventListener("load", (event) => {
			window.dispatchEvent(new Event('resize'));
			console.log("page is fully loaded");
		  });


		return StyledWith;
	}();
	/* harmony export (immutable) */

	__webpack_exports__["default"] = StyledWith;

	/***/
}

]

/******/);


// Retrieve reviews from yotpo api and render them in the parent element
function loadAndRenderReviews(productId, parentElement, handleParentHeight) {
	const REVIEWS_PER_PAGE = 3;
	let currentPage = 1;
	let totalPages = 1;
  
	function fetchAndRenderReviews(page) {
	  fetch(`/apps/reviews?productId=${productId}&page=${page}`)
		.then(res => res.json())
		.then(data => {
		  const reviews = data.response.reviews || [];
		  const pagination = data.response.pagination || {};
		  totalPages = Math.ceil((pagination.total || 0) / REVIEWS_PER_PAGE);
		  currentPage = pagination.page || 1;

		  console.log(reviews);
		  renderReviews(reviews);
		  renderPagination();
		  
		  if (typeof handleParentHeight === 'function') {
			requestAnimationFrame(() => {
				handleParentHeight(parentElement);
			});
		  }
		});
	}
  
	function renderReviews(reviews) {
	  const container = parentElement.querySelector('.custom-reviews-list');
	  let buttonHtml = `
	  <button
		type="button"
		class="Link Link--primary write-review-button"
		data-action="open-modal"
		aria-controls="modal-reviews"
	  >
		${reviews.length ? 'Write a review' : 'Be the first to write a review'}
	  </button>
	`;
	  if (!reviews.length) {
		container.innerHTML = `
		  <div class="review-block review-block-empty">
			<div class="review-title">WE'RE LOOKING FOR STARS</div>
			<div class="review-content">Saint and Sofia has over 19,000 Excellent Reviews on Trustpilot. This item is new and doesn't have any reviews yet.</div>
		  </div>
		${buttonHtml}
		`;
		return;
	  }

	  container.innerHTML = `
		${reviews.map(review => `
			<div class="review-block">
			<div class="review-title">${review.title ? review.title.toUpperCase() : ''}</div>
			<div class="review-header">
				<div class="review-stars">${'★'.repeat(review.score)}${'☆'.repeat(5 - review.score)}</div>
				<div class="review-author">${review.user.display_name}</div>
			</div>
			<div class="review-content">${review.content}</div>
			</div>
		`).join('')}
		${buttonHtml}
		`;
	}
  
	function renderPagination() {
	  const pagination = parentElement.querySelector('.custom-reviews-pagination');
	  pagination.innerHTML = '';
	  for (let i = 1; i <= totalPages; i++) {
		const btn = document.createElement('button');
		btn.textContent = i;
		btn.disabled = i === currentPage;
		btn.onclick = () => {
		  fetchAndRenderReviews(i);
		};
		pagination.appendChild(btn);
	  }
	}
  
	// Initial load
	fetchAndRenderReviews(1);
	initYotpoStarRating();
	handleYotpoReviewFormSubmit();
  }

  function initYotpoStarRating(formSelector = '#yotpo-review-form') {
	const form = document.querySelector(formSelector);
	if (!form) return;
  
	const stars = form.querySelectorAll('.YotpoReviewForm__star');
	const scoreInput = form.querySelector('#yotpo-review-score');
	if (!stars.length || !scoreInput) return;
  
	// Reset stars on form reset
	form.addEventListener('reset', function() {
	  scoreInput.value = '';
	  stars.forEach(s => s.innerHTML = '☆');
	});
  
	stars.forEach(star => {
	  star.addEventListener('click', function() {
		const value = this.getAttribute('data-value');
		scoreInput.value = value;
		stars.forEach(s => {
		  s.innerHTML = s.getAttribute('data-value') <= value ? '★' : '☆';
		});
	  });
	  star.addEventListener('keydown', function(e) {
		if (e.key === 'Enter' || e.key === ' ') {
		  this.click();
		}
	  });
	});
  
	// Optionally, set initial state if score is pre-filled
	if (scoreInput.value) {
	  stars.forEach(s => {
		s.innerHTML = s.getAttribute('data-value') <= scoreInput.value ? '★' : '☆';
	  });
	}
  }

  function handleYotpoReviewFormSubmit(formSelector = '#yotpo-review-form') {
	const form = document.querySelector(formSelector);
	if (!form) return;
  
	form.addEventListener('submit', function(e) {
	  e.preventDefault();
  
	  // Gather form data
	  const formData = new FormData(form);
	  const data = {};
	  formData.forEach((value, key) => {
		data[key] = value;
	  });
  
	  // Optionally: show loading state here
  
	  fetch('/apps/reviews', {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	  })
	  .then(async response => {
		if (!response.ok) {
		  const error = await response.text();
		  throw new Error(error || 'Failed to submit review');
		}
		// Optionally: show success message, close modal, reset form, etc.
		alert('Thank you for your review!');
		form.reset();
		setTimeout(() => {
		// Close the modal after successful submission
			const closeBtn = form.closest('.Modal').querySelector('.Modal__Close');
			if (closeBtn) closeBtn.click();
			// Optionally: reset stars visually
		}, 1000);
		if (typeof initYotpoStarRating === 'function') initYotpoStarRating(formSelector);
	  })
	  .catch(error => {
		// Optionally: show error message
		alert('There was an error submitting your review. Please try again.');
		console.error(error);
	  });
	});
  }